import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Upload: any;
};

export type Admin = {
  __typename?: 'Admin';
  adminRole: AdminRole;
  adminRoleId: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AdminConnection = {
  __typename?: 'AdminConnection';
  edges: Array<Admin>;
  pageInfo: PageInfo;
};

export type AdminNetworkDashboard = {
  __typename?: 'AdminNetworkDashboard';
  /** 활성화율 */
  activeUserRate?: Maybe<Scalars['Float']>;
  /** 평균 활동 기간 */
  averageActivePeriod: Scalars['Int'];
  /** 평균 추천 수 */
  averageReferralCount: Scalars['Float'];
  /** 평균 추천 네트워크 뎁스 */
  averageReferralDepth: Scalars['Int'];
  /** 전월 대비 활성 유저 수 비율 */
  previousMonthActiveUserCountRate: Scalars['Float'];
  /** 전월 대비 활성화 율 */
  previousMonthActiveUserRate?: Maybe<Scalars['Float']>;
  /** 전월 대비 평균 활동 기간 비율 */
  previousMonthAverageActivePeriodRate: Scalars['Float'];
  /** 전월 대비 평균 추천 수 비율 */
  previousMonthAverageReferralCountRate: Scalars['Float'];
  /** 전월 대비 평균 추천 네트워크 뎁스 비율 */
  previousMonthAverageReferralDepthRate: Scalars['Float'];
  /** 전월 대비 초대 수 비율 */
  previousMonthInviteCountRate: Scalars['Float'];
  /** 전월 대비 전체 사용자 수 비율 */
  previousMonthUserCountRate: Scalars['Float'];
  /** 활성 유저 수 */
  totalActiveUserCount: Scalars['Int'];
  /** 총 초대 수 */
  totalInviteCount: Scalars['Int'];
  /** 총 유저 수 */
  totalUserCount: Scalars['Int'];
};

export type AdminNetworkGraphDashboard = {
  __typename?: 'AdminNetworkGraphDashboard';
  month: Scalars['String'];
  totalInviteUserCount: Scalars['Int'];
  totalInvitedUserCount: Scalars['Int'];
  year: Scalars['String'];
};

export type AdminPayload = {
  __typename?: 'AdminPayload';
  accessToken: Scalars['String'];
  admin: Admin;
  refreshToken: Scalars['String'];
};

export type AdminRole = {
  __typename?: 'AdminRole';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** 어드민 검색 타입 */
export enum AdminSearchType {
  /** 이메일 */
  Email = 'EMAIL',
  /** 이름 */
  Name = 'NAME',
  /** 역할 */
  Role = 'ROLE',
  /** 상태 */
  Status = 'STATUS'
}

/** 어드민 정렬 타입 */
export enum AdminSortKey {
  /** 생성일 */
  CreatedAt = 'CREATED_AT',
  /** 이메일 */
  Email = 'EMAIL',
  /** 이름 */
  Name = 'NAME',
  /** 역할 */
  Role = 'ROLE',
  /** 상태 */
  Status = 'STATUS'
}

export type AgeGroup = {
  __typename?: 'AgeGroup';
  ageGroup: Scalars['String'];
  ageGroupRatio: Scalars['String'];
  isInReceiverGroup: Scalars['Boolean'];
};

/** 공지 */
export type Announcement = {
  __typename?: 'Announcement';
  /** 상태 */
  active: Scalars['Boolean'];
  /** 내용 */
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  /** 배너에 노출 */
  onBanner: Scalars['Boolean'];
  /** 요약 */
  summary?: Maybe<Scalars['String']>;
  thumbnailMedia?: Maybe<Media>;
  thumbnailMediaId?: Maybe<Scalars['String']>;
  /** 제목 */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type AnnouncementConnection = {
  __typename?: 'AnnouncementConnection';
  edges: Array<Announcement>;
  pageInfo: PageInfo;
};

export type AppVersion = {
  __typename?: 'AppVersion';
  currentVersion: Scalars['String'];
  isUpdate: Scalars['Boolean'];
  latestAppVersion: Scalars['String'];
};

export type Banner = {
  __typename?: 'Banner';
  clickCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** 설명 */
  description?: Maybe<Scalars['String']>;
  /** 종료일 */
  endAt: Scalars['DateTime'];
  id: Scalars['String'];
  linkType?: Maybe<CommonCode>;
  /** 공통 코드 링크 타입 ID */
  linkTypeId?: Maybe<Scalars['String']>;
  /** 링크 */
  linkUrl: Scalars['String'];
  /** 시작일 */
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<CommonCode>;
  statusId?: Maybe<Scalars['String']>;
  thumbnailMedia?: Maybe<Media>;
  thumbnailMediaId?: Maybe<Scalars['String']>;
  /** 배너명 */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type BannerConnection = {
  __typename?: 'BannerConnection';
  edges: Array<Banner>;
  pageInfo: PageInfo;
};

export type BannerCount = {
  __typename?: 'BannerCount';
  /** 배너 활성 개수 */
  activeCount: Scalars['Int'];
  /** 배너 비활성 개수 */
  inactiveCount: Scalars['Int'];
  /** 예약 배너 개수 */
  reservedCount: Scalars['Int'];
  /** 배너 총 개수 */
  totalCount: Scalars['Int'];
};

/** 배너 정렬 키 */
export enum BannerSortKey {
  /** 클릭 수 */
  ClickCount = 'CLICK_COUNT',
  /** 생성 일자 */
  CreatedAt = 'CREATED_AT',
  /** 설명 */
  Description = 'DESCRIPTION',
  /** 종료 일자 */
  EndAt = 'END_AT',
  /** 상태 */
  Status = 'STATUS',
  /** 제목 */
  Title = 'TITLE'
}

export type BokjiroWelfare = {
  __typename?: 'BokjiroWelfare';
  /** 복지서비스 지원 방법 */
  applicationMethod?: Maybe<Scalars['String']>;
  /** 복지서비스 연락처 */
  contactInformation: Scalars['String'];
  /** 복지서비스 설명 */
  description: Scalars['String'];
  /** 복지서비스 상세 페이지 링크 */
  detailPageUrl: Scalars['String'];
  /** 복지서비스 문의 전화번호 */
  inquiryPhone?: Maybe<Scalars['String']>;
  /** 복지서비스 데이터 삽입 여부 */
  isInserted: Scalars['Boolean'];
  /** 복지서비스 지원 주기 */
  supportCycle: Scalars['String'];
  /** 복지서비스 지원 유형 */
  supportType: Scalars['String'];
  /** 복지서비스 제목 */
  title: Scalars['String'];
  /** 복지서비스 카테고리 */
  welfareCategories?: Maybe<Array<CommonCode>>;
  /** 복지서비스 카테고리 아이디 */
  welfareCategoryIds?: Maybe<Array<Scalars['String']>>;
  /** 복지서비스 가족 유형 아이디 */
  welfareFamilyTypeIds?: Maybe<Array<Scalars['String']>>;
  /** 복지서비스 가족 유형 */
  welfareFamilyTypes?: Maybe<Array<CommonCode>>;
  /** 복지서비스 생애주기 아이디 */
  welfareLifeCycleIds?: Maybe<Array<Scalars['String']>>;
  /** 복지서비스 생애주기 */
  welfareLifeCycles?: Maybe<Array<CommonCode>>;
  /** 복지서비스 고유 아이디 */
  welfareServiceId: Scalars['String'];
  /** 복지서비스 유형 */
  welfareType?: Maybe<CommonCode>;
  /** 복지서비스 유형 아이디 */
  welfareTypeId: Scalars['String'];
};

export type BokjiroWelfareConnection = {
  __typename?: 'BokjiroWelfareConnection';
  edges: Array<BokjiroWelfare>;
  pageInfo: PageInfo;
};

/** 장기요양등급 */
export type CareGrade = {
  __typename?: 'CareGrade';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** 설명 */
  description: Scalars['String'];
  /** 등급 */
  grade: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CareGradeConnection = {
  __typename?: 'CareGradeConnection';
  edges: Array<CareGrade>;
  pageInfo: PageInfo;
};

export type CareGradeGroup = {
  __typename?: 'CareGradeGroup';
  grade: Scalars['String'];
  gradeGroupCount: Scalars['Int'];
  gradeGroupRatio: Scalars['String'];
  isInReceiverGroup: Scalars['Boolean'];
};

export type CareService = {
  __typename?: 'CareService';
  problemNm: Scalars['String'];
  problemSolutionNm: Scalars['String'];
  serviceCateNm: Scalars['String'];
};

/** 보호사 */
export type Caregiver = {
  __typename?: 'Caregiver';
  avatar?: Maybe<Media>;
  avatarId?: Maybe<Scalars['String']>;
  /** 카페24 회원 아이디 */
  cafe24MemberId?: Maybe<Scalars['String']>;
  certificateMedia?: Maybe<Media>;
  certificateMediaId?: Maybe<Scalars['String']>;
  /** 요양자격증 번호 */
  certificateNumber?: Maybe<Scalars['String']>;
  childUserInvitedUserCount?: Maybe<Scalars['Int']>;
  cities?: Maybe<Array<City>>;
  communityCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  dailyReportCount?: Maybe<Scalars['Int']>;
  /** 생년월일 */
  dateOfBirth?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  followerCount?: Maybe<Scalars['Int']>;
  followingCount?: Maybe<Scalars['Int']>;
  /** 성별 */
  gender: Gender;
  id: Scalars['ID'];
  /** 초대코드 */
  invitationCode?: Maybe<Scalars['String']>;
  invitedCaregivers?: Maybe<Array<Caregiver>>;
  invitedGuardians?: Maybe<Array<Guardian>>;
  invitedUserCount?: Maybe<Scalars['Int']>;
  isFollowing?: Maybe<Scalars['Boolean']>;
  lastSignInAt?: Maybe<Scalars['DateTime']>;
  /** 이름 */
  name: Scalars['String'];
  /** 전화번호 */
  phone: Scalars['String'];
  /** 포인트 */
  point: Scalars['Int'];
  receivers?: Maybe<Array<Receiver>>;
  replyCount?: Maybe<Scalars['Int']>;
  role?: Maybe<Role>;
  roleId: Scalars['String'];
  /** 이번달 추천 보상 포인트 */
  thisMonthInvitationRewardPoint?: Maybe<Scalars['Int']>;
  /** 보호사 이번달 수익 포인트 */
  thisMonthProfitPoint: Scalars['Int'];
  todayRewardPoint?: Maybe<Scalars['Int']>;
  totalRewardPoint?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  /** 아이디 */
  username?: Maybe<Scalars['String']>;
};

export type CaregiverActivities = {
  __typename?: 'CaregiverActivities';
  month: Scalars['String'];
  totalMonthHours: Scalars['Float'];
};

export type CaregiverActivitiesTotal = {
  __typename?: 'CaregiverActivitiesTotal';
  activities: Array<CaregiverActivities>;
  totalHours: Scalars['Float'];
};

/** 요양보호사 커뮤니티 */
export type CaregiverCommunity = {
  __typename?: 'CaregiverCommunity';
  /** 작성자 */
  author: Caregiver;
  /** 작성자 Id */
  authorId: Scalars['String'];
  /** 내용 */
  body: Scalars['String'];
  /** 카테고리 */
  category?: Maybe<CommonCode>;
  /** 카테고리 Id */
  categoryId?: Maybe<Scalars['String']>;
  /** 커뮤니티 타입 */
  communityType: CommonCode;
  /** 커뮤니티 타입 Id */
  communityTypeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isLiked?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  media?: Maybe<Array<Media>>;
  replyCount: Scalars['Float'];
  /** 상태 */
  status: CommonCode;
  /** 상태 Id */
  statusId: Scalars['String'];
  totalScore?: Maybe<Scalars['Int']>;
  /** 타입 : GENERAL | SECRET */
  type?: Maybe<CaregiverCommunityType>;
  updatedAt: Scalars['DateTime'];
  viewCount: Scalars['Int'];
};

export type CaregiverCommunityAndReplyCount = {
  __typename?: 'CaregiverCommunityAndReplyCount';
  caregiver: Caregiver;
  communityCount: Scalars['Int'];
  communityReplyCount: Scalars['Int'];
  infoReplyCount: Scalars['Int'];
};

export type CaregiverCommunityConnection = {
  __typename?: 'CaregiverCommunityConnection';
  edges: Array<CaregiverCommunity>;
  pageInfo: PageInfo;
};

export type CaregiverCommunityInput = {
  /** 작성자 id */
  authorId?: InputMaybe<Scalars['ID']>;
  /** 본문 내용 */
  body: Scalars['String'];
  /** 커뮤니티 카테고리 id */
  categoryId?: InputMaybe<Scalars['String']>;
  /** 커뮤니티 타입 id */
  communityTypeId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** 미디어 입력 */
  mediaInputs?: InputMaybe<Array<MediaInput>>;
};

export type CaregiverCommunityLike = {
  __typename?: 'CaregiverCommunityLike';
  caregiverId: Scalars['String'];
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
};

/** 커뮤니티 댓글 */
export type CaregiverCommunityReply = {
  __typename?: 'CaregiverCommunityReply';
  /** 작성자 정보 */
  author: Caregiver;
  authorId: Scalars['String'];
  /** 내용 */
  body?: Maybe<Scalars['String']>;
  community: CaregiverCommunity;
  communityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isLiked?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  replyCommentCount: Scalars['Int'];
  replyComments: Array<CaregiverCommunityReplyComment>;
  updatedAt: Scalars['DateTime'];
};

export type CaregiverCommunityReplyComment = {
  __typename?: 'CaregiverCommunityReplyComment';
  author: Caregiver;
  body: Scalars['String'];
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isLiked?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  replyId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CaregiverCommunityReplyCommentConnection = {
  __typename?: 'CaregiverCommunityReplyCommentConnection';
  edges: Array<CaregiverCommunityReplyComment>;
  pageInfo: PageInfo;
};

export type CaregiverCommunityReplyCommentLike = {
  __typename?: 'CaregiverCommunityReplyCommentLike';
  caregiverId: Scalars['String'];
  communityReplyCommentId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
};

export type CaregiverCommunityReplyConnection = {
  __typename?: 'CaregiverCommunityReplyConnection';
  edges: Array<CaregiverCommunityReply>;
  pageInfo: PageInfo;
};

export type CaregiverCommunityReplyInput = {
  /** admin api 용 */
  authorId?: InputMaybe<Scalars['ID']>;
  /** 댓글 내용 */
  body?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  /** 댓글 id */
  id?: InputMaybe<Scalars['ID']>;
};

export type CaregiverCommunityReplyLike = {
  __typename?: 'CaregiverCommunityReplyLike';
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  replyId: Scalars['String'];
};

/** 게시물 타입 */
export enum CaregiverCommunityType {
  /** 일반 게시물 */
  General = 'GENERAL',
  /** 비밀 게시물 */
  Secret = 'SECRET'
}

export type CaregiverConnection = {
  __typename?: 'CaregiverConnection';
  edges: Array<Caregiver>;
  pageInfo: PageInfo;
};

/** 정보글 */
export type CaregiverInfo = {
  __typename?: 'CaregiverInfo';
  /** 내용 */
  body: Scalars['String'];
  /** 정보글 지역 리스트 */
  cities: Array<City>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** 정보글 이미지 */
  media: Array<Media>;
  /** 정보글 댓글 수 */
  replyCount: Scalars['Int'];
  /** 요약 */
  summary: Scalars['String'];
  /** 제목 */
  title: Scalars['String'];
  /** 타입 */
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type CaregiverInfoConnection = {
  __typename?: 'CaregiverInfoConnection';
  edges: Array<CaregiverInfo>;
  pageInfo: PageInfo;
};

export type CaregiverInfoInput = {
  body: Scalars['String'];
  cityIds: Array<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  mediaInputs?: InputMaybe<Array<MediaInput>>;
  summary: Scalars['String'];
  title: Scalars['String'];
};

/** 정보글 댓글 */
export type CaregiverInfoReply = {
  __typename?: 'CaregiverInfoReply';
  /** 작성자 */
  author: Caregiver;
  authorId: Scalars['String'];
  /** 댓글 내용 */
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** 정보글 */
  info: CaregiverInfo;
  infoId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CaregiverInfoReplyConnection = {
  __typename?: 'CaregiverInfoReplyConnection';
  edges: Array<CaregiverInfoReply>;
  pageInfo: PageInfo;
};

export type CaregiverInfoReplyInput = {
  /** 작성자 id / admin용 */
  authorId?: InputMaybe<Scalars['String']>;
  /** 댓글 내용 */
  body: Scalars['String'];
  /** 댓글 id */
  id?: InputMaybe<Scalars['String']>;
  /** 정보글 id */
  infoId: Scalars['ID'];
};

export type CaregiverInput = {
  /** 자격증 이미지 */
  certificateMediaInput?: InputMaybe<MediaInput>;
  /** 자격증 번호 */
  certificateNumber?: InputMaybe<Scalars['String']>;
};

export type CaregiverManual = {
  __typename?: 'CaregiverManual';
  actDetail: Scalars['String'];
  actNm: Scalars['String'];
  catNm: Scalars['String'];
};

export type CaregiverReceiver = {
  __typename?: 'CaregiverReceiver';
  /** 활성화 상태 */
  active: Scalars['Boolean'];
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['String'];
  chat?: Maybe<Chat>;
  createdAt: Scalars['DateTime'];
  hasUnreadMessage?: Maybe<Scalars['Boolean']>;
  isWorkingToday: Scalars['Boolean'];
  receiver: Receiver;
  receiverId: Scalars['String'];
  /** 상태 */
  status: RelationStatus;
  updatedAt: Scalars['DateTime'];
};

export type CaregiverSupportService = {
  __typename?: 'CaregiverSupportService';
  supportServiceDetailNm: Scalars['String'];
  supportServiceItemNm: Scalars['String'];
  supportServiceTopNm: Scalars['String'];
};

export type CarestoreMileage = {
  __typename?: 'CarestoreMileage';
  memberId: Scalars['String'];
  mileage: Scalars['String'];
};

export type CategoryComments = {
  __typename?: 'CategoryComments';
  categoryId: Scalars['String'];
  comment: Scalars['String'];
};

export type CategoryMeasure = {
  categoryId?: InputMaybe<Scalars['String']>;
  measure?: InputMaybe<Scalars['Int']>;
};

/** 채팅방 */
export type Chat = {
  __typename?: 'Chat';
  chatId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  hasUnreadMessage: Scalars['Boolean'];
  id: Scalars['ID'];
  /** 마지막 메세지 보낸 시간 */
  lastMessageAt: Scalars['String'];
  messageCount: Scalars['Float'];
  receiver: Receiver;
  receiverId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  users?: Maybe<Array<ChatUser>>;
};

export type ChatConnection = {
  __typename?: 'ChatConnection';
  edges: Array<Chat>;
  pageInfo: PageInfo;
};

/** 채팅방의 유저 */
export type ChatUser = {
  __typename?: 'ChatUser';
  caregiver?: Maybe<Caregiver>;
  caregiverId?: Maybe<Scalars['String']>;
  chat: Chat;
  chatId: Scalars['ID'];
  guardian?: Maybe<Guardian>;
  guardianId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** 채팅방 입장 시간 */
  joinAt: Scalars['String'];
  /** 마지막으로 채팅을 확인한 시간 */
  lastSeenAt: Scalars['String'];
};

export type CheckDailyReport = {
  __typename?: 'CheckDailyReport';
  /** 일일 리포트 */
  dailyReport?: Maybe<Scalars['String']>;
  /** 일일 리포트 pk */
  id: Scalars['String'];
};

/** 도시 */
export type City = {
  __typename?: 'City';
  cityCode?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** 시군구 이름 */
  name: Scalars['String'];
  state: State;
};

export type Comment = {
  __typename?: 'Comment';
  /** 코멘트 */
  comment: Scalars['String'];
};

export type CommonCode = {
  __typename?: 'CommonCode';
  code: Scalars['String'];
  commonCodeGroupId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: CommonCodeStatus;
  updatedAt: Scalars['DateTime'];
  value?: Maybe<Scalars['Int']>;
};

export type CommonCodeConnection = {
  __typename?: 'CommonCodeConnection';
  edges: Array<CommonCode>;
  pageInfo: PageInfo;
};

/** 공통 코드 그룹 */
export type CommonCodeGroup = {
  __typename?: 'CommonCodeGroup';
  /** 어드민 공통 코드 그룹 공통 코드 운영중 리스트 */
  activeCommonCodes: Array<CommonCode>;
  /** 어드민 공통 코드 그룹 공통 코드 리스트 */
  commonCodes: Array<CommonCode>;
  createdAt: Scalars['DateTime'];
  groupCode: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  status: CommonCodeGroupStatus;
  updatedAt: Scalars['DateTime'];
};

export type CommonCodeGroupConnection = {
  __typename?: 'CommonCodeGroupConnection';
  edges: Array<CommonCodeGroup>;
  pageInfo: PageInfo;
};

/** 그룹코드 검색 타입 */
export enum CommonCodeGroupSearchType {
  /** 그룹코드 검색 */
  GroupCode = 'GROUP_CODE',
  /** 그룹코드명 검색 */
  Name = 'NAME'
}

/** 그룹코드 정렬 키 */
export enum CommonCodeGroupSortKey {
  /** 생성일 */
  CreatedAt = 'CREATED_AT',
  /** 그룹코드 */
  GroupCode = 'GROUP_CODE',
  /** 그룹코드명 */
  Name = 'NAME',
  /** 상태 */
  Status = 'STATUS'
}

/** 공통 코드 그룹 상태 */
export enum CommonCodeGroupStatus {
  /** 운영중 */
  Active = 'ACTIVE',
  /** 비활성 */
  Inactive = 'INACTIVE',
  /** 비운영 */
  Pending = 'PENDING'
}

/** 공통 코드 그룹 타입 */
export enum CommonCodeGroupType {
  /** 배너 링크 타입 */
  BannerLinkType = 'BANNER_LINK_TYPE',
  /** 커뮤니티 카테고리 */
  CommunityCategory = 'COMMUNITY_CATEGORY',
  /** 커뮤니티 타입 */
  CommunityType = 'COMMUNITY_TYPE',
  /** 알림 대상 타입 */
  NotificationTargetType = 'NOTIFICATION_TARGET_TYPE',
  /** 알림 타입 */
  NotificationType = 'NOTIFICATION_TYPE',
  /** 포인트 거래 유형 */
  PointTransactionType = 'POINT_TRANSACTION_TYPE',
  /** 수급자 주거 방식 */
  ReceiverLivingStyle = 'RECEIVER_LIVING_STYLE',
  /** 신고 이유 */
  ReportReason = 'REPORT_REASON',
  /** 신고 대상 타입 */
  ReportTargetType = 'REPORT_TARGET_TYPE',
  /** 리워드 포인트 */
  RewardPoint = 'REWARD_POINT',
  /** 상태 */
  Status = 'STATUS',
  /** 비디오 컨텐츠 카테고리 */
  VideoContentCategory = 'VIDEO_CONTENT_CATEGORY',
  /** 복지 컨텐츠 카테고리 */
  WelfareContentCategory = 'WELFARE_CONTENT_CATEGORY',
  /** 복지 컨텐츠 가구 타입 */
  WelfareContentFamilyType = 'WELFARE_CONTENT_FAMILY_TYPE',
  /** 복지 컨텐츠 생애주기 */
  WelfareContentLifeCycle = 'WELFARE_CONTENT_LIFE_CYCLE',
  /** 복지 컨텐츠 유형 */
  WelfareContentType = 'WELFARE_CONTENT_TYPE'
}

/** 공통 코드 검색 타입 */
export enum CommonCodeSearchType {
  /** 코드 */
  Code = 'CODE',
  /** 이름 */
  Name = 'NAME'
}

/** 공통 코드 정렬 키 */
export enum CommonCodeSortKey {
  /** 코드 */
  Code = 'CODE',
  /** 생성일 */
  CreatedAt = 'CREATED_AT',
  /** 이름 */
  Name = 'NAME',
  /** 상태 */
  Status = 'STATUS'
}

/** 공통 코드 상태 */
export enum CommonCodeStatus {
  /** 운영중 */
  Active = 'ACTIVE',
  /** 비활성 */
  Inactive = 'INACTIVE',
  /** 비운영 */
  Pending = 'PENDING'
}

export type CommunityCount = {
  __typename?: 'CommunityCount';
  general: Scalars['Int'];
  secret: Scalars['Int'];
};

export type CreateAdminUserAsAdminInput = {
  caregiverId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  guardianId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type CreateAdminUserDto = {
  adminRoleId: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  status: Scalars['String'];
};

export type CreateBannerAsAdminDto = {
  description: Scalars['String'];
  endAt: Scalars['String'];
  linkTypeId: Scalars['String'];
  linkUrl: Scalars['String'];
  startAt: Scalars['String'];
  statusId: Scalars['String'];
  thumbnailMediaInput?: InputMaybe<MediaInput>;
  title: Scalars['String'];
};

export type CreateCommonCodeDto = {
  /** 공통 코드 코드 */
  code: Scalars['String'];
  /** 공통 코드 그룹 ID */
  commonCodeGroupId: Scalars['String'];
  /** 공통 코드 이름 */
  name: Scalars['String'];
  /** 공통 코드 상태 */
  status: Scalars['String'];
};

export type CreateCommonCodeGroupDto = {
  groupCode: Scalars['String'];
  name: Scalars['String'];
  status: CommonCodeGroupStatus;
};

export type CreateReportReasonAsAdminDto = {
  active: Scalars['Boolean'];
  reason?: InputMaybe<Scalars['String']>;
  type: ReportReasonType;
};

export type DailyReceiverRecord = {
  __typename?: 'DailyReceiverRecord';
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  recordHistoryId: Scalars['String'];
};

export type DailyReceiverRecordDetail = {
  __typename?: 'DailyReceiverRecordDetail';
  answer?: Maybe<Scalars['String']>;
  answerComment?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  recordHistoryId?: Maybe<Scalars['String']>;
};

/** 일일리포트 */
export type DailyReport = {
  __typename?: 'DailyReport';
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 일일 리포트 내용 */
  dailyReport?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  media?: Maybe<Media>;
  receiver: Receiver;
  receiverId: Scalars['String'];
  recordHistories?: Maybe<Array<RecordHistory>>;
  updatedAt: Scalars['DateTime'];
};

export type DailyReportConnection = {
  __typename?: 'DailyReportConnection';
  edges: Array<DailyReport>;
  pageInfo: PageInfo;
};

export type DailyReportConnectionPhotoAlbum = {
  __typename?: 'DailyReportConnectionPhotoAlbum';
  edges: Array<DailyReportPhotoAlbum>;
  pageInfo: PageInfo;
};

export type DailyReportGroupByWeek = {
  __typename?: 'DailyReportGroupByWeek';
  dailyReports: Array<DailyReport>;
  /** 주간 리포트 여부 */
  isHasWeeklyReport: Scalars['Boolean'];
  week: Scalars['String'];
};

export type DailyReportPhotoAlbum = {
  __typename?: 'DailyReportPhotoAlbum';
  createdAt: Scalars['String'];
  dailyReports: Array<DailyReport>;
};

export type DailyReportSearchQuery = {
  /** 보호사 / 수급자 이름 */
  name?: InputMaybe<Scalars['String']>;
  /** 검색 타입 caregiver/guardian */
  searchType?: InputMaybe<SearchType>;
};

/** 질병 */
export type Disease = {
  __typename?: 'Disease';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  disease: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type DiseaseConnection = {
  __typename?: 'DiseaseConnection';
  edges: Array<Disease>;
  pageInfo: PageInfo;
};

export type DiseaseGroup = {
  __typename?: 'DiseaseGroup';
  disease: Scalars['String'];
  diseaseGroupCount: Scalars['Int'];
  isInReceiverGroup: Scalars['Int'];
};

export type ExampleQuestion = {
  __typename?: 'ExampleQuestion';
  active: Scalars['Boolean'];
  answers: Array<ExampleQuestionAnswer>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  question: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ExampleQuestionAnswer = {
  __typename?: 'ExampleQuestionAnswer';
  active: Scalars['Boolean'];
  answer: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  questionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ExampleQuestionAnswerInput = {
  active: Scalars['Boolean'];
  answer: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  questionId: Scalars['String'];
};

export type ExampleQuestionConnection = {
  __typename?: 'ExampleQuestionConnection';
  edges: Array<ExampleQuestion>;
  pageInfo: PageInfo;
};

export type ExampleQuestionInput = {
  active: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
  question: Scalars['String'];
};

export type ExchangeStatus = {
  __typename?: 'ExchangeStatus';
  amount: Scalars['Int'];
  memberId: Scalars['String'];
  message: Scalars['String'];
};

export type Follow = {
  __typename?: 'Follow';
  createdAt: Scalars['DateTime'];
  follower: Caregiver;
  followerId: Scalars['String'];
  following: Caregiver;
  followingId: Scalars['String'];
  id: Scalars['String'];
};

export type FollowConnection = {
  __typename?: 'FollowConnection';
  edges: Array<Follow>;
  pageInfo: PageInfo;
};

/** 성별 */
export enum Gender {
  /** 여자 */
  Female = 'FEMALE',
  /** 남자 */
  Male = 'MALE'
}

export type GetPickSmallCategories = {
  __typename?: 'GetPickSmallCategories';
  id: Scalars['ID'];
  smallCategory: Scalars['String'];
};

/** 보호자 */
export type Guardian = {
  __typename?: 'Guardian';
  avatar?: Maybe<Media>;
  avatarId?: Maybe<Scalars['String']>;
  /** 카페24 회원 아이디 */
  cafe24MemberId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** 생년월일 */
  dateOfBirth?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** 이메일 */
  email?: Maybe<Scalars['String']>;
  /** 성별 */
  gender: Gender;
  id: Scalars['String'];
  /** 초대코드 */
  invitationCode?: Maybe<Scalars['String']>;
  invitedCaregivers?: Maybe<Array<Caregiver>>;
  invitedGuardians?: Maybe<Array<Guardian>>;
  invitedUserCount?: Maybe<Scalars['Int']>;
  lastSignInAt?: Maybe<Scalars['DateTime']>;
  /** 이름 */
  name: Scalars['String'];
  /** 전화번호 */
  phone: Scalars['String'];
  /** 포인트 */
  point: Scalars['Int'];
  receivers?: Maybe<Array<Receiver>>;
  role?: Maybe<Role>;
  roleId: Scalars['String'];
  totalRewardPoint?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  /** 아이디 */
  username?: Maybe<Scalars['String']>;
};

export type GuardianConnection = {
  __typename?: 'GuardianConnection';
  edges: Array<Guardian>;
  pageInfo: PageInfo;
};

export type GuardianProfileInputDto = {
  /** 프로필 사진 */
  avatarInput?: InputMaybe<MediaInput>;
  /** 생년월일 */
  dateOfBirth?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 성별 */
  gender: Gender;
  /** 초대코드 */
  invitationCode?: InputMaybe<Scalars['String']>;
  /** 이름 */
  name: Scalars['String'];
  /** 핸드폰 번호 */
  phone?: InputMaybe<Scalars['String']>;
  /** 유저 이름 */
  username?: InputMaybe<Scalars['String']>;
};

export type GuardianReceiver = {
  __typename?: 'GuardianReceiver';
  /** 활성화 상태 */
  active: Scalars['Boolean'];
  chat?: Maybe<Chat>;
  createdAt: Scalars['DateTime'];
  guardian: Guardian;
  guardianId: Scalars['String'];
  hasUnreadMessage?: Maybe<Scalars['Boolean']>;
  receiver: Receiver;
  receiverId: Scalars['String'];
  relation?: Maybe<Relation>;
  relationId: Scalars['String'];
  /** 상태 */
  status: RelationStatus;
  updatedAt: Scalars['DateTime'];
};

export type IncentiveDashboard = {
  __typename?: 'IncentiveDashboard';
  /** 누적 지급액 */
  accumulatedAmount: Scalars['Int'];
  /** 평균 지급액 */
  averageReceivedAmount: Scalars['Float'];
  /** 포인트 사용자 수 */
  pointUsedCount: Scalars['Int'];
  /** 전월대비 누적 지급액 차이 */
  previousMonthAccumulatedAmountDifference: Scalars['Int'];
  /** 전월대비 평균 지급액 증감 */
  previousMonthAverageReceivedAmountRate: Scalars['Float'];
  /** 전월대비 포인트 사용자 수 증감 */
  previousMonthPointUsedCountRate: Scalars['Float'];
  /** 전월대비 이번달 총 지급액 증감 */
  previousMonthThisMonthTotalAmountRate: Scalars['Float'];
  /** 전월대비 이번달 지급 대상자 수 증감 */
  previousMonthThisMonthTotalReceivedUserCountRate: Scalars['Float'];
  /** 이번달 총 지급액 */
  thisMonthTotalAmount: Scalars['Int'];
  /** 이번달 지급 대상자 수 */
  thisMonthTotalReceivedUserCount: Scalars['Int'];
};

export type IncentiveLineGraph = {
  __typename?: 'IncentiveLineGraph';
  amount: Scalars['Int'];
  pointTransactionType: CommonCode;
  pointTransactionTypeId: Scalars['String'];
};

export type InhomeService = {
  __typename?: 'InhomeService';
  areaNm: Scalars['String'];
  careProblemNm: Scalars['String'];
  carePurposeNm: Scalars['String'];
  serviceNm: Scalars['String'];
};

export type IntroQuestion = {
  __typename?: 'IntroQuestion';
  data: NewsData;
  /** 질문 내용 */
  question: Scalars['String'];
};

export type Invitation = {
  __typename?: 'Invitation';
  caregiver?: Maybe<Caregiver>;
  caregiverId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  guardian?: Maybe<Guardian>;
  guardianId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  invitedCaregiver?: Maybe<Caregiver>;
  invitedCaregiverId?: Maybe<Scalars['String']>;
  invitedCaregivers?: Maybe<Array<Caregiver>>;
  invitedGuardian?: Maybe<Guardian>;
  invitedGuardianId?: Maybe<Scalars['String']>;
  invitedGuardians?: Maybe<Array<Guardian>>;
  totalNetworkRewardPoint?: Maybe<Scalars['Int']>;
  /** 네트워크 총 유저 수 */
  totalNetworkUserCount?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type InvitationConnection = {
  __typename?: 'InvitationConnection';
  edges: Array<Invitation>;
  pageInfo: PageInfo;
};

export type InvitedCaregiverGuardian = {
  __typename?: 'InvitedCaregiverGuardian';
  invitedCaregiver?: Maybe<Caregiver>;
};

export type Keyword = {
  __typename?: 'Keyword';
  category?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  keyword?: Maybe<Scalars['String']>;
};

/** 관리 */
export type Management = {
  __typename?: 'Management';
  /** 주소 */
  address: Scalars['String'];
  /** 대표자 이름 */
  ceoName: Scalars['String'];
  /** 회사 이름 */
  companyName: Scalars['String'];
  /** 저작권 */
  copyright: Scalars['String'];
  /** 이메일 */
  email: Scalars['String'];
  /** 에스크로등록번호 */
  escroRegistration: Scalars['String'];
  id: Scalars['Int'];
  /** 초대 포인트 */
  invitationPoint: Scalars['Int'];
  /** 카카오 주소 */
  kakaoAddress: Scalars['String'];
  /** 최소 팁 */
  minimumTip: Scalars['String'];
  /** 결제 정보 */
  paymentInformation?: Maybe<Scalars['String']>;
  /** 결제 경고 */
  paymentWarning?: Maybe<Scalars['String']>;
  /** 전화번호 */
  phone: Scalars['String'];
  /** 사업자등록번호 */
  registrationNumber: Scalars['String'];
  /** 매장 주소 */
  shopAddress: Scalars['String'];
};

export type Measure = {
  __typename?: 'Measure';
  category_id: Scalars['String'];
  large_category: Scalars['String'];
  measure: Scalars['Int'];
  medium_category: Scalars['String'];
  small_category: Scalars['String'];
};

/** 미디어 */
export type Media = {
  __typename?: 'Media';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** 파일명 */
  name: Scalars['String'];
  /** 파일 사이즈 */
  size: Scalars['Int'];
  thumbnailUri?: Maybe<Scalars['String']>;
  /** 타입 */
  type: Scalars['String'];
  uri: Scalars['String'];
};

export type MediaInput = {
  /** file */
  file: Scalars['Upload'];
  /** thumbnailFile */
  thumbnailFile?: InputMaybe<Scalars['Upload']>;
};

/** 메세지 */
export type Message = {
  __typename?: 'Message';
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['String'];
  chat: Chat;
  chatId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  guardian?: Maybe<Guardian>;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  media?: Maybe<Media>;
  mediaId: Scalars['String'];
  serviceRequest?: Maybe<ServiceRequest>;
  serviceRequestId?: Maybe<Scalars['String']>;
  /** 메세지 */
  text?: Maybe<Scalars['String']>;
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges?: Maybe<Array<MessageUnion>>;
  pageInfo: PageInfo;
};

export type MessageUnion = SystemMessage | UserMessage;

export type MonthlyMeasure = {
  __typename?: 'MonthlyMeasure';
  category_id: Scalars['String'];
  large_category: Scalars['String'];
  medium_category: Scalars['String'];
  small_category: Scalars['String'];
  weekly_measure: Array<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** 수급자 보호사 인증 코드 확인 */
  confirmCaregiverAsReceiver: Scalars['Boolean'];
  /** 수급자 보호자 인증 코드 확인 */
  confirmGuardianAsReceiver: Scalars['Boolean'];
  /** 어드민 유저 생성 */
  createAdminUser: Admin;
  /** 테스트 admin token 발급 */
  createAdminUserAsAdmin: Scalars['String'];
  /** 배너 생성 */
  createBannerAsAdmin: Banner;
  /** 어드민 보호사 생성 */
  createCaregiverAsAdmin: Caregiver;
  /** 게시물 좋아요 생성 */
  createCaregiverCommunityLike: CaregiverCommunityLike;
  createCaregiverCommunityReplyComment: CaregiverCommunityReplyComment;
  createCaregiverCommunityReplyCommentLike: CaregiverCommunityReplyCommentLike;
  /** 댓글 좋아요 생성 */
  createCaregiverCommunityReplyLike: CaregiverCommunityReplyLike;
  /** 보호사 회원가입 */
  createCaregiverProfile: Caregiver;
  /** 어드민 공통 코드 생성 */
  createCommonCodeAsAdmin: CommonCode;
  /** 어드민 공통 코드 그룹 생성 */
  createCommonCodeGroupAsAdmin: CommonCodeGroup;
  /** 일일 리포트 생성 */
  createDailyReport: DailyReport;
  /** 일일 리포트 코멘트 생성 */
  createDailyReportByComment: DailyReport;
  createFollow: Follow;
  /** 어드민 보호자 생성 */
  createGuardianAsAdmin: Guardian;
  /** 보호자 회원가입 */
  createGuardianProfile: Guardian;
  /** 수급자 생성 */
  createReceiver: Receiver;
  /** 돌봄기록 답변 코멘트 생성하기 */
  createRecordQuestionComment: RecordQuestionAnswerComment;
  createReport: Report;
  /** 어드민 신고 사유 생성 api */
  createReportReasonAsAdmin: ReportReason;
  /** 티켓 생성 */
  createTicket: Ticket;
  /** 비디오 콘텐츠 등록 */
  createVideoContentAsAdmin: VideoContent;
  createVideoContentLike: VideoContentLike;
  createVideoContentReply: VideoContentReply;
  createVideoContentReplyComment: VideoContentReplyComment;
  createVideoContentReplyCommentLike: VideoContentReplyCommentLike;
  createVideoContentReplyLike: VideoContentReplyLike;
  /** 복지서비스 등록 */
  createWelfareContentAsAdmin: Scalars['Boolean'];
  /** 근무 시작 */
  createWorkHour: WorkHour;
  /** 어드민 유저 삭제 */
  deleteAdminUser: Admin;
  /** 배너 삭제 */
  deleteBannerAsAdmin: Banner;
  /** 보호사의 도시 삭제 탈퇴 */
  deleteCaregiverCity: Caregiver;
  /** 게시물 삭제 */
  deleteCaregiverCommunity: CaregiverCommunity;
  /** 게시물 좋아요 삭제 */
  deleteCaregiverCommunityLike: Scalars['Boolean'];
  /** 게시물 사진 삭제 */
  deleteCaregiverCommunityMedia: CaregiverCommunity;
  /** 댓글 삭제 */
  deleteCaregiverCommunityReply: CaregiverCommunityReply;
  deleteCaregiverCommunityReplyComment: Scalars['Boolean'];
  deleteCaregiverCommunityReplyCommentLike: Scalars['Boolean'];
  /** 댓글 좋아요 삭제 */
  deleteCaregiverCommunityReplyLike: Scalars['Boolean'];
  /** 어드민 보호사 정보글 삭제 */
  deleteCaregiverInfoAsAdmin: CaregiverInfo;
  /** 정보글 이미지 삭제 */
  deleteCaregiverInfoMedia: CaregiverInfo;
  /** 댓글 삭제 */
  deleteCaregiverInfoReply: CaregiverInfoReply;
  /** 어드민 공통 코드 삭제 */
  deleteCommonCodeAsAdmin: CommonCode;
  /** 어드민 공통 코드 그룹 삭제 */
  deleteCommonCodeGroupAsAdmin: CommonCodeGroup;
  /** 일일 리포트 삭제 */
  deleteDailyReport: Scalars['Boolean'];
  /** 어드민 돌봄리포트 삭제  */
  deleteDailyReportAsAdmin: Scalars['Boolean'];
  deleteFollow: Scalars['Boolean'];
  deleteReceiverRecord: ReceiverRecord;
  deleteReceiverRecordMedia: ReceiverRecordMedia;
  /** 비디오 콘텐츠 삭제 */
  deleteVideoContentAsAdmin: VideoContent;
  deleteVideoContentLike: Scalars['Boolean'];
  deleteVideoContentReply: Scalars['Boolean'];
  deleteVideoContentReplyComment: Scalars['Boolean'];
  deleteVideoContentReplyCommentLike: Scalars['Boolean'];
  deleteVideoContentReplyLike: Scalars['Boolean'];
  /** 복지서비스 삭제 */
  deleteWelfareContentAsAdmin: Scalars['Boolean'];
  exchangePointsAsCaregiver: ExchangeStatus;
  exchangePointsAsGuardian: ExchangeStatus;
  /** 근무 종료 */
  finishWorkHour: WorkHour;
  /** 퀴즈용) 어드민 포인트 지급 */
  givePointAsAdminForQuiz: PointTransaction;
  /** 보호사 채팅방 입장 */
  joinChatAsCaregiver: Chat;
  /** 보호자 채팅방 입장 */
  joinChatAsGuardian: Chat;
  /** 어드민 유저 이관 */
  migrateAdminUser: Scalars['Boolean'];
  /** 알림 읽음 처리 */
  readNotification: Scalars['Boolean'];
  /** 보호사 수급자 관계 매칭 */
  relateReceiverAsCaregiver: CaregiverReceiver;
  /** 보호자 수급자 관계 매칭 */
  relateReceiverAsGuardian: GuardianReceiver;
  /** 보호자 서비스 요청 */
  requestServiceAsGuardian: ServiceRequest;
  /** 탈퇴 요청 */
  resign?: Maybe<Scalars['Boolean']>;
  resignCaregiverAsAdmin: Scalars['Boolean'];
  resignGuardianAsAdmin: Scalars['Boolean'];
  /** 메세지 보내기 */
  sendMessage: Message;
  /** admin 유저 로그인 */
  signInAsAdmin: Admin;
  /** 퀴즈용) admin 유저 로그인 */
  signInAsAdminForQuiz: AdminPayload;
  /** 보호사 로그인 */
  signInAsCaregiver: Caregiver;
  /** 보호자 로그인 */
  signInAsGuardian: Guardian;
  /** 로그아웃 */
  signOut: Scalars['Boolean'];
  /** 로그아웃 */
  signOutAsAdmin: Scalars['Boolean'];
  /** 보호사 수급자 관계 매칭 해제 */
  unrelateReceiverAsCaregiver: CaregiverReceiver;
  /** 보호자 수급자 관계 매칭 해제 */
  unrelateReceiverAsGuardian: GuardianReceiver;
  /** 어드민 보호사 수급자 매칭 수정 api */
  unrelatedCaregiverReceiverAsAdmin: CaregiverReceiver;
  /** 어드민 보호자 수급자 매칭 수정 api */
  unrelatedGuardianReceiverAsAdmin: GuardianReceiver;
  /** 어드민 유저 수정 */
  updateAdminUser: Admin;
  /** 관리자 공지사항 수정 */
  updateAnnouncementAsAdmin: Announcement;
  /** 배너 수정 */
  updateBannerAsAdmin: Banner;
  /** 어드민 보호사 수정 */
  updateCaregiverAsAdmin: Caregiver;
  /** 보호사 정보글 거주지역 수정 */
  updateCaregiverCities: Caregiver;
  /** 게시물 작성 */
  updateCaregiverCommunity: CaregiverCommunity;
  /** 게시물 사진 수정 */
  updateCaregiverCommunityMedia: CaregiverCommunity;
  /** 게시물 댓글 생성 & 업데이트 */
  updateCaregiverCommunityReply: CaregiverCommunityReply;
  updateCaregiverCommunityReplyComment: CaregiverCommunityReplyComment;
  /** 어드민 보호사 정보글 수정 & 생성 */
  updateCaregiverInfoAsAdmin: CaregiverInfo;
  /** 정보글 이미지 수정 */
  updateCaregiverInfoMedia: CaregiverInfo;
  /** 정보글 댓글 생성 & 수정 */
  updateCaregiverInfoReply: CaregiverInfoReply;
  /** 보호사 내정보 수정 */
  updateCaregiverProfile: Caregiver;
  /** 어드민 공통 코드 수정 */
  updateCommonCodeAsAdmin: CommonCode;
  /** 어드민 공통 코드 그룹 수정 */
  updateCommonCodeGroupAsAdmin: CommonCodeGroup;
  /** 예시 질문 답변 수정 */
  updateExampleQuestionAnswerAsAdmin: ExampleQuestionAnswer;
  /** 예시 질문 수정 */
  updateExampleQuestionAsAdmin: ExampleQuestion;
  /** 어드민 보호자 수정 */
  updateGuardianAsAdmin: Guardian;
  /** 보호사 프로필 업데이트 */
  updateGuardianProfile: Guardian;
  /** 채팅방 마지막 조회 시간 업데이트 */
  updateLastSeenAt: Chat;
  /** 어드민 management 수정 */
  updateManagementAsAdmin: Management;
  /** 보호사 푸시 알림 토큰 업데이트 */
  updateMessagingTokenAsCaregiver: Scalars['Boolean'];
  /** 보호사 푸시 알림 토큰 업데이트 */
  updateMessagingTokenAsGuardian: Scalars['Boolean'];
  /** 내 알림 설정 수정 */
  updateMyNotificationSetting?: Maybe<NotificationSetting>;
  /** 패키지 수정 */
  updatePackageAsAdmin: Package;
  /** 어드민 정책 업데이트 */
  updatePolicyAsAdmin: Policy;
  /** 수급자 업데이트 */
  updateReceiver: Receiver;
  /** 어드민 수급자 업데이트 api */
  updateReceiverAsAdmin: Receiver;
  /** 수급자 이슈 수정 */
  updateReceiverIssueAsGuardian: Receiver;
  updateReceiverRecord: ReceiverRecord;
  updateReceiverRecordMedia: ReceiverRecord;
  /** 어드민 관계 업데이트 api */
  updateRelationAsAdmin: Array<Relation>;
  /** 어드민 신고 사유 업데이트 api */
  updateReportReasonAsAdmin: ReportReason;
  updateServiceAsAdmin: Service;
  /** 보호사 서비스 요청 상태 변경 */
  updateServiceRequestStatusAsCaregiver: ServiceRequest;
  /** 보호자 서비스 요청 상태 변경 */
  updateServiceRequestStatusAsGuardian: ServiceRequest;
  /** 비디오 콘텐츠 수정 */
  updateVideoContentAsAdmin: VideoContent;
  updateVideoContentReply: VideoContentReply;
  updateVideoContentReplyComment: VideoContentReplyComment;
  /** 복지서비스 수정 */
  updateWelfareContentAsAdmin: WelfareContent;
  /** 일일 리포트 사진 업로드 */
  uploadImagesDailyReport: DailyReport;
};


export type MutationConfirmCaregiverAsReceiverArgs = {
  code: Scalars['String'];
  urlId: Scalars['ID'];
};


export type MutationConfirmGuardianAsReceiverArgs = {
  code: Scalars['String'];
  urlId: Scalars['ID'];
};


export type MutationCreateAdminUserArgs = {
  createAdminUserDto: CreateAdminUserDto;
};


export type MutationCreateAdminUserAsAdminArgs = {
  createAdminUserAsAdminInput: CreateAdminUserAsAdminInput;
};


export type MutationCreateBannerAsAdminArgs = {
  createBannerAsAdminDto: CreateBannerAsAdminDto;
};


export type MutationCreateCaregiverAsAdminArgs = {
  caregiverInput: CaregiverInput;
  cityCodes: Array<Scalars['ID']>;
  phone: Scalars['String'];
  profileInput: ProfileInput;
};


export type MutationCreateCaregiverCommunityLikeArgs = {
  communityId: Scalars['String'];
};


export type MutationCreateCaregiverCommunityReplyCommentArgs = {
  body: Scalars['String'];
  replyId: Scalars['String'];
};


export type MutationCreateCaregiverCommunityReplyCommentLikeArgs = {
  communityReplyCommentId: Scalars['String'];
};


export type MutationCreateCaregiverCommunityReplyLikeArgs = {
  caregiverCommunityReplyId: Scalars['String'];
};


export type MutationCreateCaregiverProfileArgs = {
  caregiverInput?: InputMaybe<CaregiverInput>;
  profileInput: ProfileInput;
};


export type MutationCreateCommonCodeAsAdminArgs = {
  createCommonCodeInput: CreateCommonCodeDto;
};


export type MutationCreateCommonCodeGroupAsAdminArgs = {
  createCommonCodeGroupInput: CreateCommonCodeGroupDto;
};


export type MutationCreateDailyReportArgs = {
  receiverId: Scalars['String'];
};


export type MutationCreateDailyReportByCommentArgs = {
  dailyReportId: Scalars['String'];
  receiverId: Scalars['String'];
};


export type MutationCreateFollowArgs = {
  caregiverId: Scalars['String'];
};


export type MutationCreateGuardianAsAdminArgs = {
  phoneNumber: Scalars['String'];
  profileInput: ProfileInput;
};


export type MutationCreateGuardianProfileArgs = {
  profileInput: GuardianProfileInputDto;
};


export type MutationCreateReceiverArgs = {
  receiverInput: ReceiverInput;
};


export type MutationCreateRecordQuestionCommentArgs = {
  answer: Scalars['String'];
  dailyReportId: Scalars['String'];
  measure?: InputMaybe<Scalars['Int']>;
  receiverId: Scalars['String'];
  recordQuestionId: Scalars['String'];
};


export type MutationCreateReportArgs = {
  reportInput: ReportInput;
};


export type MutationCreateReportReasonAsAdminArgs = {
  reportReasonInput: CreateReportReasonAsAdminDto;
};


export type MutationCreateTicketArgs = {
  body: Scalars['String'];
  receiverId: Scalars['ID'];
};


export type MutationCreateVideoContentAsAdminArgs = {
  description?: InputMaybe<Scalars['String']>;
  mediaInput: MediaInput;
  playTime: Scalars['String'];
  statusId: Scalars['String'];
  title: Scalars['String'];
  videoContentCategoryId: Scalars['String'];
  youtubeUrl: Scalars['String'];
};


export type MutationCreateVideoContentLikeArgs = {
  videoContentId: Scalars['String'];
};


export type MutationCreateVideoContentReplyArgs = {
  body: Scalars['String'];
  videoContentId: Scalars['String'];
};


export type MutationCreateVideoContentReplyCommentArgs = {
  body: Scalars['String'];
  videoContentReplyId: Scalars['String'];
};


export type MutationCreateVideoContentReplyCommentLikeArgs = {
  videoContentReplyCommentId: Scalars['String'];
};


export type MutationCreateVideoContentReplyLikeArgs = {
  videoContentReplyId: Scalars['String'];
};


export type MutationCreateWelfareContentAsAdminArgs = {
  applicationMethod?: InputMaybe<Scalars['String']>;
  contactInformation?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  detailPageUrl: Scalars['String'];
  inquiryPhone?: InputMaybe<Scalars['String']>;
  statusId: Scalars['String'];
  supportCycle?: InputMaybe<Scalars['String']>;
  supportType?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  welfareFamilyTypeIds?: InputMaybe<Array<Scalars['String']>>;
  welfareLifeCycleIds?: InputMaybe<Array<Scalars['String']>>;
  welfareServiceId: Scalars['String'];
  welfareTypeId: Scalars['String'];
};


export type MutationCreateWorkHourArgs = {
  receiverId: Scalars['ID'];
  x: Scalars['String'];
  y: Scalars['String'];
};


export type MutationDeleteAdminUserArgs = {
  adminId: Scalars['String'];
};


export type MutationDeleteBannerAsAdminArgs = {
  bannerId: Scalars['String'];
};


export type MutationDeleteCaregiverCityArgs = {
  cityCode: Scalars['ID'];
};


export type MutationDeleteCaregiverCommunityArgs = {
  communityId: Scalars['ID'];
};


export type MutationDeleteCaregiverCommunityLikeArgs = {
  communityId: Scalars['String'];
};


export type MutationDeleteCaregiverCommunityMediaArgs = {
  communityId: Scalars['ID'];
  mediaId: Scalars['ID'];
};


export type MutationDeleteCaregiverCommunityReplyArgs = {
  replyId: Scalars['ID'];
};


export type MutationDeleteCaregiverCommunityReplyCommentArgs = {
  replyCommentId: Scalars['String'];
};


export type MutationDeleteCaregiverCommunityReplyCommentLikeArgs = {
  communityReplyCommentId: Scalars['String'];
};


export type MutationDeleteCaregiverCommunityReplyLikeArgs = {
  caregiverCommunityReplyId: Scalars['String'];
};


export type MutationDeleteCaregiverInfoAsAdminArgs = {
  infoId: Scalars['ID'];
};


export type MutationDeleteCaregiverInfoMediaArgs = {
  infoId: Scalars['ID'];
  mediaId: Scalars['ID'];
};


export type MutationDeleteCaregiverInfoReplyArgs = {
  replyId: Scalars['ID'];
};


export type MutationDeleteCommonCodeAsAdminArgs = {
  commonCodeId: Scalars['String'];
};


export type MutationDeleteCommonCodeGroupAsAdminArgs = {
  commonCodeGroupId: Scalars['String'];
};


export type MutationDeleteDailyReportArgs = {
  dailyReportId: Scalars['String'];
  receiverId: Scalars['String'];
};


export type MutationDeleteDailyReportAsAdminArgs = {
  dailyReportId: Scalars['String'];
};


export type MutationDeleteFollowArgs = {
  caregiverId: Scalars['String'];
};


export type MutationDeleteReceiverRecordArgs = {
  recordId: Scalars['ID'];
};


export type MutationDeleteReceiverRecordMediaArgs = {
  mediaId: Scalars['ID'];
  recordId: Scalars['ID'];
};


export type MutationDeleteVideoContentAsAdminArgs = {
  videoContentId: Scalars['String'];
};


export type MutationDeleteVideoContentLikeArgs = {
  videoContentId: Scalars['String'];
};


export type MutationDeleteVideoContentReplyArgs = {
  id: Scalars['String'];
};


export type MutationDeleteVideoContentReplyCommentArgs = {
  videoContentReplyCommentId: Scalars['String'];
};


export type MutationDeleteVideoContentReplyCommentLikeArgs = {
  videoContentReplyCommentId: Scalars['String'];
};


export type MutationDeleteVideoContentReplyLikeArgs = {
  videoContentReplyId: Scalars['String'];
};


export type MutationDeleteWelfareContentAsAdminArgs = {
  welfareContentId: Scalars['String'];
};


export type MutationExchangePointsAsCaregiverArgs = {
  amount: Scalars['Int'];
  memberId: Scalars['ID'];
};


export type MutationExchangePointsAsGuardianArgs = {
  amount: Scalars['Int'];
  memberId: Scalars['ID'];
};


export type MutationFinishWorkHourArgs = {
  workHourId: Scalars['ID'];
  x: Scalars['String'];
  y: Scalars['String'];
};


export type MutationGivePointAsAdminForQuizArgs = {
  amount: Scalars['Int'];
  caregiverId: Scalars['String'];
};


export type MutationJoinChatAsCaregiverArgs = {
  chatId: Scalars['ID'];
};


export type MutationJoinChatAsGuardianArgs = {
  chatId: Scalars['ID'];
};


export type MutationReadNotificationArgs = {
  notificationId: Scalars['ID'];
};


export type MutationRelateReceiverAsCaregiverArgs = {
  receiverId: Scalars['ID'];
};


export type MutationRelateReceiverAsGuardianArgs = {
  receiverId: Scalars['ID'];
  relationId?: InputMaybe<Scalars['ID']>;
};


export type MutationRequestServiceAsGuardianArgs = {
  requestServiceInput: RequestServiceAsGuardianDto;
};


export type MutationResignArgs = {
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationResignCaregiverAsAdminArgs = {
  caregiverId: Scalars['ID'];
};


export type MutationResignGuardianAsAdminArgs = {
  guardianId: Scalars['String'];
};


export type MutationSendMessageArgs = {
  attachment?: InputMaybe<MediaInput>;
  chatId: Scalars['ID'];
  text?: InputMaybe<Scalars['String']>;
};


export type MutationSignInAsAdminArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationSignInAsAdminForQuizArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationSignInAsCaregiverArgs = {
  phone: Scalars['String'];
  verifyCode: Scalars['String'];
};


export type MutationSignInAsGuardianArgs = {
  phone: Scalars['String'];
  verifyCode: Scalars['String'];
};


export type MutationUnrelateReceiverAsCaregiverArgs = {
  receiverId: Scalars['ID'];
};


export type MutationUnrelateReceiverAsGuardianArgs = {
  receiverId: Scalars['ID'];
};


export type MutationUpdateAdminUserArgs = {
  updateAdminUserDto: UpdateAdminUserDto;
};


export type MutationUpdateAnnouncementAsAdminArgs = {
  announcementInput: UpdateAnnouncementAsAdminDto;
};


export type MutationUpdateBannerAsAdminArgs = {
  updateBannerAsAdminDto: UpdateBannerAsAdminDto;
};


export type MutationUpdateCaregiverAsAdminArgs = {
  caregiverId: Scalars['String'];
  caregiverInput: CaregiverInput;
  phoneNumber: Scalars['String'];
  profileInput: ProfileInput;
};


export type MutationUpdateCaregiverCitiesArgs = {
  cityCodes: Array<Scalars['ID']>;
};


export type MutationUpdateCaregiverCommunityArgs = {
  communityInput: CaregiverCommunityInput;
};


export type MutationUpdateCaregiverCommunityMediaArgs = {
  communityId: Scalars['ID'];
  mediaInputs?: InputMaybe<Array<MediaInput>>;
};


export type MutationUpdateCaregiverCommunityReplyArgs = {
  caregiverCommunityReplyInput: CaregiverCommunityReplyInput;
};


export type MutationUpdateCaregiverCommunityReplyCommentArgs = {
  body: Scalars['String'];
  replyCommentId: Scalars['String'];
};


export type MutationUpdateCaregiverInfoAsAdminArgs = {
  caregiverInfoInput: CaregiverInfoInput;
};


export type MutationUpdateCaregiverInfoMediaArgs = {
  infoId: Scalars['ID'];
  mediaInputs?: InputMaybe<Array<MediaInput>>;
};


export type MutationUpdateCaregiverInfoReplyArgs = {
  caregiverInfoReplyInput: CaregiverInfoReplyInput;
};


export type MutationUpdateCaregiverProfileArgs = {
  caregiverInput?: InputMaybe<CaregiverInput>;
  profileInput: ProfileInput;
};


export type MutationUpdateCommonCodeAsAdminArgs = {
  updateCommonCodeInput: UpdateCommonCodeDto;
};


export type MutationUpdateCommonCodeGroupAsAdminArgs = {
  updateCommonCodeGroupInput: UpdateCommonCodeGroupDto;
};


export type MutationUpdateExampleQuestionAnswerAsAdminArgs = {
  exampleQuestionAnswerInput: ExampleQuestionAnswerInput;
};


export type MutationUpdateExampleQuestionAsAdminArgs = {
  exampleQuestionInput: ExampleQuestionInput;
};


export type MutationUpdateGuardianAsAdminArgs = {
  guardianId: Scalars['String'];
  phoneNumber: Scalars['String'];
  profileInput: ProfileInput;
};


export type MutationUpdateGuardianProfileArgs = {
  profileInput: GuardianProfileInputDto;
};


export type MutationUpdateLastSeenAtArgs = {
  chatId: Scalars['ID'];
};


export type MutationUpdateManagementAsAdminArgs = {
  managementInput: UpdateManagementAsAdminDto;
};


export type MutationUpdateMessagingTokenAsCaregiverArgs = {
  newToken?: InputMaybe<Scalars['String']>;
  oldToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateMessagingTokenAsGuardianArgs = {
  newToken?: InputMaybe<Scalars['String']>;
  oldToken: Scalars['String'];
};


export type MutationUpdateMyNotificationSettingArgs = {
  notificationSettingInput: NotificationSettingInput;
};


export type MutationUpdatePackageAsAdminArgs = {
  packageInput: PackageInput;
};


export type MutationUpdatePolicyAsAdminArgs = {
  policyInput: UpdatePolicyDto;
};


export type MutationUpdateReceiverArgs = {
  receiverInput: ReceiverInput;
};


export type MutationUpdateReceiverAsAdminArgs = {
  receiverInput: ReceiverInput;
};


export type MutationUpdateReceiverIssueAsGuardianArgs = {
  issue: Scalars['String'];
  receiverId: Scalars['ID'];
};


export type MutationUpdateReceiverRecordArgs = {
  receiverRecordInput: ReceiverRecordInput;
};


export type MutationUpdateReceiverRecordMediaArgs = {
  mediaInputs: Array<MediaInput>;
  recordId: Scalars['ID'];
};


export type MutationUpdateRelationAsAdminArgs = {
  relationInput: UpdateRelationAsAdminDto;
};


export type MutationUpdateReportReasonAsAdminArgs = {
  reportReasonInput: UpdateReportReasonAsAdminDto;
};


export type MutationUpdateServiceAsAdminArgs = {
  serviceInput: UpdateServiceAsAdminDto;
};


export type MutationUpdateServiceRequestStatusAsCaregiverArgs = {
  serviceRequestId: Scalars['ID'];
  status: ServiceRequestStatus;
};


export type MutationUpdateServiceRequestStatusAsGuardianArgs = {
  serviceRequestId: Scalars['ID'];
  status: ServiceRequestStatus;
};


export type MutationUpdateVideoContentAsAdminArgs = {
  description?: InputMaybe<Scalars['String']>;
  mediaInput?: InputMaybe<MediaInput>;
  playTime: Scalars['String'];
  statusId: Scalars['String'];
  title: Scalars['String'];
  videoContentCategoryId: Scalars['String'];
  videoContentId: Scalars['String'];
  youtubeUrl: Scalars['String'];
};


export type MutationUpdateVideoContentReplyArgs = {
  body: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUpdateVideoContentReplyCommentArgs = {
  body: Scalars['String'];
  videoContentReplyCommentId: Scalars['String'];
};


export type MutationUpdateWelfareContentAsAdminArgs = {
  statusId: Scalars['String'];
  welfareContentId: Scalars['String'];
};


export type MutationUploadImagesDailyReportArgs = {
  dailyReportId: Scalars['String'];
  mediaInput?: InputMaybe<MediaInput>;
};

export type MyInvitedCaregiverGuardianConnection = {
  __typename?: 'MyInvitedCaregiverGuardianConnection';
  edges: Array<InvitedCaregiverGuardian>;
  pageInfo: PageInfo;
};

/** 추천 네트워크 유저 순위 정렬 키 */
export enum NetworkUserRankSortKey {
  /** 추천 네트워크 유저 순위 정렬 키 */
  Count = 'COUNT'
}

/** 추천 네트워크 유저 검색 타입 */
export enum NetworkUserSearchType {
  /** 보호사 이름 */
  CaregiverName = 'CAREGIVER_NAME',
  /** 보호자 이름 */
  GuardianName = 'GUARDIAN_NAME'
}

/** 추천 네트워크 유저 정렬 타입 */
export enum NetworkUserSortKey {
  /** 생성일 */
  CreatedAt = 'CREATED_AT',
  /** 총 추천 네트워크 유저 수 */
  TotalNetworkUserCount = 'TOTAL_NETWORK_USER_COUNT',
  /** 총 리워드 포인트 */
  TotalRewardPoint = 'TOTAL_REWARD_POINT'
}

export type NewsData = {
  __typename?: 'NewsData';
  /** 제목 */
  title: Scalars['String'];
  /** 주제 */
  topic: Scalars['String'];
};

/** 알림 */
export type Notification = {
  __typename?: 'Notification';
  /** 내용 */
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 알림 발신자 */
  fromUser?: Maybe<Caregiver>;
  /** 알림 발신자 id */
  fromUserId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** 읽었는지 */
  isRead: Scalars['Boolean'];
  /** 보여졌는지 */
  isSeen: Scalars['Boolean'];
  linkTarget?: Maybe<NotificationLinkTargetDto>;
  /** 링크 대상 id */
  linkTargetId: Scalars['String'];
  /** 대상 타입 */
  linkTargetType: CommonCode;
  linkTargetTypeId: Scalars['String'];
  /** 알림 타입 */
  notificationType: CommonCode;
  notificationTypeId: Scalars['String'];
  /** 읽었는지 */
  readAt?: Maybe<Scalars['DateTime']>;
  /** 보여졌는지 */
  seenAt?: Maybe<Scalars['DateTime']>;
  /** 알림 대상 */
  targetUser: Caregiver;
  /** 알림 대상 id */
  targetUserId?: Maybe<Scalars['String']>;
  /** 제목 */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<Notification>;
  pageInfo: PageInfo;
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  payload: Notification;
  type: NotificationEventType;
};

export enum NotificationEventType {
  /** 서비스 요청 수락 */
  AcceptServiceRequest = 'ACCEPT_SERVICE_REQUEST',
  /** 팁 요청 수락 */
  AcceptTip = 'ACCEPT_TIP',
  /** 서비스 요청 취소 */
  CancelServiceRequest = 'CANCEL_SERVICE_REQUEST',
  /** 팁 요청 취소 */
  CancelTip = 'CANCEL_TIP',
  /** 커뮤니티 댓글 */
  CommunityReply = 'COMMUNITY_REPLY',
  /** 커뮤니티 댓글 댓글 */
  CommunityReplyComment = 'COMMUNITY_REPLY_COMMENT',
  /** 팔로우 */
  Follow = 'FOLLOW',
  /** 서비스 요청 거절 */
  RejectServiceRequest = 'REJECT_SERVICE_REQUEST',
  /** 팁 요청 거절 */
  RejectTip = 'REJECT_TIP',
  /** 서비스 요청 */
  ServiceReqest = 'SERVICE_REQEST',
  /** 팁 요청 */
  TipRequest = 'TIP_REQUEST',
  VideoContentReplyComment = 'VIDEO_CONTENT_REPLY_COMMENT'
}

export type NotificationLinkTargetDto = {
  __typename?: 'NotificationLinkTargetDTO';
  id: Scalars['String'];
  receiverId?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** 공지 세팅 */
export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  announcement: Scalars['Boolean'];
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  chat: Scalars['Boolean'];
  guardian: Guardian;
  guardianId: Scalars['String'];
  id: Scalars['String'];
};

export type NotificationSettingInput = {
  announcement: Scalars['Boolean'];
  chat: Scalars['Boolean'];
  id?: InputMaybe<Scalars['ID']>;
};

/** 상품 */
export type Package = {
  __typename?: 'Package';
  /** 활성화 여부 */
  active: Scalars['Boolean'];
  /** 최종 가격 */
  finalPrice: Scalars['String'];
  id: Scalars['String'];
  /** 초기가격 */
  initialPrice: Scalars['String'];
  /** 패키지 이름 */
  name?: Maybe<Scalars['String']>;
  /** 포인트 */
  point: Scalars['Int'];
};

export type PackageInput = {
  active: Scalars['Boolean'];
  finalPrice: Scalars['Int'];
  id?: InputMaybe<Scalars['ID']>;
  initialPrice: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  point: Scalars['Int'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** 마지막 커서 */
  endCursor?: Maybe<Scalars['String']>;
  /** 다음 페이지 번호 */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** 처음 커서 */
  startCursor?: Maybe<Scalars['String']>;
  /** 전체 개수 */
  totalCount?: Maybe<Scalars['Int']>;
};

/** 포인트 트랜잭션 */
export type PointTransaction = {
  __typename?: 'PointTransaction';
  /** 포인트 금액 */
  amount: Scalars['Int'];
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  guardian?: Maybe<Guardian>;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  invitedCaregiver?: Maybe<Caregiver>;
  invitedCaregiverId: Scalars['String'];
  invitedGuardian?: Maybe<Guardian>;
  invitedGuardianId: Scalars['String'];
  pointTransactionType?: Maybe<CommonCode>;
  pointTransactionTypeId: Scalars['String'];
  purchase?: Maybe<Purchase>;
  purchaseId: Scalars['String'];
  serviceRequest?: Maybe<ServiceRequest>;
  serviceRequestId: Scalars['String'];
  /** 포인트 타입 */
  type?: Maybe<PointTransactionType>;
  updatedAt: Scalars['DateTime'];
};

export type PointTransactionConnection = {
  __typename?: 'PointTransactionConnection';
  edges: Array<PointTransaction>;
  pageInfo: PageInfo;
};

export enum PointTransactionType {
  /** 추가 */
  Addition = 'ADDITION',
  /** 교환 */
  Exchange = 'EXCHANGE',
  ExchangeCafe24Point = 'EXCHANGE_CAFE24_POINT',
  RewardCommentPoint = 'REWARD_COMMENT_POINT',
  RewardCommunityWritePoint = 'REWARD_COMMUNITY_WRITE_POINT',
  RewardDailyReportPoint = 'REWARD_DAILY_REPORT_POINT',
  RewardInviteUserDepth1 = 'REWARD_INVITE_USER_DEPTH1',
  RewardInviteUserDepth2 = 'REWARD_INVITE_USER_DEPTH2',
  /** 차감 */
  Subtract = 'SUBTRACT'
}

/** 정책 */
export type Policy = {
  __typename?: 'Policy';
  /** 내용 */
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  /** 타입 */
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** 정책 타입 */
export enum PolicyType {
  /** ? */
  Privacy = 'PRIVACY',
  /** ? */
  Terms = 'TERMS'
}

export type ProfileInput = {
  /** avatar */
  avatarInput?: InputMaybe<MediaInput>;
  /** 생년월일 */
  dateOfBirth?: InputMaybe<Scalars['String']>;
  /** 이메일 */
  email?: InputMaybe<Scalars['String']>;
  /** 성별 */
  gender: Gender;
  /** 초대코드 */
  invitationCode?: InputMaybe<Scalars['String']>;
  /** 이름 */
  name: Scalars['String'];
  /** 핸드폰 번호 */
  phone?: InputMaybe<Scalars['String']>;
  /** 유저 이름 */
  username?: InputMaybe<Scalars['String']>;
};

/** 결제 */
export type Purchase = {
  __typename?: 'Purchase';
  /** 취소 사유 */
  cancelReason: Scalars['String'];
  /** 결제 취소 시각 */
  cancelledAt: Scalars['String'];
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 최종 가격 */
  finalPrice: Scalars['String'];
  guardian?: Maybe<Guardian>;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  /** 아임포트 결제 고유번호 */
  impUid: Scalars['String'];
  /** 초기 가격 */
  initialPrice: Scalars['String'];
  /** 상점 거래 고유번호 */
  merchantUid: Scalars['String'];
  /** 결제 수단 */
  method: Scalars['String'];
  packageId: Scalars['String'];
  /** 결제 완료 시각 */
  paidAt: Scalars['String'];
  /** PG사 */
  pgProvider: Scalars['String'];
  /** 포인트 */
  point: Scalars['String'];
  pointPackage: Package;
  /** 결제 상태 */
  status: PurchaseStatus;
  updatedAt: Scalars['DateTime'];
};

export enum PurchaseStatus {
  /** 결제 취소 */
  Cancelled = 'CANCELLED',
  /** 결제 실패 */
  Failed = 'FAILED',
  /** 결제 완료 */
  Paid = 'PAID'
}

export type Query = {
  __typename?: 'Query';
  checkAppVersion: AppVersion;
  /** 새로운 알림 조회 */
  checkNewNotification: Scalars['Boolean'];
  /** 어드민 역할 리스트 조회 */
  getAdminRoles: Array<AdminRole>;
  /** 어드민 유저 상세 페이지 */
  getAdminUser: Admin;
  /** 어드민 유저 리스트 조회 */
  getAdminUsers: AdminConnection;
  /** 공지사항 조회 */
  getAnnouncement: Announcement;
  /** 공지사항 목록 조회 */
  getAnnouncements: AnnouncementConnection;
  /** 자동 문장 완성 */
  getAutoCompletedSentences: Array<Scalars['String']>;
  /** 배너 상세 조회 */
  getBannerAsAdmin: Banner;
  /** 배너 리스트 조회 */
  getBannersAsAdmin: BannerConnection;
  /** 배너 집계 조회 */
  getBannersCountAsAdmin: BannerCount;
  /** 복지로 복지서비스 목록 조회 */
  getBokjiroWelfareContentsAsAdmin: BokjiroWelfareConnection;
  /** Cafe24 OAuth 토큰 가져오기 */
  getCafe24OAuthToken: Scalars['String'];
  getCafe24TokenExpiryTimesAsAdmin: TokenExpiryTimes;
  /** 장기요양등급 리스트 */
  getCareGrades: CareGradeConnection;
  /** 키워드 리스트 */
  getCareService: Array<CareService>;
  /** 보호사 내 활동 */
  getCaregiverActivities: CaregiverActivitiesTotal;
  /** 내가 쓴 게시물 리스트 */
  getCaregiverCommunitiesByAuthor: CaregiverCommunityConnection;
  /** 어드민 작성자별 커뮤니티 리스트 */
  getCaregiverCommunitiesByAuthorAsAdmin: CaregiverCommunityConnection;
  /** 내가 쓴 게시물 댓글 리스트 */
  getCaregiverCommunitiesByReplyAuthor: CaregiverCommunityConnection;
  /** 타입별 게시물 리스트 */
  getCaregiverCommunitiesByType: CaregiverCommunityConnection;
  /** 이번달 신규 게시물 수 */
  getCaregiverCommunitiesByTypeAsAdmin: CaregiverCommunityConnection;
  /** 게시물 상세페이지 */
  getCaregiverCommunity: CaregiverCommunity;
  /** 댓글 리스트 */
  getCaregiverCommunityRepliesByCommunity: CaregiverCommunityReplyConnection;
  /** 어드민 커뮤니티 댓글 리스트 */
  getCaregiverCommunityRepliesByCommunityAsAdmin: CaregiverCommunityReplyConnection;
  /** 댓글 */
  getCaregiverCommunityReply: CaregiverCommunityReply;
  getCaregiverCommunityReplyComment: CaregiverCommunityReplyComment;
  getCaregiverCommunityReplyComments: CaregiverCommunityReplyCommentConnection;
  /** 정보글 상세 페이지 */
  getCaregiverInfo: CaregiverInfo;
  /** 정보글 댓글 리스트 */
  getCaregiverInfoRepliesByInfo: CaregiverInfoReplyConnection;
  /** 지역별 정보글 리스트 */
  getCaregiverInfos: CaregiverInfoConnection;
  getCaregiverManual: Array<CaregiverManual>;
  /** 보호사 정보 가져오기 */
  getCaregiverProfile: Caregiver;
  getCaregiverSupportService: Array<CaregiverSupportService>;
  /** 어드민 보호사 리스트 */
  getCaregiversAsAdmin: CaregiverConnection;
  getCaregiversCommunityAndReplyCountAsAdmin: CaregiverCommunityAndReplyCount;
  /** 자격증 OCR API */
  getCertificateNumberFromBase64: Scalars['String'];
  /** 채팅방 조회 */
  getChat: Chat;
  /** 메세지 리스트 */
  getChatMessages: MessageConnection;
  /** 어드민 대시보드 채팅방 메세지 개수 리스트 */
  getChatsOrderByMessagesCountAsAdmin: ChatConnection;
  getCitiesByState: Array<City>;
  /** 공통 코드 상세 */
  getCommonCode: CommonCode;
  /** 어드민 공통 코드 상세페이지 조회 */
  getCommonCodeAsAdmin: CommonCode;
  /** 공통 코드 그룹 상세페이지 */
  getCommonCodeGroup: CommonCodeGroup;
  /** 어드민 공통 코드 그룹 */
  getCommonCodeGroupAsAdmin: CommonCodeGroup;
  /** 공통 코드 그룹 이름 검색 */
  getCommonCodeGroupByType: CommonCodeGroup;
  /** 어드민 공통 코드 그룹 리스트 */
  getCommonCodeGroupsAsAdmin: CommonCodeGroupConnection;
  /** 어드민 공통 코드 이름 검색 */
  getCommonCodeGroupsByTypeAsAdmin: Array<CommonCodeGroup>;
  /** 공통 코드 리스트 */
  getCommonCodes: CommonCodeConnection;
  /** 어드민 공통 코드 리스트 조회 */
  getCommonCodesAsAdmin: CommonCodeConnection;
  /** 어드민 질문 상세 조회 api */
  getDailyReceiverRecordDetailAsAdmin?: Maybe<DailyReceiverRecordDetail>;
  /** 어드민 질문 조회 api */
  getDailyReceiverRecordsAsAdmin: Array<DailyReceiverRecord>;
  /** 어드민 돌봄일지 조회 */
  getDailyReportAsAdmin: DailyReport;
  /** 보호사 일일리포트 */
  getDailyReportAsCaregiver: DailyReport;
  /** 보호자 일일리포트 */
  getDailyReportAsGuardian: DailyReport;
  /** 어드민 돌봄일지 리스트 조회 */
  getDailyReportsAsAdmin: DailyReportConnection;
  /** 보호사 일일리포트 리스트 */
  getDailyReportsAsCaregiver: Array<DailyReport>;
  /** 보호자 일일리포트 리스트 */
  getDailyReportsAsGuardian: Array<DailyReport>;
  /** 어드민 주별 리포트 조회 */
  getDailyReportsByMonthWeekAdmin: Array<DailyReportGroupByWeek>;
  /** 질병 리스트 */
  getDiseases: DiseaseConnection;
  /** 예시 질문 조회 */
  getExmapleQuestionsAsAdmin: ExampleQuestionConnection;
  /** 팔로워 리스트 */
  getFollowers: FollowConnection;
  /** 팔로잉 리스트 */
  getFollowings: FollowConnection;
  /** 해당 보호사 프로필 가져오기 */
  getGuardianProfile: Guardian;
  /** 어드민 보호자 리스트 조회 */
  getGuardiansAsAdmin: GuardianConnection;
  getIncentiveDashboardAsAdmin: IncentiveDashboard;
  /** 관리자 보상 및 인센티브 라인 그래프 api  */
  getIncentiveLineGraphAsAdmin: Array<IncentiveLineGraph>;
  /** 재가 서비스 */
  getInhomeService: Array<InhomeService>;
  /** 돌봄 기록 인트로 질문 코멘트 가져오기 */
  getIntroQuestionComment: Comment;
  /** 돌봄 기록 인트로 질문 */
  getIntroRecordQuestion: IntroQuestion;
  /** 최신 정책 조회 api */
  getLatestPolicy: Policy;
  getManagement: Management;
  /** 월별리포트 척도 점수 그래프 */
  getMonthlyReceiverMeasure: Array<MonthlyMeasure>;
  /** 월별리포트 수급자 상태 보고서 */
  getMonthlyReceiverStatus: ReceiverStatus;
  /** 토큰으로 어드민 유저 조회 */
  getMyAdminUser: Admin;
  /** 보호사 내 정보 가져오기 */
  getMyCaregiverProfile: Caregiver;
  /** 보호사의 수급자 리스트 */
  getMyCaregiversAsReceiver: Array<CaregiverReceiver>;
  /** 보호자 프로필 가져오기 */
  getMyGuardianProfile: Guardian;
  /** 서브어드민 나의 초대한 유저 조회 */
  getMyInvitationCaregiversGuardians: MyInvitedCaregiverGuardianConnection;
  /** 내 추천 네트워크 조회 */
  getMyInvitations: InvitationConnection;
  getMyMileageAsCaregiver: CarestoreMileage;
  getMyMileageAsGuardian: CarestoreMileage;
  /** 내 알림 설정 조회 */
  getMyNotificationSetting?: Maybe<NotificationSetting>;
  /** 보호사 내 포인트 변경 사항 리스트 */
  getMyPointTransactionsAsCaregiver: PointTransactionConnection;
  /** 보호자 내 포인트 변경사항 리스트 */
  getMyPointTransactionsAsGuardian: PointTransactionConnection;
  /** 보호사의 수급자 */
  getMyReceiverAsCaregiver: CaregiverReceiver;
  /** 보호자의 수급자 리스트 */
  getMyReceiverAsGuardian: GuardianReceiver;
  /** 보호사의 수급자 리스트 */
  getMyReceiversAsCaregiver: Array<CaregiverReceiver>;
  /** 보호자의 수급자 리스트 */
  getMyReceiversAsGuardian: Array<GuardianReceiver>;
  /** 보호사 서비스 요청 목록 조회 */
  getMyServiceRequestsAsCaregiver: ServiceRequestConnection;
  /** 보호자 서비스 요청 목록 조회 */
  getMyServiceRequestsAsGuardian: ServiceRequestConnection;
  getNetworkDashboardAsAdmin: AdminNetworkDashboard;
  getNetworkGraphDashboardAsAdmin: Array<AdminNetworkGraphDashboard>;
  /** 알림 상세 조회 */
  getNotification: Notification;
  /** 알림 리스트 조회 */
  getNotifications: NotificationConnection;
  getPackage: Package;
  getPackages: Array<Package>;
  /** 정책 리스트 api */
  getPolicies: Array<Policy>;
  getPurchase: Purchase;
  getRandomExampleQuestion: ExampleQuestion;
  /** 수급자 프로필 가져오기 */
  getReceiver: Receiver;
  /** 수급자 나이 그래프 */
  getReceiverAgeRatioGraph: ReceiverAgeRatioGraph;
  /** 수급자 요양등급 그래프 */
  getReceiverCareGradeRatioGraph: ReceiverCareGradeRatioGraph;
  /** 보호사 일일리포트 포토앨범 */
  getReceiverDailyReportMediasAsCaregiver: DailyReportConnectionPhotoAlbum;
  /** 보호자 일일리포트 포토앨범 */
  getReceiverDailyReportMediasAsGuardian: DailyReportConnectionPhotoAlbum;
  /** 돌봄기록 질병 질문 가져오기 */
  getReceiverDiseaseCategoryQuestions: Array<RecordQuestion>;
  /** 수급자 질병 그래프 */
  getReceiverDiseaseRatioGraph: ReceiverDiseaseRatioGraph;
  /** 수급자 배변 그래프 */
  getReceiverExcretionRatioGraph: ReceiverExcretionRatioGraph;
  /** 수급자 성비 그래프 */
  getReceiverGenderRatioGraph: ReceiverGenderRatioGraph;
  getReceiverKeywords: Array<Keyword>;
  /** 수급자 욕창 그래프 */
  getReceiverPuRatioGraph: ReceiverPuRatioGraph;
  getReceiverRecord: ReceiverRecord;
  getReceiverRecords: ReceiverRecordConnection;
  /** 수신 기록 조회 */
  getReceiverRecordsAsAdmin: ReceiverRecordConnection;
  getReceiverWeeklyReport: ReceiverMeasureComment;
  getReceiverWeeklyReportWithTotalComment: ReceiverMeasureTotalComment;
  /** 어드민 수급자 리스트 api */
  getReceiversAsAdmin: ReceiverConnection;
  /** 돌봄기록 질문 가져오기 */
  getRecordQuestion?: Maybe<RecordQuestion>;
  /** 추천 네트워크 유저 상세 조회 */
  getReferralNetworkUserAsAdmin: Invitation;
  /** 추천 네트워크 유저 조회 */
  getReferralNetworkUsersAsAdmin: InvitationConnection;
  /** 추천 네트워크 유저 순위 조회 */
  getReferralNetworkUsersRankAsAdmin: InvitationConnection;
  /** OCR */
  getRegistrationNumberFromBase64: Scalars['String'];
  /** 보호자 수급자 매칭 */
  getRelationWithReceiverAsGuardian: GuardianReceiver;
  /** 관계 리스트 */
  getRelations: Array<Relation>;
  /** 신고 사유 리스트 */
  getReportReasons: Array<ReportReason>;
  /** 어드민 신고 조회 api */
  getReportsAsAdmin: ReportConnection;
  getResignedUsersAsAdmin: ResignationConnect;
  /** 서비스 상세 조회 */
  getService: Service;
  /** 서비스 요청 상세 조회 */
  getServiceRequest: ServiceRequest;
  /** 서비스 리스트 조회 */
  getServices: Array<Service>;
  getStates: Array<State>;
  /** 테스트 admin token 발급 */
  getTestAdminToken: Scalars['String'];
  getTicketsAsAdmin: TicketConnection;
  /** 오늘의 인기 게시물 리스트 */
  getTodayPopularCaregiverCommunities: CaregiverCommunityConnection;
  getTodayPopularVideoContents: VideoContentConnection;
  /** 오늘 근무 시간 */
  getTodaysWorkHour?: Maybe<WorkHour>;
  getUserCountsAsAdmin: UserCounts;
  /** 어드민 유저 보상 및 인센티브 리스트 */
  getUserIncentivesAsAdmin: PointTransactionConnection;
  /** 어드민 point transaction 리스트 */
  getUserPointTransactionsAsAdmin: PointTransactionConnection;
  getVideoContent: VideoContent;
  getVideoContentReplies: VideoContentReplyConnection;
  getVideoContentReply: VideoContentReply;
  getVideoContentReplyComment: VideoContentReplyComment;
  getVideoContentReplyComments: VideoContentReplyCommentConnection;
  getVideoContents: VideoContentConnection;
  /** 비디오 컨텐츠 리스트 가져오기 */
  getVideoContentsAsAdmin: VideoContentConnection;
  /** 주간리포트 카테고리 리스트 */
  getWeeklyReceiverMeasures: Array<Measure>;
  /** 어드민 질문 주간 중분류 조회 api */
  getWeeklyReceiverMediumRecordsAsAdmin?: Maybe<Array<ReceiverMediumRecordData>>;
  /** 어드민 질문 주간 카운트 조회 api */
  getWeeklyReceiverRecordCountAsAdmin?: Maybe<Array<ReceiverRecordCount>>;
  /** 어드민 질문 주간 소분류 조회 api */
  getWeeklyReceiverSmallRecordsAsAdmin?: Maybe<Array<ReceiverSmallRecordData>>;
  /** 복지서비스 상세 조회 */
  getWelfareContentAsAdmin: WelfareContent;
  getWelfareContents: WelfareContentConnection;
  /** 복지서비스 목록 조회 */
  getWelfareContentsAsAdmin: WelfareContentConnection;
  /** 근무 시간 리스트 */
  getWorkHours: WorkHourConnection;
  getWorkHoursAsAdmin: WorkHourConnection;
  /** 연간 게시물 트렌드 */
  getYearlyCommunityTrendAsAdmin: Array<CommunityCount>;
  getYearlyUserTrendAsAdmin: Array<UserCounts>;
  /** 유튜브 동영상 리스트 가져오기 */
  getYoutubeVideosAsAdmin: YoutubeVideosConnection;
  /** 어드민 보호사 검색 */
  searchCaregiversAsAdmin: CaregiverConnection;
  /** 어드민 보호자 검색 */
  searchGuardiansAsAdmin: GuardianConnection;
  /** 메세지 검색 */
  searchMessages: MessageConnection;
  /** 수급자 검색 */
  searchReceivers: ReceiverConnection;
  /** 어드민 수급자 검색 api */
  searchReceiversAsAdmin: ReceiverConnection;
  /** 인증 문자 발송 */
  sendVerifyCode: Scalars['Boolean'];
};


export type QueryCheckAppVersionArgs = {
  currentVersion: Scalars['String'];
  platform: Scalars['String'];
  role: Scalars['String'];
};


export type QueryGetAdminUserArgs = {
  adminId: Scalars['String'];
};


export type QueryGetAdminUsersArgs = {
  adminSearchType?: InputMaybe<AdminSearchType>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<AdminSortKey>;
};


export type QueryGetAnnouncementArgs = {
  announcementId: Scalars['ID'];
};


export type QueryGetAnnouncementsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  onBanner?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetAutoCompletedSentencesArgs = {
  answer?: InputMaybe<Scalars['String']>;
  receiverId: Scalars['String'];
  recordQuestionId?: InputMaybe<Scalars['String']>;
};


export type QueryGetBannerAsAdminArgs = {
  bannerId: Scalars['String'];
};


export type QueryGetBannersAsAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<BannerSortKey>;
};


export type QueryGetBokjiroWelfareContentsAsAdminArgs = {
  limit: Scalars['Int'];
  page: Scalars['Int'];
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  welfareFamilyTypeIds?: InputMaybe<Array<Scalars['String']>>;
  welfareLifeCycleIds?: InputMaybe<Array<Scalars['String']>>;
  welfareTypeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetCafe24OAuthTokenArgs = {
  code: Scalars['String'];
};


export type QueryGetCareGradesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCareServiceArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetCaregiverCommunitiesByAuthorArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCaregiverCommunitiesByAuthorAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCaregiverCommunitiesByReplyAuthorArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCaregiverCommunitiesByTypeArgs = {
  after?: InputMaybe<Scalars['String']>;
  categoryIds?: InputMaybe<Array<Scalars['String']>>;
  communityTypeId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCaregiverCommunitiesByTypeAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<RangeInput>;
  type?: InputMaybe<CaregiverCommunityType>;
};


export type QueryGetCaregiverCommunityArgs = {
  communityId: Scalars['ID'];
};


export type QueryGetCaregiverCommunityRepliesByCommunityArgs = {
  after?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCaregiverCommunityRepliesByCommunityAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  communityId: Scalars['ID'];
  first: Scalars['Int'];
};


export type QueryGetCaregiverCommunityReplyArgs = {
  replyId: Scalars['ID'];
};


export type QueryGetCaregiverCommunityReplyCommentArgs = {
  replyCommentId: Scalars['String'];
};


export type QueryGetCaregiverCommunityReplyCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  replyId: Scalars['String'];
};


export type QueryGetCaregiverInfoArgs = {
  infoId: Scalars['ID'];
};


export type QueryGetCaregiverInfoRepliesByInfoArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  infoId: Scalars['ID'];
};


export type QueryGetCaregiverInfosArgs = {
  after?: InputMaybe<Scalars['String']>;
  cityCodes?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCaregiverManualArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetCaregiverProfileArgs = {
  caregiverId: Scalars['ID'];
};


export type QueryGetCaregiverSupportServiceArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetCaregiversAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
};


export type QueryGetCaregiversCommunityAndReplyCountAsAdminArgs = {
  caregiverId: Scalars['ID'];
};


export type QueryGetCertificateNumberFromBase64Args = {
  base64: Scalars['String'];
  format: Scalars['String'];
  name: Scalars['String'];
};


export type QueryGetChatArgs = {
  chatId: Scalars['ID'];
};


export type QueryGetChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  chatId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryGetChatsOrderByMessagesCountAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCitiesByStateArgs = {
  stateId: Scalars['ID'];
};


export type QueryGetCommonCodeArgs = {
  commonCodeId: Scalars['String'];
};


export type QueryGetCommonCodeAsAdminArgs = {
  commonCodeId: Scalars['String'];
};


export type QueryGetCommonCodeGroupArgs = {
  commonCodeGroupId: Scalars['String'];
};


export type QueryGetCommonCodeGroupAsAdminArgs = {
  groupId: Scalars['String'];
};


export type QueryGetCommonCodeGroupByTypeArgs = {
  type: CommonCodeGroupType;
};


export type QueryGetCommonCodeGroupsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  commonGroupCodeSearchType?: InputMaybe<CommonCodeGroupSearchType>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<CommonCodeGroupSortKey>;
};


export type QueryGetCommonCodeGroupsByTypeAsAdminArgs = {
  types: Array<CommonCodeGroupType>;
};


export type QueryGetCommonCodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  commonCodeGroupId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCommonCodesAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  commonCodeGroupId: Scalars['String'];
  commonCodeSearchType?: InputMaybe<CommonCodeSearchType>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<CommonCodeSortKey>;
};


export type QueryGetDailyReceiverRecordDetailAsAdminArgs = {
  recordHistoryId: Scalars['String'];
};


export type QueryGetDailyReceiverRecordsAsAdminArgs = {
  date: Scalars['String'];
  receiverId: Scalars['String'];
};


export type QueryGetDailyReportAsAdminArgs = {
  dailyReportId: Scalars['String'];
};


export type QueryGetDailyReportAsCaregiverArgs = {
  dailyReportId: Scalars['String'];
};


export type QueryGetDailyReportAsGuardianArgs = {
  dailyReportId: Scalars['String'];
};


export type QueryGetDailyReportsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  dailyReportSearchQuery?: InputMaybe<DailyReportSearchQuery>;
  first: Scalars['Int'];
};


export type QueryGetDailyReportsAsCaregiverArgs = {
  month: Scalars['String'];
  receiverId: Scalars['String'];
  year: Scalars['String'];
};


export type QueryGetDailyReportsAsGuardianArgs = {
  caregiverId: Scalars['String'];
  month: Scalars['String'];
  receiverId: Scalars['String'];
  year: Scalars['String'];
};


export type QueryGetDailyReportsByMonthWeekAdminArgs = {
  month?: InputMaybe<Scalars['Int']>;
  receiverId?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};


export type QueryGetDiseasesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetExmapleQuestionsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
};


export type QueryGetFollowersArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId: Scalars['String'];
  first: Scalars['Int'];
};


export type QueryGetFollowingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId: Scalars['String'];
  first: Scalars['Int'];
};


export type QueryGetGuardianProfileArgs = {
  guardianId: Scalars['String'];
};


export type QueryGetGuardiansAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
};


export type QueryGetIncentiveDashboardAsAdminArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetIncentiveLineGraphAsAdminArgs = {
  caregiverId?: InputMaybe<Scalars['String']>;
  guardianId?: InputMaybe<Scalars['String']>;
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetInhomeServiceArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetIntroQuestionCommentArgs = {
  answer: Scalars['String'];
  question: Scalars['String'];
  title: Scalars['String'];
  topic: Scalars['String'];
};


export type QueryGetLatestPolicyArgs = {
  type: PolicyType;
};


export type QueryGetMonthlyReceiverMeasureArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetMonthlyReceiverStatusArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetMyCaregiversAsReceiverArgs = {
  receiverId: Scalars['ID'];
};


export type QueryGetMyInvitationCaregiversGuardiansArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMyInvitationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMyPointTransactionsAsCaregiverArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMyPointTransactionsAsGuardianArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetMyReceiverAsCaregiverArgs = {
  receiverId: Scalars['ID'];
};


export type QueryGetMyReceiverAsGuardianArgs = {
  receiverId: Scalars['ID'];
};


export type QueryGetMyServiceRequestsAsCaregiverArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  receiverId: Scalars['ID'];
  status?: InputMaybe<Array<ServiceRequestStatus>>;
};


export type QueryGetMyServiceRequestsAsGuardianArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  receiverId: Scalars['ID'];
  status?: InputMaybe<Array<ServiceRequestStatus>>;
};


export type QueryGetNetworkDashboardAsAdminArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetNetworkGraphDashboardAsAdminArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetNotificationArgs = {
  notificationId: Scalars['ID'];
};


export type QueryGetNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
};


export type QueryGetPackageArgs = {
  packageId: Scalars['ID'];
};


export type QueryGetPoliciesArgs = {
  type: PolicyType;
};


export type QueryGetPurchaseArgs = {
  purchaseId: Scalars['ID'];
};


export type QueryGetRandomExampleQuestionArgs = {
  excludeId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetReceiverArgs = {
  receiverId: Scalars['ID'];
};


export type QueryGetReceiverAgeRatioGraphArgs = {
  receiverId: Scalars['ID'];
  targetGender: Gender;
};


export type QueryGetReceiverCareGradeRatioGraphArgs = {
  receiverId: Scalars['ID'];
  targetAge: Scalars['String'];
  targetGender: Gender;
};


export type QueryGetReceiverDailyReportMediasAsCaregiverArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['String']>;
  receiverId: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};


export type QueryGetReceiverDailyReportMediasAsGuardianArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['String']>;
  receiverId: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};


export type QueryGetReceiverDiseaseCategoryQuestionsArgs = {
  receiverId: Scalars['String'];
  recordQuestionCategoryId: Scalars['String'];
};


export type QueryGetReceiverDiseaseRatioGraphArgs = {
  receiverId: Scalars['ID'];
  targetAge: Scalars['String'];
  targetGender: Gender;
};


export type QueryGetReceiverExcretionRatioGraphArgs = {
  receiverId: Scalars['String'];
  targetAge: Scalars['String'];
  targetGender: Gender;
};


export type QueryGetReceiverGenderRatioGraphArgs = {
  receiverId: Scalars['ID'];
  targetAge: Scalars['String'];
};


export type QueryGetReceiverKeywordsArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
};


export type QueryGetReceiverPuRatioGraphArgs = {
  receiverId: Scalars['ID'];
  targetAge: Scalars['String'];
  targetGender: Gender;
};


export type QueryGetReceiverRecordArgs = {
  recordId: Scalars['ID'];
};


export type QueryGetReceiverRecordsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  range: RangeInput;
  receiverId: Scalars['ID'];
};


export type QueryGetReceiverRecordsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  receiverId: Scalars['String'];
};


export type QueryGetReceiverWeeklyReportArgs = {
  categoryId: Scalars['String'];
  endDate?: InputMaybe<Scalars['String']>;
  measure: Scalars['Int'];
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  week: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetReceiverWeeklyReportWithTotalCommentArgs = {
  categoryMeasures: Array<CategoryMeasure>;
  endDate?: InputMaybe<Scalars['String']>;
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  week: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetReceiversAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  cityId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
  stateId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetRecordQuestionArgs = {
  receiverId: Scalars['String'];
};


export type QueryGetReferralNetworkUserAsAdminArgs = {
  caregiverId?: InputMaybe<Scalars['String']>;
  guardianId?: InputMaybe<Scalars['String']>;
};


export type QueryGetReferralNetworkUsersAsAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  networkUserSearchType?: InputMaybe<NetworkUserSearchType>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<NetworkUserSortKey>;
};


export type QueryGetReferralNetworkUsersRankAsAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<NetworkUserRankSortKey>;
};


export type QueryGetRegistrationNumberFromBase64Args = {
  base64: Scalars['String'];
  format: Scalars['String'];
  name: Scalars['String'];
};


export type QueryGetRelationWithReceiverAsGuardianArgs = {
  receiverId: Scalars['ID'];
};


export type QueryGetReportReasonsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ReportReasonType>;
};


export type QueryGetReportsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetResignedUsersAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ResignationUserType>;
};


export type QueryGetServiceArgs = {
  serviceId: Scalars['String'];
};


export type QueryGetServiceRequestArgs = {
  serviceRequestId: Scalars['ID'];
};


export type QueryGetTicketsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  receiverId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetTodayPopularCaregiverCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetTodayPopularVideoContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetTodaysWorkHourArgs = {
  range: RangeInput;
  receiverId: Scalars['ID'];
};


export type QueryGetUserCountsAsAdminArgs = {
  range?: InputMaybe<RangeInput>;
};


export type QueryGetUserIncentivesAsAdminArgs = {
  caregiverId?: InputMaybe<Scalars['ID']>;
  guardianId?: InputMaybe<Scalars['ID']>;
  limit: Scalars['Int'];
  month: Scalars['Int'];
  page: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetUserPointTransactionsAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  guardianId?: InputMaybe<Scalars['ID']>;
  range?: InputMaybe<RangeInput>;
};


export type QueryGetVideoContentArgs = {
  videoContentId: Scalars['ID'];
};


export type QueryGetVideoContentRepliesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  videoContentId: Scalars['String'];
};


export type QueryGetVideoContentReplyArgs = {
  id: Scalars['String'];
};


export type QueryGetVideoContentReplyCommentArgs = {
  videoContentReplyCommentId: Scalars['String'];
};


export type QueryGetVideoContentReplyCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first: Scalars['Int'];
  videoContentReplyId: Scalars['String'];
};


export type QueryGetVideoContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryGetVideoContentsAsAdminArgs = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<VideoContentSortKey>;
  videoContentSearchType?: InputMaybe<VideoContentSearchType>;
};


export type QueryGetWeeklyReceiverMeasuresArgs = {
  endDate?: InputMaybe<Scalars['String']>;
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  week: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetWeeklyReceiverMediumRecordsAsAdminArgs = {
  largeCategory: Scalars['String'];
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  week: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetWeeklyReceiverRecordCountAsAdminArgs = {
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  type: Scalars['String'];
  week: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetWeeklyReceiverSmallRecordsAsAdminArgs = {
  largeCategory: Scalars['String'];
  month: Scalars['Int'];
  receiverId: Scalars['String'];
  week: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryGetWelfareContentAsAdminArgs = {
  welfareContentId: Scalars['String'];
};


export type QueryGetWelfareContentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<WelfareContentSearchType>;
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']>>;
  welfareTypeId?: InputMaybe<Scalars['String']>;
};


export type QueryGetWelfareContentsAsAdminArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<WelfareContentSearchType>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<WelfareContentSortKey>;
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetWorkHoursArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  range: RangeInput;
  receiverId: Scalars['ID'];
};


export type QueryGetWorkHoursAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  caregiverId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<RangeInput>;
  receiverId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetYoutubeVideosAsAdminArgs = {
  endCursor?: InputMaybe<Scalars['String']>;
  limit: Scalars['Int'];
};


export type QuerySearchCaregiversAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
  query?: InputMaybe<Scalars['String']>;
};


export type QuerySearchGuardiansAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
  query: Scalars['String'];
};


export type QuerySearchMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  chatId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchReceiversArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySearchReceiversAsAdminArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
  query: Scalars['String'];
};


export type QuerySendVerifyCodeArgs = {
  phone: Scalars['String'];
};

export type RangeInput = {
  /** 시작 시간 */
  from: Scalars['String'];
  /** 종료 시간 */
  to: Scalars['String'];
};

/** 수급자 */
export type Receiver = {
  __typename?: 'Receiver';
  /** 주소 */
  address?: Maybe<Scalars['String']>;
  /** 상세 주소 */
  addressDetail?: Maybe<Scalars['String']>;
  avatar?: Maybe<Media>;
  avatarId?: Maybe<Scalars['String']>;
  careGrade?: Maybe<CareGrade>;
  careGradeId: Scalars['String'];
  caregivers?: Maybe<Array<CaregiverReceiver>>;
  city?: Maybe<City>;
  /** cityId */
  cityId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dailyReport?: Maybe<CheckDailyReport>;
  /** 생년월일 */
  dateOfBirth: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  diseases?: Maybe<Array<ReceiverDisease>>;
  /** 성별 */
  gender: Gender;
  guardians?: Maybe<Array<GuardianReceiver>>;
  /** 동거가족 유무 */
  hasCohabitingFamily: Scalars['Boolean'];
  /** pk */
  id: Scalars['String'];
  /** 이슈 */
  issue?: Maybe<Scalars['String']>;
  lastRecordAt?: Maybe<Scalars['DateTime']>;
  /** 수급자 이름 */
  name: Scalars['String'];
  /** 전화번호 */
  phone?: Maybe<Scalars['String']>;
  receiverLivingStyle?: Maybe<CommonCode>;
  receiverLivingStyleId?: Maybe<Scalars['String']>;
  registrationMedia?: Maybe<Media>;
  registrationMediaId: Scalars['String'];
  /** 등급 인정서 번호 */
  registrationNumber?: Maybe<Scalars['String']>;
  state?: Maybe<State>;
  stateId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  /** x좌표 */
  x?: Maybe<Scalars['String']>;
  /** y좌표 */
  y?: Maybe<Scalars['String']>;
};

export type ReceiverAgeRatioGraph = {
  __typename?: 'ReceiverAgeRatioGraph';
  ageGroup: Array<AgeGroup>;
  receiverAge: Scalars['Int'];
};

export type ReceiverCareGradeRatioGraph = {
  __typename?: 'ReceiverCareGradeRatioGraph';
  careGradeGroup: Array<CareGradeGroup>;
};

export type ReceiverConnection = {
  __typename?: 'ReceiverConnection';
  edges: Array<Receiver>;
  pageInfo: PageInfo;
};

export type ReceiverDisease = {
  __typename?: 'ReceiverDisease';
  disease: Disease;
  diseaseId: Scalars['String'];
  id: Scalars['String'];
  receiver: Receiver;
  receiverId: Scalars['String'];
};

export type ReceiverDiseaseRatioGraph = {
  __typename?: 'ReceiverDiseaseRatioGraph';
  diseaseGroup: Array<DiseaseGroup>;
};

export type ReceiverExcretionRatioGraph = {
  __typename?: 'ReceiverExcretionRatioGraph';
  getExcretionPickSmallCategories: Array<GetPickSmallCategories>;
  hasRatio: Scalars['String'];
  isInReceiverGroup: Scalars['Boolean'];
  notHasRatio: Scalars['String'];
};

export type ReceiverGenderRatioGraph = {
  __typename?: 'ReceiverGenderRatioGraph';
  femaleRatio: Scalars['String'];
  maleRatio: Scalars['String'];
  receiverGender: Scalars['String'];
};

export type ReceiverInput = {
  address?: InputMaybe<Scalars['String']>;
  addressDetail?: InputMaybe<Scalars['String']>;
  /** avatar */
  avatarInput?: InputMaybe<MediaInput>;
  /** 장기요양등급 Id */
  careGradeId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  dateOfBirth: Scalars['String'];
  /** 질병 Ids */
  diseaseIds?: InputMaybe<Array<Scalars['String']>>;
  gender: Gender;
  /** 동거 가족 유무 */
  hasCohabitingFamily?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receiverLivingStyleId?: InputMaybe<Scalars['String']>;
  /** 등급 인정서 사진 */
  registrationMediaInput?: InputMaybe<MediaInput>;
  /** 등급 번호 */
  registrationNumber?: InputMaybe<Scalars['String']>;
  relationId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  x?: InputMaybe<Scalars['String']>;
  y?: InputMaybe<Scalars['String']>;
};

export type ReceiverMeasureComment = {
  __typename?: 'ReceiverMeasureComment';
  comment: Scalars['String'];
};

export type ReceiverMeasureTotalComment = {
  __typename?: 'ReceiverMeasureTotalComment';
  categoryComments: Array<CategoryComments>;
  /** 총평 */
  totalComment: Scalars['String'];
};

export type ReceiverMediumRecordData = {
  __typename?: 'ReceiverMediumRecordData';
  largeCategory: Scalars['String'];
  mediumCategory: Scalars['String'];
  totalComment: Scalars['String'];
  weeklyReportTotalCommentId: Scalars['Int'];
};

export type ReceiverPuRatioGraph = {
  __typename?: 'ReceiverPuRatioGraph';
  getPuPickSmallCategories?: Maybe<Array<GetPickSmallCategories>>;
  hasRatio: Scalars['String'];
  isInReceiverGroup: Scalars['Boolean'];
  notHasRatio: Scalars['String'];
};

export type ReceiverRecord = {
  __typename?: 'ReceiverRecord';
  author: Caregiver;
  authorId: Scalars['String'];
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  media?: Maybe<Array<Media>>;
  receiver: Receiver;
  receiverId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ReceiverRecordConnection = {
  __typename?: 'ReceiverRecordConnection';
  edges: Array<ReceiverRecord>;
  pageInfo: PageInfo;
};

export type ReceiverRecordCount = {
  __typename?: 'ReceiverRecordCount';
  count: Scalars['String'];
  largeCategory: Scalars['String'];
};

export type ReceiverRecordInput = {
  authorId?: InputMaybe<Scalars['ID']>;
  body: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  mediaInputs?: InputMaybe<Array<MediaInput>>;
  receiverId?: InputMaybe<Scalars['ID']>;
};

export type ReceiverRecordMedia = {
  __typename?: 'ReceiverRecordMedia';
  id: Scalars['String'];
  mediaId: Scalars['String'];
  receiverRecordId: Scalars['String'];
};

export type ReceiverSmallRecordData = {
  __typename?: 'ReceiverSmallRecordData';
  categoryId: Scalars['String'];
  comment: Scalars['String'];
  largeCategory: Scalars['String'];
  measure: Scalars['Int'];
  mediumCategory: Scalars['String'];
  recordHistoryId: Scalars['String'];
  smallCategory: Scalars['String'];
};

export type ReceiverStatus = {
  __typename?: 'ReceiverStatus';
  comment: Scalars['String'];
};

/** 질문 예상 답변 */
export type RecordExampleAnswer = {
  __typename?: 'RecordExampleAnswer';
  /** 답변 */
  answer: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  recordQuestionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** 돌봄 기록 히스토리 */
export type RecordHistory = {
  __typename?: 'RecordHistory';
  /** 답변 */
  answer?: Maybe<Scalars['String']>;
  /** 답변 AI 코멘트 */
  answerComment?: Maybe<Scalars['String']>;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  dailyReportId: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  /** 측정 */
  measure?: Maybe<Scalars['Int']>;
  receiverId: Scalars['String'];
  recordQuestion?: Maybe<RecordQuestion>;
  recordQuestionId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** 돌봄 기록 질문 */
export type RecordQuestion = {
  __typename?: 'RecordQuestion';
  createdAt: Scalars['DateTime'];
  diseaseId?: Maybe<Scalars['String']>;
  /** 질병 질문 중 질병 여부 */
  hasDisease?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  /** 정보 질문 여부 */
  isInformationQuestion: Scalars['Boolean'];
  /** 측정 질문 여부 */
  isMeasureQuestion: Scalars['Boolean'];
  /** 측정 타입 */
  measureType?: Maybe<Scalars['String']>;
  /** 질문 */
  question: Scalars['String'];
  recordExampleAnswer?: Maybe<RecordExampleAnswer>;
  recordHistories?: Maybe<Array<RecordHistory>>;
  recordQuestionCategoryId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type RecordQuestionAnswerComment = {
  __typename?: 'RecordQuestionAnswerComment';
  /** 돌봄기록 답변 코멘트 */
  comment: Scalars['String'];
};

/** 가족 관계 */
export type Relation = {
  __typename?: 'Relation';
  /** 활성화 여부 */
  active: Scalars['Boolean'];
  id: Scalars['String'];
  /** 가족 관계 이름 */
  name: Scalars['String'];
  /** 정렬 순서 */
  sort: Scalars['Int'];
};

/** 관계 상태 */
export enum RelationStatus {
  /** 확인 */
  Confirmed = 'CONFIRMED',
  /** 대기 */
  Waiting = 'WAITING'
}

/** 신고 */
export type Report = {
  __typename?: 'Report';
  caregiver?: Maybe<Caregiver>;
  caregiverId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  /** 신고  사유 */
  customReason?: Maybe<Scalars['String']>;
  guardian?: Maybe<Guardian>;
  guardianId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  reason?: Maybe<CommonCode>;
  reasonId?: Maybe<Scalars['String']>;
  reportedTargetId?: Maybe<Scalars['String']>;
  reportedTargetType: CommonCode;
  reportedTargetTypeId?: Maybe<Scalars['String']>;
  statusId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ReportConnection = {
  __typename?: 'ReportConnection';
  edges: Array<Report>;
  pageInfo: PageInfo;
};

export type ReportInput = {
  customReason?: InputMaybe<Scalars['String']>;
  reasonId?: InputMaybe<Scalars['ID']>;
  reportedTargetId?: InputMaybe<Scalars['ID']>;
  reportedTargetTypeId?: InputMaybe<Scalars['ID']>;
};

/** 신고 사유 */
export type ReportReason = {
  __typename?: 'ReportReason';
  /** 활성화 여부 */
  active: Scalars['Boolean'];
  id: Scalars['String'];
  /** 신고 사유 */
  reason: Scalars['String'];
  /** 타입 */
  type: Scalars['String'];
};

/** 신고 사유 타입 */
export enum ReportReasonType {
  /** 보호사 신고 */
  Caregiver = 'CAREGIVER',
  /** 케어그룹 게시글 신고 */
  CaregiverCommunity = 'CAREGIVER_COMMUNITY',
  /** 케어그룹 게시글 댓글 신고 */
  CaregiverCommunityReply = 'CAREGIVER_COMMUNITY_REPLY',
  /** 케어그룹 정보글 댓글 신고 */
  CaregiverInfoReply = 'CAREGIVER_INFO_REPLY'
}

export type RequestServiceAsGuardianDto = {
  caregiverId: Scalars['ID'];
  /** 메세지 */
  message?: InputMaybe<Scalars['String']>;
  /** 가격 */
  price?: InputMaybe<Scalars['Int']>;
  receiverId: Scalars['ID'];
  /** 서비스 수행 시간 */
  serviceAt?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['ID']>;
  /** 서비스 요청 타입 */
  type: ServiceRequestType;
};

/** 사직 */
export type Resignation = {
  __typename?: 'Resignation';
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  guardian: Guardian;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  /** 사유 */
  reason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ResignationConnect = {
  __typename?: 'ResignationConnect';
  edges: Array<Resignation>;
  pageInfo: PageInfo;
};

/** The type of user that resigned */
export enum ResignationUserType {
  /** The type of user that resigned */
  Caregiver = 'Caregiver',
  /** The type of user that resigned */
  Guardian = 'Guardian'
}

/** 권한 */
export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** 보호사 / 어드민 */
export enum SearchType {
  /** 보호사 */
  Caregiver = 'CAREGIVER',
  /** 수급자 */
  Receiver = 'RECEIVER'
}

/** 서비스 */
export type Service = {
  __typename?: 'Service';
  /** 서비스 활성화 여부 */
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  /** 서비스 명 */
  name: Scalars['String'];
  /** 서비스 가격 */
  price: Scalars['Int'];
  /** 서비스 요약 */
  summary: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** 서비스 요청 */
export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  guardian: Guardian;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  /** 서비스 요청 메세지 */
  message: Scalars['String'];
  /** 서비스 요청 가격 */
  price: Scalars['Int'];
  receiver: Receiver;
  receiverId: Scalars['String'];
  service?: Maybe<Service>;
  /** 서비스 요청 날짜 */
  serviceAt: Scalars['String'];
  serviceId?: Maybe<Scalars['String']>;
  /** 서비스 요청 상태 */
  status: ServiceRequestStatus;
  /** 서비스 요청 타입 */
  type: ServiceRequestType;
  updatedAt: Scalars['DateTime'];
};

export type ServiceRequestConnection = {
  __typename?: 'ServiceRequestConnection';
  edges: Array<ServiceRequest>;
  pageInfo: PageInfo;
};

/** 서비스 요청 상태 */
export enum ServiceRequestStatus {
  /** 서비스 수락 */
  ServiceAccepted = 'SERVICE_ACCEPTED',
  /** 서비스 취소 */
  ServiceCancelled = 'SERVICE_CANCELLED',
  /** 서비스 완료 */
  ServiceDone = 'SERVICE_DONE',
  /** 서비스 거절 */
  ServiceRejected = 'SERVICE_REJECTED',
  /** 서비스 알림 */
  ServiceReminded = 'SERVICE_REMINDED',
  /** 서비스 요청 */
  ServiceRequested = 'SERVICE_REQUESTED',
  /** 팁 수락 */
  TipAccepted = 'TIP_ACCEPTED',
  /** 팁 취소 */
  TipCancelled = 'TIP_CANCELLED',
  /** 팁 거절 */
  TipRejected = 'TIP_REJECTED',
  /** 팁 요청 */
  TipRequested = 'TIP_REQUESTED'
}

/** 시군구 */
export type State = {
  __typename?: 'State';
  /** 시군구 아이디 */
  id: Scalars['String'];
  /** 시군구 이름 */
  name: Scalars['String'];
  /** 시군구 코드 */
  stateCode?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  newMessage: Message;
  notificationEvent: NotificationEvent;
  updateChat: Chat;
  updateChatUser: ChatUser;
};


export type SubscriptionNewMessageArgs = {
  chatId: Scalars['String'];
};

export type SystemMessage = {
  __typename?: 'SystemMessage';
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['String'];
  chat: Chat;
  chatId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 마지막 커서 */
  endCursor?: Maybe<Scalars['String']>;
  guardian?: Maybe<Guardian>;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  media?: Maybe<Media>;
  mediaId: Scalars['String'];
  serviceRequest?: Maybe<ServiceRequest>;
  serviceRequestId?: Maybe<Scalars['String']>;
  /** 처음 커서 */
  startCursor?: Maybe<Scalars['String']>;
  /** 메세지 */
  text?: Maybe<Scalars['String']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  body: Scalars['String'];
  caregiver?: Maybe<Caregiver>;
  caregiverId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  guardian?: Maybe<Guardian>;
  guardianId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  receiver: Receiver;
  receiverId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TicketConnection = {
  __typename?: 'TicketConnection';
  edges: Array<Ticket>;
  pageInfo: PageInfo;
};

export type TokenExpiryTimes = {
  __typename?: 'TokenExpiryTimes';
  access?: Maybe<Scalars['String']>;
  refresh?: Maybe<Scalars['String']>;
};

export type UpdateAdminUserDto = {
  adminId: Scalars['String'];
  adminRoleId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateAnnouncementAsAdminDto = {
  active: Scalars['Boolean'];
  body: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  onBanner: Scalars['Boolean'];
  summary?: InputMaybe<Scalars['String']>;
  thumbnailMediaInput?: InputMaybe<MediaInput>;
  title: Scalars['String'];
};

export type UpdateBannerAsAdminDto = {
  description?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  linkTypeId?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
  statusId?: InputMaybe<Scalars['String']>;
  thumbnailMediaInput?: InputMaybe<MediaInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCommonCodeDto = {
  /** 공통 코드 코드 */
  code?: InputMaybe<Scalars['String']>;
  /** 공통 코드 그룹 ID */
  commonCodeGroupId?: InputMaybe<Scalars['String']>;
  /** 공통 코드 ID */
  id: Scalars['String'];
  /** 공통 코드 이름 */
  name?: InputMaybe<Scalars['String']>;
  /** 공통 코드 상태 */
  status?: InputMaybe<CommonCodeStatus>;
};

export type UpdateCommonCodeGroupDto = {
  groupCode?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CommonCodeGroupStatus>;
};

export type UpdateManagementAsAdminDto = {
  address?: InputMaybe<Scalars['String']>;
  ceoName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  copyright?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  escroRegistration?: InputMaybe<Scalars['String']>;
  invitationPoint: Scalars['Int'];
  kakaoAddress?: InputMaybe<Scalars['String']>;
  minimumTip: Scalars['Int'];
  paymentInformation?: InputMaybe<Scalars['String']>;
  paymentWarning?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  registrationNumber?: InputMaybe<Scalars['String']>;
  shopAddress?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyDto = {
  body: Scalars['String'];
  type: PolicyType;
};

export type UpdateRelationAsAdminDto = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  sort: Scalars['Int'];
};

export type UpdateReportReasonAsAdminDto = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  type: ReportReasonType;
};

export type UpdateServiceAsAdminDto = {
  active: Scalars['Boolean'];
  id: Scalars['String'];
  name: Scalars['String'];
  price: Scalars['Int'];
  summary: Scalars['String'];
};

export type UserCounts = {
  __typename?: 'UserCounts';
  caregiverCount: Scalars['Int'];
  guardianCount: Scalars['Int'];
  receiverCount: Scalars['Int'];
  resignedUsersCount: Scalars['Int'];
};

export type UserMessage = {
  __typename?: 'UserMessage';
  caregiver?: Maybe<Caregiver>;
  caregiverId: Scalars['String'];
  chat: Chat;
  chatId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 마지막 커서 */
  endCursor?: Maybe<Scalars['String']>;
  guardian?: Maybe<Guardian>;
  guardianId: Scalars['String'];
  id: Scalars['String'];
  media?: Maybe<Media>;
  mediaId: Scalars['String'];
  serviceRequest?: Maybe<ServiceRequest>;
  serviceRequestId?: Maybe<Scalars['String']>;
  /** 처음 커서 */
  startCursor?: Maybe<Scalars['String']>;
  /** 메세지 */
  text?: Maybe<Scalars['String']>;
};

export type VideoContent = {
  __typename?: 'VideoContent';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isLiked?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  media: Media;
  mediaId: Scalars['String'];
  playTime: Scalars['String'];
  replyCount: Scalars['Int'];
  status: CommonCode;
  statusId: Scalars['String'];
  title: Scalars['String'];
  totalScore?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  videoContentCategory: CommonCode;
  videoContentCategoryId: Scalars['String'];
  viewCount?: Maybe<Scalars['Int']>;
  youtubeUrl: Scalars['String'];
};

export type VideoContentConnection = {
  __typename?: 'VideoContentConnection';
  edges: Array<VideoContent>;
  pageInfo: PageInfo;
};

export type VideoContentLike = {
  __typename?: 'VideoContentLike';
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  videoContentId: Scalars['String'];
};

/** 비디오 컨텐츠 댓글 */
export type VideoContentReply = {
  __typename?: 'VideoContentReply';
  author: Caregiver;
  authorId: Scalars['String'];
  /** 내용 */
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isLiked?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  replyCommentCount: Scalars['Int'];
  replyComments: Array<VideoContentReplyComment>;
  updatedAt: Scalars['DateTime'];
  videoContentId: Scalars['String'];
};

export type VideoContentReplyComment = {
  __typename?: 'VideoContentReplyComment';
  author: Caregiver;
  body: Scalars['String'];
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  isLiked?: Maybe<Scalars['Boolean']>;
  likeCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  videoContentReplyId: Scalars['String'];
};

export type VideoContentReplyCommentConnection = {
  __typename?: 'VideoContentReplyCommentConnection';
  edges: Array<VideoContentReplyComment>;
  pageInfo: PageInfo;
};

export type VideoContentReplyCommentLike = {
  __typename?: 'VideoContentReplyCommentLike';
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  videoContentReplyCommentId: Scalars['String'];
};

export type VideoContentReplyConnection = {
  __typename?: 'VideoContentReplyConnection';
  edges: Array<VideoContentReply>;
  pageInfo: PageInfo;
};

export type VideoContentReplyLike = {
  __typename?: 'VideoContentReplyLike';
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  videoContentReplyId: Scalars['String'];
};

/** 비디오 컨텐츠 검색 타입 */
export enum VideoContentSearchType {
  /** 상태 */
  Status = 'STATUS',
  /** 제목 */
  Title = 'TITLE'
}

/** 비디오 컨텐츠 정렬 키 */
export enum VideoContentSortKey {
  /** 카테고리 */
  Category = 'CATEGORY',
  /** 생성일 */
  CreatedAt = 'CREATED_AT',
  /** 재생 시간 */
  Playtime = 'PLAYTIME',
  /** 상태 */
  Status = 'STATUS',
  /** 제목 */
  Title = 'TITLE',
  /** 조회수 */
  ViewCount = 'VIEW_COUNT'
}

export type WelfareContent = {
  __typename?: 'WelfareContent';
  /** 신청 방법 */
  applicationMethod?: Maybe<Scalars['String']>;
  /** 담당 정보 */
  contactInformation?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  detailPageUrl: Scalars['String'];
  id: Scalars['String'];
  /** 문의처 */
  inquiryPhone?: Maybe<Scalars['String']>;
  /** 복지서비스 상태값 */
  status?: Maybe<CommonCode>;
  statusId: Scalars['String'];
  /** 지원 주기 */
  supportCycle?: Maybe<Scalars['String']>;
  /** 제공 유형 */
  supportType?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  /** 복지서비스 카테고리 */
  welfareCategories?: Maybe<Array<CommonCode>>;
  /** 복지서비스 가족 유형 */
  welfareFamilyTypes?: Maybe<Array<CommonCode>>;
  /** 복지서비스 생애주기 */
  welfareLifeCycles?: Maybe<Array<CommonCode>>;
  /** 복지로 서비스 Id */
  welfareServiceId?: Maybe<Scalars['String']>;
  /** 복지서비스 타입 카테고리 */
  welfareType?: Maybe<CommonCode>;
  welfareTypeId: Scalars['String'];
};

export type WelfareContentConnection = {
  __typename?: 'WelfareContentConnection';
  edges: Array<WelfareContent>;
  pageInfo: PageInfo;
};

/** 복지서비스 검색 타입 */
export enum WelfareContentSearchType {
  /** 제목 */
  Title = 'TITLE'
}

/** 복지서비스 정렬 타입 */
export enum WelfareContentSortKey {
  /** 생성일 */
  CreatedAt = 'CREATED_AT',
  /** 상태 */
  Status = 'STATUS',
  /** 제목 */
  Title = 'TITLE'
}

/** 근무 시간 */
export type WorkHour = {
  __typename?: 'WorkHour';
  caregiver: Caregiver;
  caregiverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  /** 시작시간 */
  from?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  receiver: Receiver;
  receiverId: Scalars['String'];
  /** 종료 시간 */
  to?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type WorkHourConnection = {
  __typename?: 'WorkHourConnection';
  edges: Array<WorkHour>;
  pageInfo: PageInfo;
};

export type YoutubeVideo = {
  __typename?: 'YoutubeVideo';
  commentCount: Scalars['Int'];
  description: Scalars['String'];
  isInserted: Scalars['Boolean'];
  likeCount: Scalars['Int'];
  playTime: Scalars['String'];
  thumbnail: Scalars['String'];
  title: Scalars['String'];
  viewCount: Scalars['Int'];
  youtubeUrl: Scalars['String'];
};

export type YoutubeVideosConnection = {
  __typename?: 'YoutubeVideosConnection';
  edges: Array<YoutubeVideo>;
  pageInfo: PageInfo;
};

/** 서비스 요청  타입 */
export enum ServiceRequestType {
  /** 서비스 */
  Service = 'SERVICE',
  /** 팁 */
  Tip = 'TIP'
}

export type GetAdminUsersQueryVariables = Exact<{
  adminSearchType?: InputMaybe<AdminSearchType>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<AdminSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminUsersQuery = { __typename?: 'Query', getAdminUsers: { __typename?: 'AdminConnection', edges: Array<{ __typename?: 'Admin', adminRoleId: string, createdAt?: any | null, email: string, id: string, name: string, status: string, updatedAt?: any | null, adminRole: { __typename?: 'AdminRole', id: string, name: string } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } } };

export type GetMyAdminUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAdminUserQuery = { __typename?: 'Query', getMyAdminUser: { __typename?: 'Admin', id: string, email: string, name: string, password?: string | null, adminRoleId: string, status: string, createdAt?: any | null, updatedAt?: any | null, adminRole: { __typename?: 'AdminRole', name: string, id: string } } };

export type GetAdminUserQueryVariables = Exact<{
  adminId: Scalars['String'];
}>;


export type GetAdminUserQuery = { __typename?: 'Query', getAdminUser: { __typename?: 'Admin', id: string, email: string, name: string, adminRoleId: string, status: string, createdAt?: any | null, updatedAt?: any | null, adminRole: { __typename?: 'AdminRole', id: string, name: string } } };

export type GetAdminRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminRolesQuery = { __typename?: 'Query', getAdminRoles: Array<{ __typename?: 'AdminRole', id: string, name: string }> };

export type CreateAdminUserMutationVariables = Exact<{
  createAdminUserDto: CreateAdminUserDto;
}>;


export type CreateAdminUserMutation = { __typename?: 'Mutation', createAdminUser: { __typename?: 'Admin', adminRoleId: string, createdAt?: any | null, email: string, id: string, name: string, status: string, updatedAt?: any | null, adminRole: { __typename?: 'AdminRole', id: string, name: string } } };

export type DeleteAdminUserMutationVariables = Exact<{
  adminId: Scalars['String'];
}>;


export type DeleteAdminUserMutation = { __typename?: 'Mutation', deleteAdminUser: { __typename?: 'Admin', id: string, email: string, name: string, adminRoleId: string, status: string, createdAt?: any | null, updatedAt?: any | null, adminRole: { __typename?: 'AdminRole', name: string, id: string } } };

export type UpdateAdminUserMutationVariables = Exact<{
  updateAdminUserDto: UpdateAdminUserDto;
}>;


export type UpdateAdminUserMutation = { __typename?: 'Mutation', updateAdminUser: { __typename?: 'Admin', id: string } };

export type GetAnnouncementQueryVariables = Exact<{
  announcementId: Scalars['ID'];
}>;


export type GetAnnouncementQuery = { __typename?: 'Query', getAnnouncement: { __typename?: 'Announcement', id: string, title: string, summary?: string | null, body: string, active: boolean, onBanner: boolean, createdAt: any, updatedAt: any, thumbnailMedia?: { __typename?: 'Media', id: string, uri: string } | null } };

export type GetAnnouncementsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  onBanner?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetAnnouncementsQuery = { __typename?: 'Query', getAnnouncements: { __typename?: 'AnnouncementConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Announcement', id: string, title: string, summary?: string | null, body: string, active: boolean, onBanner: boolean, createdAt: any, updatedAt: any, thumbnailMedia?: { __typename?: 'Media', id: string, uri: string } | null }> } };

export type UpdateAnnouncementAsAdminMutationVariables = Exact<{
  announcementInput: UpdateAnnouncementAsAdminDto;
}>;


export type UpdateAnnouncementAsAdminMutation = { __typename?: 'Mutation', updateAnnouncementAsAdmin: { __typename?: 'Announcement', id: string, title: string, summary?: string | null, body: string, active: boolean, onBanner: boolean, createdAt: any, updatedAt: any, thumbnailMedia?: { __typename?: 'Media', id: string, uri: string } | null } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type SignInMutation = { __typename?: 'Mutation', signInAsAdmin: { __typename?: 'Admin', id: string, email: string, name: string, password?: string | null, adminRoleId: string, status: string, createdAt?: any | null, updatedAt?: any | null, adminRole: { __typename?: 'AdminRole', name: string, id: string } } };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', signOutAsAdmin: boolean };

export type GetBannerCountsAsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBannerCountsAsAdminQuery = { __typename?: 'Query', getBannersCountAsAdmin: { __typename?: 'BannerCount', activeCount: number, inactiveCount: number, reservedCount: number, totalCount: number } };

export type GetBannersAsAdminQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<BannerSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetBannersAsAdminQuery = { __typename?: 'Query', getBannersAsAdmin: { __typename?: 'BannerConnection', edges: Array<{ __typename?: 'Banner', id: string, title: string, description?: string | null, statusId?: string | null, linkTypeId?: string | null, clickCount?: number | null, linkUrl: string, startAt?: any | null, endAt: any, createdAt: any, updatedAt: any, thumbnailMediaId?: string | null, status?: { __typename?: 'CommonCode', code: string, id: string, name: string } | null, linkType?: { __typename?: 'CommonCode', name: string, id: string, code: string } | null, thumbnailMedia?: { __typename?: 'Media', id: string, thumbnailUri?: string | null, uri: string } | null }>, pageInfo: { __typename?: 'PageInfo', totalCount?: number | null } } };

export type GetBannerAsAdminQueryVariables = Exact<{
  bannerId: Scalars['String'];
}>;


export type GetBannerAsAdminQuery = { __typename?: 'Query', getBannerAsAdmin: { __typename?: 'Banner', clickCount?: number | null, createdAt: any, description?: string | null, endAt: any, id: string, linkTypeId?: string | null, linkUrl: string, startAt?: any | null, statusId?: string | null, updatedAt: any, title: string, thumbnailMediaId?: string | null, linkType?: { __typename?: 'CommonCode', id: string, name: string, code: string } | null, status?: { __typename?: 'CommonCode', code: string, id: string, name: string } | null, thumbnailMedia?: { __typename?: 'Media', name: string, id: string, thumbnailUri?: string | null, uri: string } | null } };

export type CreateBannerAsAdminMutationVariables = Exact<{
  createBannerAsAdminDto: CreateBannerAsAdminDto;
}>;


export type CreateBannerAsAdminMutation = { __typename?: 'Mutation', createBannerAsAdmin: { __typename?: 'Banner', updatedAt: any } };

export type UpdateBannerAsAdminMutationVariables = Exact<{
  updateBannerAsAdminDto: UpdateBannerAsAdminDto;
}>;


export type UpdateBannerAsAdminMutation = { __typename?: 'Mutation', updateBannerAsAdmin: { __typename?: 'Banner', updatedAt: any } };

export type DeleteBannerAsAdminMutationVariables = Exact<{
  bannerId: Scalars['String'];
}>;


export type DeleteBannerAsAdminMutation = { __typename?: 'Mutation', deleteBannerAsAdmin: { __typename?: 'Banner', id: string } };

export type GetCaregiversAsAdminQueryVariables = Exact<{
  gender?: InputMaybe<Gender>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCaregiversAsAdminQuery = { __typename?: 'Query', getCaregiversAsAdmin: { __typename?: 'CaregiverConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Caregiver', id: string, phone: string, gender: Gender, point: number, name: string, username?: string | null, dateOfBirth?: string | null, certificateNumber?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, certificateMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }> } };

export type GetCaregiverProfileQueryVariables = Exact<{
  caregiverId: Scalars['ID'];
}>;


export type GetCaregiverProfileQuery = { __typename?: 'Query', getCaregiverProfile: { __typename?: 'Caregiver', id: string, phone: string, email?: string | null, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, role?: { __typename?: 'Role', id: string, name: string } | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, certificateMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, receivers?: Array<{ __typename?: 'Receiver', id: string, name: string, phone?: string | null, registrationNumber?: string | null, dateOfBirth: any, gender: Gender, address?: string | null, addressDetail?: string | null, guardians?: Array<{ __typename?: 'GuardianReceiver', guardian: { __typename?: 'Guardian', id: string, phone: string, name: string, gender: Gender, username?: string | null, dateOfBirth?: string | null, point: number, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } }> | null }> | null } };

export type CreateCaregiverAsAdminMutationVariables = Exact<{
  phone: Scalars['String'];
  profileInput: ProfileInput;
  cityCodes: Array<Scalars['ID']> | Scalars['ID'];
  caregiverInput: CaregiverInput;
}>;


export type CreateCaregiverAsAdminMutation = { __typename?: 'Mutation', createCaregiverAsAdmin: { __typename?: 'Caregiver', id: string, name: string } };

export type ResignCaregiverAsAdminMutationVariables = Exact<{
  caregiverId: Scalars['ID'];
}>;


export type ResignCaregiverAsAdminMutation = { __typename?: 'Mutation', resignCaregiverAsAdmin: boolean };

export type GetWorkHoursAsAdminQueryVariables = Exact<{
  receiverId?: InputMaybe<Scalars['ID']>;
  caregiverId?: InputMaybe<Scalars['ID']>;
  range?: InputMaybe<RangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetWorkHoursAsAdminQuery = { __typename?: 'Query', getWorkHoursAsAdmin: { __typename?: 'WorkHourConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'WorkHour', id: string, createdAt: any, updatedAt: any, caregiver: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, point: number, createdAt: any, updatedAt: any }, receiver: { __typename?: 'Receiver', id: string, name: string, dateOfBirth: any, gender: Gender, createdAt: any, updatedAt: any, deletedAt?: any | null, registrationNumber?: string | null, phone?: string | null } }> } };

export type SearchCaregiversAsAdminQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SearchCaregiversAsAdminQuery = { __typename?: 'Query', searchCaregiversAsAdmin: { __typename?: 'CaregiverConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Caregiver', id: string, phone: string, gender: Gender, point: number, name: string, username?: string | null, dateOfBirth?: string | null, certificateNumber?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, certificateMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }> } };

export type UpdateCaregiverAsAdminMutationVariables = Exact<{
  caregiverId: Scalars['String'];
  phoneNumber: Scalars['String'];
  profileInput: ProfileInput;
  caregiverInput: CaregiverInput;
}>;


export type UpdateCaregiverAsAdminMutation = { __typename?: 'Mutation', updateCaregiverAsAdmin: { __typename?: 'Caregiver', id: string, phone: string, email?: string | null, name: string, updatedAt: any } };

export type GetChatsOrderByMessagesCountAsAdminQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetChatsOrderByMessagesCountAsAdminQuery = { __typename?: 'Query', getChatsOrderByMessagesCountAsAdmin: { __typename?: 'ChatConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Chat', id: string, chatId: string, createdAt: any, updatedAt: any, messageCount: number, hasUnreadMessage: boolean, receiver: { __typename?: 'Receiver', id: string, name: string, dateOfBirth: any, gender: Gender, createdAt: any, updatedAt: any }, users?: Array<{ __typename?: 'ChatUser', id: string, lastSeenAt: string, joinAt: string, caregiver?: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, guardian?: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, point: number, createdAt: any, updatedAt: any } | null }> | null }> } };

export type GetCommonCodeGroupsAsAdminQueryVariables = Exact<{
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<CommonCodeGroupSortKey>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  commonGroupCodeSearchType?: InputMaybe<CommonCodeGroupSearchType>;
}>;


export type GetCommonCodeGroupsAsAdminQuery = { __typename?: 'Query', getCommonCodeGroupsAsAdmin: { __typename?: 'CommonCodeGroupConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, startCursor?: string | null }, edges: Array<{ __typename?: 'CommonCodeGroup', id: string, groupCode: string, name: string, status: CommonCodeGroupStatus, createdAt: any, updatedAt: any, commonCodes: Array<{ __typename?: 'CommonCode', id: string, code: string, name: string, status: CommonCodeStatus, commonCodeGroupId: string, createdAt: any, updatedAt: any }> }> } };

export type GetCommonCodesAsAdminQueryVariables = Exact<{
  commonCodeGroupId: Scalars['String'];
  commonCodeSearchType?: InputMaybe<CommonCodeSearchType>;
  query?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<CommonCodeSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetCommonCodesAsAdminQuery = { __typename?: 'Query', getCommonCodesAsAdmin: { __typename?: 'CommonCodeConnection', edges: Array<{ __typename?: 'CommonCode', code: string, commonCodeGroupId: string, createdAt: any, id: string, name: string, status: CommonCodeStatus, updatedAt: any }>, pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null } } };

export type CreateCommonCodeGroupAsAdminMutationVariables = Exact<{
  createCommonCodeGroupInput: CreateCommonCodeGroupDto;
}>;


export type CreateCommonCodeGroupAsAdminMutation = { __typename?: 'Mutation', createCommonCodeGroupAsAdmin: { __typename?: 'CommonCodeGroup', id: string, name: string, status: CommonCodeGroupStatus } };

export type UpdateCommonCodeGroupAsAdminMutationVariables = Exact<{
  updateCommonCodeGroupInput: UpdateCommonCodeGroupDto;
}>;


export type UpdateCommonCodeGroupAsAdminMutation = { __typename?: 'Mutation', updateCommonCodeGroupAsAdmin: { __typename?: 'CommonCodeGroup', id: string, name: string, status: CommonCodeGroupStatus, groupCode: string } };

export type DeleteCommonCodeGroupAsAdminMutationVariables = Exact<{
  commonCodeGroupId: Scalars['String'];
}>;


export type DeleteCommonCodeGroupAsAdminMutation = { __typename?: 'Mutation', deleteCommonCodeGroupAsAdmin: { __typename?: 'CommonCodeGroup', id: string, name: string, status: CommonCodeGroupStatus, updatedAt: any, groupCode: string } };

export type DeleteCommonCodeAsAdminMutationVariables = Exact<{
  commonCodeId: Scalars['String'];
}>;


export type DeleteCommonCodeAsAdminMutation = { __typename?: 'Mutation', deleteCommonCodeAsAdmin: { __typename?: 'CommonCode', commonCodeGroupId: string, createdAt: any, id: string, name: string, status: CommonCodeStatus, updatedAt: any } };

export type UpdateCommonCodeAsAdminMutationVariables = Exact<{
  updateCommonCodeInput: UpdateCommonCodeDto;
}>;


export type UpdateCommonCodeAsAdminMutation = { __typename?: 'Mutation', updateCommonCodeAsAdmin: { __typename?: 'CommonCode', code: string, id: string, name: string, status: CommonCodeStatus, updatedAt: any, createdAt: any, commonCodeGroupId: string } };

export type CreateCommonCodeAsAdminMutationVariables = Exact<{
  createCommonCodeInput: CreateCommonCodeDto;
}>;


export type CreateCommonCodeAsAdminMutation = { __typename?: 'Mutation', createCommonCodeAsAdmin: { __typename?: 'CommonCode', code: string, commonCodeGroupId: string, createdAt: any, id: string, name: string, status: CommonCodeStatus, updatedAt: any } };

export type GetCommonCodeGroupAsAdminQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type GetCommonCodeGroupAsAdminQuery = { __typename?: 'Query', getCommonCodeGroupAsAdmin: { __typename?: 'CommonCodeGroup', id: string, name: string, status: CommonCodeGroupStatus, updatedAt: any, groupCode: string, createdAt: any } };

export type GetCommonCodeAsAdminQueryVariables = Exact<{
  commonCodeId: Scalars['String'];
}>;


export type GetCommonCodeAsAdminQuery = { __typename?: 'Query', getCommonCodeAsAdmin: { __typename?: 'CommonCode', code: string, commonCodeGroupId: string, createdAt: any, id: string, name: string, status: CommonCodeStatus, updatedAt: any } };

export type GetCommonCodeGroupsForSelectionAsAdminQueryVariables = Exact<{
  sortDirection?: InputMaybe<Scalars['String']>;
  sortKey?: InputMaybe<CommonCodeGroupSortKey>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  commonGroupCodeSearchType?: InputMaybe<CommonCodeGroupSearchType>;
}>;


export type GetCommonCodeGroupsForSelectionAsAdminQuery = { __typename?: 'Query', getCommonCodeGroupsAsAdmin: { __typename?: 'CommonCodeGroupConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null, startCursor?: string | null }, edges: Array<{ __typename?: 'CommonCodeGroup', id: string, groupCode: string, name: string }> } };

export type GetCommonCodeGroupsByTypeAsAdminQueryVariables = Exact<{
  types: Array<CommonCodeGroupType> | CommonCodeGroupType;
}>;


export type GetCommonCodeGroupsByTypeAsAdminQuery = { __typename?: 'Query', getCommonCodeGroupsByTypeAsAdmin: Array<{ __typename?: 'CommonCodeGroup', groupCode: string, id: string, name: string, activeCommonCodes: Array<{ __typename?: 'CommonCode', code: string, id: string, name: string }> }> };

export type GetCaregiverCommunitiesByTypeAsAdminQueryVariables = Exact<{
  type?: InputMaybe<CaregiverCommunityType>;
  range?: InputMaybe<RangeInput>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCaregiverCommunitiesByTypeAsAdminQuery = { __typename?: 'Query', getCaregiverCommunitiesByTypeAsAdmin: { __typename?: 'CaregiverCommunityConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CaregiverCommunity', id: string, body: string, type?: CaregiverCommunityType | null, replyCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, author: { __typename?: 'Caregiver', name: string, gender: Gender, email?: string | null, phone: string, id: string, point: number, updatedAt: any, createdAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }, media?: Array<{ __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null }> | null }> } };

export type GetCaregiverCommunitiesByAuthorAsAdminQueryVariables = Exact<{
  caregiverId: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCaregiverCommunitiesByAuthorAsAdminQuery = { __typename?: 'Query', getCaregiverCommunitiesByAuthorAsAdmin: { __typename?: 'CaregiverCommunityConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CaregiverCommunity', id: string, body: string, type?: CaregiverCommunityType | null, replyCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, author: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }, media?: Array<{ __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null }> | null }> } };

export type GetCaregiverCommunityRepliesByCommunityAsAdminQueryVariables = Exact<{
  communityId: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCaregiverCommunityRepliesByCommunityAsAdminQuery = { __typename?: 'Query', getCaregiverCommunityRepliesByCommunityAsAdmin: { __typename?: 'CaregiverCommunityReplyConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CaregiverCommunityReply', id: string, updatedAt: any, deletedAt?: any | null, createdAt: any, body?: string | null, author: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, point: number, createdAt: any, updatedAt: any, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } }> } };

export type DeleteCaregiverCommunityMutationVariables = Exact<{
  communityId: Scalars['ID'];
}>;


export type DeleteCaregiverCommunityMutation = { __typename?: 'Mutation', deleteCaregiverCommunity: { __typename?: 'CaregiverCommunity', id: string, body: string, type?: CaregiverCommunityType | null, replyCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, author: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } } };

export type GetYearlyCommunityTrendAsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYearlyCommunityTrendAsAdminQuery = { __typename?: 'Query', getYearlyCommunityTrendAsAdmin: Array<{ __typename?: 'CommunityCount', general: number, secret: number }> };

export type GetGuardianProfileQueryVariables = Exact<{
  guardianId: Scalars['String'];
}>;


export type GetGuardianProfileQuery = { __typename?: 'Query', getGuardianProfile: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null, role?: { __typename?: 'Role', id: string, name: string } | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, receivers?: Array<{ __typename?: 'Receiver', id: string, name: string, phone?: string | null, gender: Gender, address?: string | null, dateOfBirth: any, caregivers?: Array<{ __typename?: 'CaregiverReceiver', caregiver?: { __typename?: 'Caregiver', id: string, phone: string, email?: string | null, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } | null }> | null }> | null } };

export type SearchGuardiansAsAdminQueryVariables = Exact<{
  query: Scalars['String'];
  gender?: InputMaybe<Gender>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type SearchGuardiansAsAdminQuery = { __typename?: 'Query', searchGuardiansAsAdmin: { __typename?: 'GuardianConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }> } };

export type GetGuardiansAsAdminQueryVariables = Exact<{
  gender?: InputMaybe<Gender>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetGuardiansAsAdminQuery = { __typename?: 'Query', getGuardiansAsAdmin: { __typename?: 'GuardianConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }> } };

export type ResignGuardianAsAdminMutationVariables = Exact<{
  guardianId: Scalars['String'];
}>;


export type ResignGuardianAsAdminMutation = { __typename?: 'Mutation', resignGuardianAsAdmin: boolean };

export type CreateGuardianAsAdminMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  profileInput: ProfileInput;
}>;


export type CreateGuardianAsAdminMutation = { __typename?: 'Mutation', createGuardianAsAdmin: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, point: number, createdAt: any, updatedAt: any } };

export type UpdateGuardianAsAdminMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
  guardianId: Scalars['String'];
  profileInput: ProfileInput;
}>;


export type UpdateGuardianAsAdminMutation = { __typename?: 'Mutation', updateGuardianAsAdmin: { __typename?: 'Guardian', id: string, phone: string, name: string, updatedAt: any } };

export type UpdateCaregiverInfoAsAdminMutationVariables = Exact<{
  caregiverInfoInput: CaregiverInfoInput;
}>;


export type UpdateCaregiverInfoAsAdminMutation = { __typename?: 'Mutation', updateCaregiverInfoAsAdmin: { __typename?: 'CaregiverInfo', id: string, body: string, title: string, summary: string, createdAt: any, media: Array<{ __typename?: 'Media', id: string, uri: string }>, cities: Array<{ __typename?: 'City', cityCode?: string | null, name: string, state: { __typename?: 'State', stateCode?: string | null, name: string } }> } };

export type GetCaregiverInfosQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  cityCodes?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetCaregiverInfosQuery = { __typename?: 'Query', getCaregiverInfos: { __typename?: 'CaregiverInfoConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CaregiverInfo', id: string, body: string, title: string, summary: string, replyCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, media: Array<{ __typename?: 'Media', id: string, uri: string }>, cities: Array<{ __typename?: 'City', cityCode?: string | null, name: string, state: { __typename?: 'State', stateCode?: string | null, name: string } }> }> } };

export type GetCaregiverInfoQueryVariables = Exact<{
  infoId: Scalars['ID'];
}>;


export type GetCaregiverInfoQuery = { __typename?: 'Query', getCaregiverInfo: { __typename?: 'CaregiverInfo', id: string, body: string, title: string, summary: string, replyCount: number, createdAt: any, updatedAt: any, deletedAt?: any | null, media: Array<{ __typename?: 'Media', id: string, uri: string }>, cities: Array<{ __typename?: 'City', cityCode?: string | null, name: string, state: { __typename?: 'State', stateCode?: string | null, name: string } }> } };

export type DeleteCaregiverInfoAsAdminMutationVariables = Exact<{
  infoId: Scalars['ID'];
}>;


export type DeleteCaregiverInfoAsAdminMutation = { __typename?: 'Mutation', deleteCaregiverInfoAsAdmin: { __typename?: 'CaregiverInfo', id: string, replyCount: number, createdAt: any, updatedAt: any } };

export type DeleteCaregiverInfoMediaMutationVariables = Exact<{
  infoId: Scalars['ID'];
  mediaId: Scalars['ID'];
}>;


export type DeleteCaregiverInfoMediaMutation = { __typename?: 'Mutation', deleteCaregiverInfoMedia: { __typename?: 'CaregiverInfo', id: string, media: Array<{ __typename?: 'Media', id: string, uri: string }> } };

export type GetLatestPolicyQueryVariables = Exact<{
  type: PolicyType;
}>;


export type GetLatestPolicyQuery = { __typename?: 'Query', getLatestPolicy: { __typename?: 'Policy', id: string, type: string, body: string, createdAt: any } };

export type UpdatePolicyAsAdminMutationVariables = Exact<{
  policyInput: UpdatePolicyDto;
}>;


export type UpdatePolicyAsAdminMutation = { __typename?: 'Mutation', updatePolicyAsAdmin: { __typename?: 'Policy', id: string, type: string, body: string, createdAt: any } };

export type GetManagementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManagementQuery = { __typename?: 'Query', getManagement: { __typename?: 'Management', id: number, companyName: string, address: string, copyright: string, email: string, ceoName: string, registrationNumber: string, escroRegistration: string, paymentWarning?: string | null, paymentInformation?: string | null, phone: string, kakaoAddress: string, minimumTip: string, invitationPoint: number, shopAddress: string } };

export type UpdateManagementAsAdminMutationVariables = Exact<{
  managementInput: UpdateManagementAsAdminDto;
}>;


export type UpdateManagementAsAdminMutation = { __typename?: 'Mutation', updateManagementAsAdmin: { __typename?: 'Management', id: number, companyName: string, address: string, copyright: string, email: string, ceoName: string, registrationNumber: string, escroRegistration: string, phone: string, kakaoAddress: string, minimumTip: string, invitationPoint: number, shopAddress: string } };

export type GetPoliciesQueryVariables = Exact<{
  type: PolicyType;
}>;


export type GetPoliciesQuery = { __typename?: 'Query', getPolicies: Array<{ __typename?: 'Policy', id: string, type: string, body: string, createdAt: any }> };

export type GetCafe24TokenExpiryTimesAsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCafe24TokenExpiryTimesAsAdminQuery = { __typename?: 'Query', getCafe24TokenExpiryTimesAsAdmin: { __typename?: 'TokenExpiryTimes', refresh?: string | null, access?: string | null } };

export type GetReferralNetworkUsersAsAdminQueryVariables = Exact<{
  networkUserSearchType?: InputMaybe<NetworkUserSearchType>;
  query?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<NetworkUserSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetReferralNetworkUsersAsAdminQuery = { __typename?: 'Query', getReferralNetworkUsersAsAdmin: { __typename?: 'InvitationConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null }, edges: Array<{ __typename?: 'Invitation', id?: string | null, totalNetworkRewardPoint?: number | null, totalNetworkUserCount?: number | null, createdAt: any, deletedAt?: any | null, caregiver?: { __typename?: 'Caregiver', id: string, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null } | null, guardian?: { __typename?: 'Guardian', id: string, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null } | null }> } };

export type GetReferralNetworkUserAsAdminQueryVariables = Exact<{
  caregiverId?: InputMaybe<Scalars['String']>;
  guardianId?: InputMaybe<Scalars['String']>;
}>;


export type GetReferralNetworkUserAsAdminQuery = { __typename?: 'Query', getReferralNetworkUserAsAdmin: { __typename?: 'Invitation', id?: string | null, totalNetworkUserCount?: number | null, totalNetworkRewardPoint?: number | null, updatedAt: any, caregiver?: { __typename?: 'Caregiver', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null, invitedCaregivers?: Array<{ __typename?: 'Caregiver', id: string, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, totalRewardPoint?: number | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null, invitedCaregivers?: Array<{ __typename?: 'Caregiver', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null, invitedGuardians?: Array<{ __typename?: 'Guardian', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null }> | null, invitedGuardians?: Array<{ __typename?: 'Guardian', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null, invitedCaregivers?: Array<{ __typename?: 'Caregiver', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null, invitedGuardians?: Array<{ __typename?: 'Guardian', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null }> | null } | null, guardian?: { __typename?: 'Guardian', id: string, invitedUserCount?: number | null, totalRewardPoint?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null, invitedCaregivers?: Array<{ __typename?: 'Caregiver', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null, invitedCaregivers?: Array<{ __typename?: 'Caregiver', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null, invitedGuardians?: Array<{ __typename?: 'Guardian', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null }> | null, invitedGuardians?: Array<{ __typename?: 'Guardian', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null, invitedCaregivers?: Array<{ __typename?: 'Caregiver', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null, invitedGuardians?: Array<{ __typename?: 'Guardian', id: string, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, name: string, phone: string, updatedAt: any, username?: string | null, avatar?: { __typename?: 'Media', id: string, uri: string, thumbnailUri?: string | null } | null }> | null }> | null } | null } };

export type GetNetworkDashboardAsAdminQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetNetworkDashboardAsAdminQuery = { __typename?: 'Query', getNetworkDashboardAsAdmin: { __typename?: 'AdminNetworkDashboard', activeUserRate?: number | null, averageActivePeriod: number, totalUserCount: number, totalInviteCount: number, totalActiveUserCount: number, previousMonthUserCountRate: number, previousMonthInviteCountRate: number, previousMonthAverageReferralDepthRate: number, previousMonthAverageReferralCountRate: number, previousMonthAverageActivePeriodRate: number, previousMonthActiveUserRate?: number | null, previousMonthActiveUserCountRate: number, averageReferralDepth: number, averageReferralCount: number } };

export type GetNetworkGraphDashboardAsAdminQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetNetworkGraphDashboardAsAdminQuery = { __typename?: 'Query', getNetworkGraphDashboardAsAdmin: Array<{ __typename?: 'AdminNetworkGraphDashboard', year: string, month: string, totalInviteUserCount: number, totalInvitedUserCount: number }> };

export type GetNetworkRankingAsAdminQueryVariables = Exact<{
  page: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<NetworkUserRankSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetNetworkRankingAsAdminQuery = { __typename?: 'Query', getReferralNetworkUsersRankAsAdmin: { __typename?: 'InvitationConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null }, edges: Array<{ __typename?: 'Invitation', totalNetworkRewardPoint?: number | null, totalNetworkUserCount?: number | null, id?: string | null, caregiver?: { __typename?: 'Caregiver', id: string, name: string, username?: string | null, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, createdAt: any } | null, guardian?: { __typename?: 'Guardian', id: string, name: string, username?: string | null, totalRewardPoint?: number | null, invitedUserCount?: number | null, lastSignInAt?: any | null, createdAt: any } | null }> } };

export type GetIncentiveDashboardAsAdminQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetIncentiveDashboardAsAdminQuery = { __typename?: 'Query', getIncentiveDashboardAsAdmin: { __typename?: 'IncentiveDashboard', accumulatedAmount: number, previousMonthAccumulatedAmountDifference: number, thisMonthTotalAmount: number, previousMonthThisMonthTotalAmountRate: number, thisMonthTotalReceivedUserCount: number, previousMonthThisMonthTotalReceivedUserCountRate: number, averageReceivedAmount: number, previousMonthAverageReceivedAmountRate: number, pointUsedCount: number, previousMonthPointUsedCountRate: number } };

export type GetIncentiveLineGraphAsAdminQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
  caregiverId?: InputMaybe<Scalars['String']>;
  guardianId?: InputMaybe<Scalars['String']>;
}>;


export type GetIncentiveLineGraphAsAdminQuery = { __typename?: 'Query', getIncentiveLineGraphAsAdmin: Array<{ __typename?: 'IncentiveLineGraph', amount: number, pointTransactionTypeId: string, pointTransactionType: { __typename?: 'CommonCode', code: string, id: string, name: string } }> };

export type GetUserIncentivesAsAdminQueryVariables = Exact<{
  year: Scalars['Int'];
  month: Scalars['Int'];
  page: Scalars['Int'];
  limit: Scalars['Int'];
  guardianId?: InputMaybe<Scalars['ID']>;
  caregiverId?: InputMaybe<Scalars['ID']>;
}>;


export type GetUserIncentivesAsAdminQuery = { __typename?: 'Query', getUserIncentivesAsAdmin: { __typename?: 'PointTransactionConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null }, edges: Array<{ __typename?: 'PointTransaction', id: string, amount: number, createdAt: any, caregiver?: { __typename?: 'Caregiver', id: string, name: string, phone: string, createdAt: any, dateOfBirth?: string | null, gender: Gender, username?: string | null } | null, guardian?: { __typename?: 'Guardian', id: string, name: string, phone: string, createdAt: any, dateOfBirth?: string | null, gender: Gender, username?: string | null } | null, pointTransactionType?: { __typename?: 'CommonCode', code: string, name: string, id: string } | null }> } };

export type GetPackagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPackagesQuery = { __typename?: 'Query', getPackages: Array<{ __typename?: 'Package', id: string, point: number, initialPrice: string, finalPrice: string, name?: string | null, active: boolean }> };

export type UpdatePackageAsAdminMutationVariables = Exact<{
  packageInput: PackageInput;
}>;


export type UpdatePackageAsAdminMutation = { __typename?: 'Mutation', updatePackageAsAdmin: { __typename?: 'Package', id: string, point: number, initialPrice: string, finalPrice: string, name?: string | null, active: boolean } };

export type GetPackageQueryVariables = Exact<{
  packageId: Scalars['ID'];
}>;


export type GetPackageQuery = { __typename?: 'Query', getPackage: { __typename?: 'Package', id: string, point: number, initialPrice: string, finalPrice: string, name?: string | null, active: boolean } };

export type CreateAdminUserAsAdminMutationVariables = Exact<{
  createAdminUserAsAdminInput: CreateAdminUserAsAdminInput;
}>;


export type CreateAdminUserAsAdminMutation = { __typename?: 'Mutation', createAdminUserAsAdmin: string };

export type GetMyInvitationCaregiversGuardiansQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetMyInvitationCaregiversGuardiansQuery = { __typename?: 'Query', getMyInvitationCaregiversGuardians: { __typename?: 'MyInvitedCaregiverGuardianConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null, startCursor?: string | null }, edges: Array<{ __typename?: 'InvitedCaregiverGuardian', invitedCaregiver?: { __typename?: 'Caregiver', id: string, phone: string, email?: string | null, communityCount?: number | null, dailyReportCount?: number | null, replyCount?: number | null, cafe24MemberId?: string | null, name: string, gender: Gender, username?: string | null, avatar?: { __typename?: 'Media', uri: string, id: string } | null } | null }> } };

export type GetUserPointTransactionsAsAdminQueryVariables = Exact<{
  caregiverId?: InputMaybe<Scalars['ID']>;
  guardianId?: InputMaybe<Scalars['ID']>;
  range?: InputMaybe<RangeInput>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetUserPointTransactionsAsAdminQuery = { __typename?: 'Query', getUserPointTransactionsAsAdmin: { __typename?: 'PointTransactionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'PointTransaction', id: string, type?: PointTransactionType | null, amount: number, createdAt: any, updatedAt: any, purchase?: { __typename?: 'Purchase', id: string, impUid: string, merchantUid: string, status: PurchaseStatus, initialPrice: string, finalPrice: string, point: string, method: string, paidAt: string, cancelledAt: string, cancelReason: string, pgProvider: string, createdAt: any, updatedAt: any, guardian?: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } | null, caregiver?: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, updatedAt: any, createdAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } | null, pointPackage: { __typename?: 'Package', id: string, point: number, initialPrice: string, finalPrice: string, name?: string | null, active: boolean } } | null, serviceRequest?: { __typename?: 'ServiceRequest', id: string, price: number, serviceAt: string, type: ServiceRequestType, status: ServiceRequestStatus, message: string, createdAt: any, updatedAt: any, service?: { __typename?: 'Service', id: string, name: string, summary: string, price: number, active: boolean, createdAt: any, updatedAt: any } | null, guardian: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }, receiver: { __typename?: 'Receiver', id: string, name: string, phone?: string | null, registrationNumber?: string | null, dateOfBirth: any, gender: Gender, createdAt: any, updatedAt: any, deletedAt?: any | null }, caregiver: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } } | null }> } };

export type GetExmapleQuestionsAsAdminQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Float']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetExmapleQuestionsAsAdminQuery = { __typename?: 'Query', getExmapleQuestionsAsAdmin: { __typename?: 'ExampleQuestionConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'ExampleQuestion', id: string, question: string, createdAt: any, active: boolean, updatedAt: any, answers: Array<{ __typename?: 'ExampleQuestionAnswer', id: string, answer: string, active: boolean }> }> } };

export type UpdateExampleQuestionAsAdminMutationVariables = Exact<{
  exampleQuestionInput: ExampleQuestionInput;
}>;


export type UpdateExampleQuestionAsAdminMutation = { __typename?: 'Mutation', updateExampleQuestionAsAdmin: { __typename?: 'ExampleQuestion', id: string, question: string } };

export type UpdateExampleQuestionAnswerAsAdminMutationVariables = Exact<{
  exampleQuestionAnswerInput: ExampleQuestionAnswerInput;
}>;


export type UpdateExampleQuestionAnswerAsAdminMutation = { __typename?: 'Mutation', updateExampleQuestionAnswerAsAdmin: { __typename?: 'ExampleQuestionAnswer', id: string, answer: string } };

export type GetReceiversAsAdminQueryVariables = Exact<{
  stateId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<Gender>;
  cityId?: InputMaybe<Scalars['ID']>;
}>;


export type GetReceiversAsAdminQuery = { __typename?: 'Query', getReceiversAsAdmin: { __typename?: 'ReceiverConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Receiver', id: string, name: string, phone?: string | null, registrationNumber?: string | null, dateOfBirth: any, gender: Gender, address?: string | null, addressDetail?: string | null, lastRecordAt?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null, registrationMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, state?: { __typename?: 'State', stateCode?: string | null, name: string } | null, city?: { __typename?: 'City', cityCode?: string | null, name: string } | null }> } };

export type SearchReceiversAsAdminQueryVariables = Exact<{
  query: Scalars['String'];
  gender?: InputMaybe<Gender>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SearchReceiversAsAdminQuery = { __typename?: 'Query', searchReceiversAsAdmin: { __typename?: 'ReceiverConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'Receiver', id: string, name: string, phone?: string | null, registrationNumber?: string | null, dateOfBirth: any, gender: Gender, address?: string | null, addressDetail?: string | null, lastRecordAt?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null, registrationMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, state?: { __typename?: 'State', stateCode?: string | null, name: string } | null, city?: { __typename?: 'City', cityCode?: string | null, name: string } | null }> } };

export type GetReceiverQueryVariables = Exact<{
  receiverId: Scalars['ID'];
}>;


export type GetReceiverQuery = { __typename?: 'Query', getReceiver: { __typename?: 'Receiver', id: string, name: string, phone?: string | null, registrationNumber?: string | null, dateOfBirth: any, gender: Gender, address?: string | null, addressDetail?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, registrationMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, guardians?: Array<{ __typename?: 'GuardianReceiver', guardian: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } }> | null, caregivers?: Array<{ __typename?: 'CaregiverReceiver', active: boolean, hasUnreadMessage?: boolean | null, createdAt: any, updatedAt: any, caregiver?: { __typename?: 'Caregiver', id: string, phone: string, email?: string | null, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, deletedAt?: any | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null } | null }> | null, city?: { __typename?: 'City', cityCode?: string | null, name: string } | null, state?: { __typename?: 'State', stateCode?: string | null, name: string } | null } };

export type GetReceiverNameQueryVariables = Exact<{
  receiverId: Scalars['ID'];
}>;


export type GetReceiverNameQuery = { __typename?: 'Query', getReceiver: { __typename?: 'Receiver', name: string } };

export type UpdateReceiverMutationVariables = Exact<{
  receiverInput: ReceiverInput;
}>;


export type UpdateReceiverMutation = { __typename?: 'Mutation', updateReceiver: { __typename?: 'Receiver', id: string, name: string, registrationNumber?: string | null, phone?: string | null, dateOfBirth: any, gender: Gender, createdAt: any } };

export type GetReceiverRecordsAsAdminQueryVariables = Exact<{
  receiverId: Scalars['String'];
  first?: InputMaybe<Scalars['Float']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetReceiverRecordsAsAdminQuery = { __typename?: 'Query', getReceiverRecordsAsAdmin: { __typename?: 'ReceiverRecordConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'ReceiverRecord', body: string, createdAt: any, deletedAt?: any | null, updatedAt: any, id: string, author: { __typename?: 'Caregiver', id: string, phone: string, name: string, gender: Gender, username?: string | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }, media?: Array<{ __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null }> | null }> } };

export type GetReceiverRecordsQueryVariables = Exact<{
  receiverId: Scalars['ID'];
  range: RangeInput;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetReceiverRecordsQuery = { __typename?: 'Query', getReceiverRecords: { __typename?: 'ReceiverRecordConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'ReceiverRecord', id: string, body: string, createdAt: any, deletedAt?: any | null, updatedAt: any, author: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, certificateNumber?: string | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null }, receiver: { __typename?: 'Receiver', id: string, name: string }, media?: Array<{ __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null }> | null }> } };

export type UpdateReceiverAsAdminMutationVariables = Exact<{
  receiverInput: ReceiverInput;
}>;


export type UpdateReceiverAsAdminMutation = { __typename?: 'Mutation', updateReceiverAsAdmin: { __typename?: 'Receiver', id: string, name: string, phone?: string | null, registrationNumber?: string | null, dateOfBirth: any, gender: Gender, address?: string | null, addressDetail?: string | null, hasCohabitingFamily: boolean, issue?: string | null, lastRecordAt?: any | null, registrationMedia?: { __typename?: 'Media', id: string, name: string, uri: string, size: number, type: string, createdAt: any, thumbnailUri?: string | null } | null, state?: { __typename?: 'State', stateCode?: string | null, name: string } | null, city?: { __typename?: 'City', cityCode?: string | null } | null } };

export type GetDailyReportsAsAdminQueryVariables = Exact<{
  dailyReportSearchQuery?: InputMaybe<DailyReportSearchQuery>;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetDailyReportsAsAdminQuery = { __typename?: 'Query', getDailyReportsAsAdmin: { __typename?: 'DailyReportConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'DailyReport', id: string, dailyReport?: string | null, createdAt: any, deletedAt?: any | null, caregiver: { __typename?: 'Caregiver', id: string, name: string }, receiver: { __typename?: 'Receiver', id: string, name: string }, recordHistories?: Array<{ __typename?: 'RecordHistory', id: string, measure?: number | null, answerComment?: string | null, answer?: string | null, recordQuestion?: { __typename?: 'RecordQuestion', id: string, question: string, measureType?: string | null, isMeasureQuestion: boolean, isInformationQuestion: boolean } | null }> | null }> } };

export type GetDailyReportAsAdminQueryVariables = Exact<{
  dailyReportId: Scalars['String'];
}>;


export type GetDailyReportAsAdminQuery = { __typename?: 'Query', getDailyReportAsAdmin: { __typename?: 'DailyReport', id: string, dailyReport?: string | null, createdAt: any, deletedAt?: any | null, caregiver: { __typename?: 'Caregiver', id: string, phone: string, email?: string | null, gender: Gender, name: string, username?: string | null, avatar?: { __typename?: 'Media', id: string, name: string, uri: string } | null }, receiver: { __typename?: 'Receiver', id: string, name: string, phone?: string | null, dateOfBirth: any, gender: Gender, address?: string | null, addressDetail?: string | null }, recordHistories?: Array<{ __typename?: 'RecordHistory', id: string, answer?: string | null, measure?: number | null, answerComment?: string | null, recordQuestion?: { __typename?: 'RecordQuestion', id: string, question: string, isMeasureQuestion: boolean, measureType?: string | null, isInformationQuestion: boolean } | null }> | null } };

export type DeleteDailyReportAsAdminMutationVariables = Exact<{
  dailyReportId: Scalars['String'];
}>;


export type DeleteDailyReportAsAdminMutation = { __typename?: 'Mutation', deleteDailyReportAsAdmin: boolean };

export type GetDailyReportsByMonthWeekAdminQueryVariables = Exact<{
  receiverId: Scalars['String'];
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetDailyReportsByMonthWeekAdminQuery = { __typename?: 'Query', getDailyReportsByMonthWeekAdmin: Array<{ __typename?: 'DailyReportGroupByWeek', week: string, isHasWeeklyReport: boolean, dailyReports: Array<{ __typename?: 'DailyReport', id: string, dailyReport?: string | null, createdAt: any, deletedAt?: any | null, caregiver: { __typename?: 'Caregiver', id: string, name: string }, receiver: { __typename?: 'Receiver', id: string, name: string }, recordHistories?: Array<{ __typename?: 'RecordHistory', id: string }> | null }> }> };

export type GetWeeklyReceiverMeasuresQueryVariables = Exact<{
  month: Scalars['Int'];
  week: Scalars['Int'];
  receiverId: Scalars['String'];
  year: Scalars['Int'];
}>;


export type GetWeeklyReceiverMeasuresQuery = { __typename?: 'Query', getWeeklyReceiverMeasures: Array<{ __typename?: 'Measure', category_id: string, large_category: string, measure: number, medium_category: string, small_category: string }> };

export type GetReceiverWeeklyReportQueryVariables = Exact<{
  categoryId: Scalars['String'];
  receiverId: Scalars['String'];
  measure: Scalars['Int'];
  year: Scalars['Int'];
  month: Scalars['Int'];
  week: Scalars['Int'];
}>;


export type GetReceiverWeeklyReportQuery = { __typename?: 'Query', getReceiverWeeklyReport: { __typename?: 'ReceiverMeasureComment', comment: string } };

export type GetReceiverWeeklyReportWithTotalCommentQueryVariables = Exact<{
  receiverId: Scalars['String'];
  categoryMeasures: Array<CategoryMeasure> | CategoryMeasure;
  year: Scalars['Int'];
  month: Scalars['Int'];
  week: Scalars['Int'];
}>;


export type GetReceiverWeeklyReportWithTotalCommentQuery = { __typename?: 'Query', getReceiverWeeklyReportWithTotalComment: { __typename?: 'ReceiverMeasureTotalComment', totalComment: string, categoryComments: Array<{ __typename?: 'CategoryComments', categoryId: string, comment: string }> } };

export type GetMonthlyReceiverMeasureQueryVariables = Exact<{
  receiverId: Scalars['String'];
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetMonthlyReceiverMeasureQuery = { __typename?: 'Query', getMonthlyReceiverMeasure: Array<{ __typename?: 'MonthlyMeasure', category_id: string, large_category: string, medium_category: string, small_category: string, weekly_measure: Array<number> }> };

export type GetReceiverKeywordsQueryVariables = Exact<{
  receiverId: Scalars['String'];
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetReceiverKeywordsQuery = { __typename?: 'Query', getReceiverKeywords: Array<{ __typename?: 'Keyword', keyword?: string | null, category?: string | null, count?: number | null }> };

export type GetCaregiverManualQueryVariables = Exact<{
  receiverId: Scalars['String'];
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetCaregiverManualQuery = { __typename?: 'Query', getCaregiverManual: Array<{ __typename?: 'CaregiverManual', catNm: string, actNm: string, actDetail: string }> };

export type GetMonthlyReceiverStatusQueryVariables = Exact<{
  receiverId: Scalars['String'];
  month: Scalars['Int'];
  year: Scalars['Int'];
}>;


export type GetMonthlyReceiverStatusQuery = { __typename?: 'Query', getMonthlyReceiverStatus: { __typename?: 'ReceiverStatus', comment: string } };

export type GetCareServiceQueryVariables = Exact<{
  receiverId: Scalars['String'];
  year: Scalars['Int'];
  month: Scalars['Int'];
}>;


export type GetCareServiceQuery = { __typename?: 'Query', getCareService: Array<{ __typename?: 'CareService', serviceCateNm: string, problemNm: string, problemSolutionNm: string }> };

export type UpdateReportReasonAsAdminMutationVariables = Exact<{
  reportReasonInput: UpdateReportReasonAsAdminDto;
}>;


export type UpdateReportReasonAsAdminMutation = { __typename?: 'Mutation', updateReportReasonAsAdmin: { __typename?: 'ReportReason', active: boolean, id: string, reason: string, type: string } };

export type CreateReportReasonAsAdminMutationVariables = Exact<{
  reportReasonInput: CreateReportReasonAsAdminDto;
}>;


export type CreateReportReasonAsAdminMutation = { __typename?: 'Mutation', createReportReasonAsAdmin: { __typename?: 'ReportReason', active: boolean, id: string, reason: string, type: string } };

export type GetReportReasonsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetReportReasonsQuery = { __typename?: 'Query', getReportReasons: Array<{ __typename?: 'ReportReason', id: string, type: string, reason: string, active: boolean }> };

export type GetReportsAsAdminQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetReportsAsAdminQuery = { __typename?: 'Query', getReportsAsAdmin: { __typename?: 'ReportConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename?: 'Report', id: string, createdAt: any, updatedAt: any, customReason?: string | null, reason?: { __typename?: 'CommonCode', id: string, code: string, name: string } | null, caregiver?: { __typename?: 'Caregiver', id: string, phone: string, gender: Gender, name: string, username?: string | null, point: number, dateOfBirth?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null, guardian?: { __typename?: 'Guardian', id: string, phone: string, gender: Gender, name: string, username?: string | null, dateOfBirth?: string | null, point: number, createdAt: any, updatedAt: any, deletedAt?: any | null } | null }> } };

export type GetServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServicesQuery = { __typename?: 'Query', getServices: Array<{ __typename?: 'Service', id: string, name: string, summary: string, price: number, active: boolean, createdAt: any, updatedAt: any }> };

export type GetServiceQueryVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type GetServiceQuery = { __typename?: 'Query', getService: { __typename?: 'Service', id: string, name: string, summary: string, price: number, active: boolean, createdAt: any, updatedAt: any } };

export type UpdateServiceAsAdminMutationVariables = Exact<{
  serviceInput: UpdateServiceAsAdminDto;
}>;


export type UpdateServiceAsAdminMutation = { __typename?: 'Mutation', updateServiceAsAdmin: { __typename?: 'Service', id: string, name: string, summary: string, price: number, active: boolean, createdAt: any, updatedAt: any } };

export type GetUserCountsAsAdminQueryVariables = Exact<{
  range?: InputMaybe<RangeInput>;
}>;


export type GetUserCountsAsAdminQuery = { __typename?: 'Query', getUserCountsAsAdmin: { __typename?: 'UserCounts', caregiverCount: number, guardianCount: number, receiverCount: number, resignedUsersCount: number } };

export type GetYearlyUserTrendAsAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYearlyUserTrendAsAdminQuery = { __typename?: 'Query', getYearlyUserTrendAsAdmin: Array<{ __typename?: 'UserCounts', caregiverCount: number, guardianCount: number, receiverCount: number, resignedUsersCount: number }> };

export type GetYoutubeVideosAsAdminQueryVariables = Exact<{
  limit: Scalars['Int'];
  endCursor?: InputMaybe<Scalars['String']>;
}>;


export type GetYoutubeVideosAsAdminQuery = { __typename?: 'Query', getYoutubeVideosAsAdmin: { __typename?: 'YoutubeVideosConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ __typename?: 'YoutubeVideo', commentCount: number, description: string, likeCount: number, playTime: string, thumbnail: string, title: string, viewCount: number, youtubeUrl: string, isInserted: boolean }> } };

export type CreateVideoContentAsAdminMutationVariables = Exact<{
  title: Scalars['String'];
  mediaInput: MediaInput;
  playTime: Scalars['String'];
  youtubeUrl: Scalars['String'];
  statusId: Scalars['String'];
  videoContentCategoryId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type CreateVideoContentAsAdminMutation = { __typename?: 'Mutation', createVideoContentAsAdmin: { __typename?: 'VideoContent', id: string } };

export type DeleteVideoContentAsAdminMutationVariables = Exact<{
  videoContentId: Scalars['String'];
}>;


export type DeleteVideoContentAsAdminMutation = { __typename?: 'Mutation', deleteVideoContentAsAdmin: { __typename?: 'VideoContent', id: string } };

export type UpdateVideoContentAsAdminMutationVariables = Exact<{
  videoContentId: Scalars['String'];
  title: Scalars['String'];
  mediaInput?: InputMaybe<MediaInput>;
  playTime: Scalars['String'];
  youtubeUrl: Scalars['String'];
  statusId: Scalars['String'];
  videoContentCategoryId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateVideoContentAsAdminMutation = { __typename?: 'Mutation', updateVideoContentAsAdmin: { __typename?: 'VideoContent', id: string } };

export type GetVideoContentsAsAdminQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  videoContentSearchType?: InputMaybe<VideoContentSearchType>;
  sortKey?: InputMaybe<VideoContentSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
}>;


export type GetVideoContentsAsAdminQuery = { __typename?: 'Query', getVideoContentsAsAdmin: { __typename?: 'VideoContentConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null }, edges: Array<{ __typename?: 'VideoContent', createdAt: any, description?: string | null, id: string, playTime: string, title: string, updatedAt: any, viewCount?: number | null, youtubeUrl: string, media: { __typename?: 'Media', uri: string, id: string }, status: { __typename?: 'CommonCode', code: string, id: string, commonCodeGroupId: string, status: CommonCodeStatus, name: string }, videoContentCategory: { __typename?: 'CommonCode', id: string, name: string, status: CommonCodeStatus, code: string } }> } };

export type GetBokjiroWelfareContentsAsAdminQueryVariables = Exact<{
  limit: Scalars['Int'];
  page: Scalars['Int'];
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  welfareLifeCycleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  welfareFamilyTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  welfareTypeId?: InputMaybe<Scalars['String']>;
}>;


export type GetBokjiroWelfareContentsAsAdminQuery = { __typename?: 'Query', getBokjiroWelfareContentsAsAdmin: { __typename?: 'BokjiroWelfareConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null }, edges: Array<{ __typename?: 'BokjiroWelfare', welfareServiceId: string, isInserted: boolean, title: string, description: string, contactInformation: string, supportType: string, inquiryPhone?: string | null, detailPageUrl: string, welfareTypeId: string, supportCycle: string, applicationMethod?: string | null, welfareCategoryIds?: Array<string> | null, welfareLifeCycleIds?: Array<string> | null, welfareFamilyTypeIds?: Array<string> | null, welfareType?: { __typename?: 'CommonCode', id: string, name: string, code: string } | null, welfareCategories?: Array<{ __typename?: 'CommonCode', id: string, name: string, code: string }> | null, welfareLifeCycles?: Array<{ __typename?: 'CommonCode', id: string, name: string, code: string }> | null, welfareFamilyTypes?: Array<{ __typename?: 'CommonCode', id: string, name: string, code: string }> | null }> } };

export type CreateWelfareContentAsAdminMutationVariables = Exact<{
  title: Scalars['String'];
  description: Scalars['String'];
  detailPageUrl: Scalars['String'];
  statusId: Scalars['String'];
  welfareTypeId: Scalars['String'];
  welfareServiceId: Scalars['String'];
  inquiryPhone?: InputMaybe<Scalars['String']>;
  contactInformation?: InputMaybe<Scalars['String']>;
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  welfareLifeCycleIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  welfareFamilyTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type CreateWelfareContentAsAdminMutation = { __typename?: 'Mutation', createWelfareContentAsAdmin: boolean };

export type UpdateWelfareContentAsAdminMutationVariables = Exact<{
  statusId: Scalars['String'];
  welfareContentId: Scalars['String'];
}>;


export type UpdateWelfareContentAsAdminMutation = { __typename?: 'Mutation', updateWelfareContentAsAdmin: { __typename?: 'WelfareContent', id: string } };

export type GetWelfareContentStatusQueryVariables = Exact<{
  welfareContentId: Scalars['String'];
}>;


export type GetWelfareContentStatusQuery = { __typename?: 'Query', getWelfareContentAsAdmin: { __typename?: 'WelfareContent', statusId: string } };

export type GetWelfareContentsAsAdminQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  searchType?: InputMaybe<WelfareContentSearchType>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<WelfareContentSortKey>;
  sortDirection?: InputMaybe<Scalars['String']>;
  welfareCategoryIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetWelfareContentsAsAdminQuery = { __typename?: 'Query', getWelfareContentsAsAdmin: { __typename?: 'WelfareContentConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null }, edges: Array<{ __typename?: 'WelfareContent', title: string, id: string, description: string, createdAt: any, contactInformation?: string | null, applicationMethod?: string | null, inquiryPhone?: string | null, detailPageUrl: string, updatedAt: any, supportType?: string | null, supportCycle?: string | null, status?: { __typename?: 'CommonCode', name: string, status: CommonCodeStatus, id: string, code: string } | null, welfareCategories?: Array<{ __typename?: 'CommonCode', id: string, name: string, code: string }> | null, welfareFamilyTypes?: Array<{ __typename?: 'CommonCode', id: string, name: string, code: string }> | null, welfareLifeCycles?: Array<{ __typename?: 'CommonCode', code: string, name: string, id: string }> | null, welfareType?: { __typename?: 'CommonCode', id: string, name: string, code: string } | null }> } };

export type DeleteWelfareContentAsAdminMutationVariables = Exact<{
  welfareContentId: Scalars['String'];
}>;


export type DeleteWelfareContentAsAdminMutation = { __typename?: 'Mutation', deleteWelfareContentAsAdmin: boolean };


export const GetAdminUsersDocument = gql`
    query GetAdminUsers($adminSearchType: AdminSearchType, $query: String, $first: Int, $after: String, $sortKey: AdminSortKey, $sortDirection: String) {
  getAdminUsers(
    adminSearchType: $adminSearchType
    query: $query
    first: $first
    after: $after
    sortKey: $sortKey
    sortDirection: $sortDirection
  ) {
    edges {
      adminRole {
        id
        name
      }
      adminRoleId
      createdAt
      email
      id
      name
      status
      updatedAt
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *      adminSearchType: // value for 'adminSearchType'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const GetMyAdminUserDocument = gql`
    query GetMyAdminUser {
  getMyAdminUser {
    id
    email
    name
    password
    adminRoleId
    status
    createdAt
    updatedAt
    adminRole {
      name
      id
    }
  }
}
    `;

/**
 * __useGetMyAdminUserQuery__
 *
 * To run a query within a React component, call `useGetMyAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyAdminUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyAdminUserQuery(baseOptions?: Apollo.QueryHookOptions<GetMyAdminUserQuery, GetMyAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyAdminUserQuery, GetMyAdminUserQueryVariables>(GetMyAdminUserDocument, options);
      }
export function useGetMyAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyAdminUserQuery, GetMyAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyAdminUserQuery, GetMyAdminUserQueryVariables>(GetMyAdminUserDocument, options);
        }
export type GetMyAdminUserQueryHookResult = ReturnType<typeof useGetMyAdminUserQuery>;
export type GetMyAdminUserLazyQueryHookResult = ReturnType<typeof useGetMyAdminUserLazyQuery>;
export type GetMyAdminUserQueryResult = Apollo.QueryResult<GetMyAdminUserQuery, GetMyAdminUserQueryVariables>;
export const GetAdminUserDocument = gql`
    query GetAdminUser($adminId: String!) {
  getAdminUser(adminId: $adminId) {
    id
    email
    name
    adminRoleId
    status
    createdAt
    updatedAt
    adminRole {
      id
      name
    }
  }
}
    `;

/**
 * __useGetAdminUserQuery__
 *
 * To run a query within a React component, call `useGetAdminUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUserQuery({
 *   variables: {
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useGetAdminUserQuery(baseOptions: Apollo.QueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
      }
export function useGetAdminUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUserQuery, GetAdminUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUserQuery, GetAdminUserQueryVariables>(GetAdminUserDocument, options);
        }
export type GetAdminUserQueryHookResult = ReturnType<typeof useGetAdminUserQuery>;
export type GetAdminUserLazyQueryHookResult = ReturnType<typeof useGetAdminUserLazyQuery>;
export type GetAdminUserQueryResult = Apollo.QueryResult<GetAdminUserQuery, GetAdminUserQueryVariables>;
export const GetAdminRolesDocument = gql`
    query GetAdminRoles {
  getAdminRoles {
    id
    name
  }
}
    `;

/**
 * __useGetAdminRolesQuery__
 *
 * To run a query within a React component, call `useGetAdminRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminRolesQuery, GetAdminRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminRolesQuery, GetAdminRolesQueryVariables>(GetAdminRolesDocument, options);
      }
export function useGetAdminRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminRolesQuery, GetAdminRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminRolesQuery, GetAdminRolesQueryVariables>(GetAdminRolesDocument, options);
        }
export type GetAdminRolesQueryHookResult = ReturnType<typeof useGetAdminRolesQuery>;
export type GetAdminRolesLazyQueryHookResult = ReturnType<typeof useGetAdminRolesLazyQuery>;
export type GetAdminRolesQueryResult = Apollo.QueryResult<GetAdminRolesQuery, GetAdminRolesQueryVariables>;
export const CreateAdminUserDocument = gql`
    mutation CreateAdminUser($createAdminUserDto: CreateAdminUserDto!) {
  createAdminUser(createAdminUserDto: $createAdminUserDto) {
    adminRole {
      id
      name
    }
    adminRoleId
    createdAt
    email
    id
    name
    status
    updatedAt
  }
}
    `;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<CreateAdminUserMutation, CreateAdminUserMutationVariables>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      createAdminUserDto: // value for 'createAdminUserDto'
 *   },
 * });
 */
export function useCreateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(CreateAdminUserDocument, options);
      }
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>;
export const DeleteAdminUserDocument = gql`
    mutation DeleteAdminUser($adminId: String!) {
  deleteAdminUser(adminId: $adminId) {
    id
    email
    name
    adminRoleId
    status
    createdAt
    updatedAt
    adminRole {
      name
      id
    }
  }
}
    `;
export type DeleteAdminUserMutationFn = Apollo.MutationFunction<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>;

/**
 * __useDeleteAdminUserMutation__
 *
 * To run a mutation, you first call `useDeleteAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdminUserMutation, { data, loading, error }] = useDeleteAdminUserMutation({
 *   variables: {
 *      adminId: // value for 'adminId'
 *   },
 * });
 */
export function useDeleteAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>(DeleteAdminUserDocument, options);
      }
export type DeleteAdminUserMutationHookResult = ReturnType<typeof useDeleteAdminUserMutation>;
export type DeleteAdminUserMutationResult = Apollo.MutationResult<DeleteAdminUserMutation>;
export type DeleteAdminUserMutationOptions = Apollo.BaseMutationOptions<DeleteAdminUserMutation, DeleteAdminUserMutationVariables>;
export const UpdateAdminUserDocument = gql`
    mutation UpdateAdminUser($updateAdminUserDto: UpdateAdminUserDto!) {
  updateAdminUser(updateAdminUserDto: $updateAdminUserDto) {
    id
  }
}
    `;
export type UpdateAdminUserMutationFn = Apollo.MutationFunction<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>;

/**
 * __useUpdateAdminUserMutation__
 *
 * To run a mutation, you first call `useUpdateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminUserMutation, { data, loading, error }] = useUpdateAdminUserMutation({
 *   variables: {
 *      updateAdminUserDto: // value for 'updateAdminUserDto'
 *   },
 * });
 */
export function useUpdateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>(UpdateAdminUserDocument, options);
      }
export type UpdateAdminUserMutationHookResult = ReturnType<typeof useUpdateAdminUserMutation>;
export type UpdateAdminUserMutationResult = Apollo.MutationResult<UpdateAdminUserMutation>;
export type UpdateAdminUserMutationOptions = Apollo.BaseMutationOptions<UpdateAdminUserMutation, UpdateAdminUserMutationVariables>;
export const GetAnnouncementDocument = gql`
    query GetAnnouncement($announcementId: ID!) {
  getAnnouncement(announcementId: $announcementId) {
    id
    title
    summary
    thumbnailMedia {
      id
      uri
    }
    body
    active
    onBanner
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetAnnouncementQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementQuery({
 *   variables: {
 *      announcementId: // value for 'announcementId'
 *   },
 * });
 */
export function useGetAnnouncementQuery(baseOptions: Apollo.QueryHookOptions<GetAnnouncementQuery, GetAnnouncementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementQuery, GetAnnouncementQueryVariables>(GetAnnouncementDocument, options);
      }
export function useGetAnnouncementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementQuery, GetAnnouncementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementQuery, GetAnnouncementQueryVariables>(GetAnnouncementDocument, options);
        }
export type GetAnnouncementQueryHookResult = ReturnType<typeof useGetAnnouncementQuery>;
export type GetAnnouncementLazyQueryHookResult = ReturnType<typeof useGetAnnouncementLazyQuery>;
export type GetAnnouncementQueryResult = Apollo.QueryResult<GetAnnouncementQuery, GetAnnouncementQueryVariables>;
export const GetAnnouncementsDocument = gql`
    query GetAnnouncements($active: Boolean, $onBanner: Boolean, $first: Int, $after: String) {
  getAnnouncements(
    active: $active
    onBanner: $onBanner
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      title
      summary
      thumbnailMedia {
        id
        uri
      }
      body
      active
      onBanner
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnnouncementsQuery({
 *   variables: {
 *      active: // value for 'active'
 *      onBanner: // value for 'onBanner'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
      }
export function useGetAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>(GetAnnouncementsDocument, options);
        }
export type GetAnnouncementsQueryHookResult = ReturnType<typeof useGetAnnouncementsQuery>;
export type GetAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetAnnouncementsLazyQuery>;
export type GetAnnouncementsQueryResult = Apollo.QueryResult<GetAnnouncementsQuery, GetAnnouncementsQueryVariables>;
export const UpdateAnnouncementAsAdminDocument = gql`
    mutation UpdateAnnouncementAsAdmin($announcementInput: UpdateAnnouncementAsAdminDto!) {
  updateAnnouncementAsAdmin(announcementInput: $announcementInput) {
    id
    title
    summary
    thumbnailMedia {
      id
      uri
    }
    body
    active
    onBanner
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAnnouncementAsAdminMutationFn = Apollo.MutationFunction<UpdateAnnouncementAsAdminMutation, UpdateAnnouncementAsAdminMutationVariables>;

/**
 * __useUpdateAnnouncementAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateAnnouncementAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnnouncementAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnnouncementAsAdminMutation, { data, loading, error }] = useUpdateAnnouncementAsAdminMutation({
 *   variables: {
 *      announcementInput: // value for 'announcementInput'
 *   },
 * });
 */
export function useUpdateAnnouncementAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnnouncementAsAdminMutation, UpdateAnnouncementAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnnouncementAsAdminMutation, UpdateAnnouncementAsAdminMutationVariables>(UpdateAnnouncementAsAdminDocument, options);
      }
export type UpdateAnnouncementAsAdminMutationHookResult = ReturnType<typeof useUpdateAnnouncementAsAdminMutation>;
export type UpdateAnnouncementAsAdminMutationResult = Apollo.MutationResult<UpdateAnnouncementAsAdminMutation>;
export type UpdateAnnouncementAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateAnnouncementAsAdminMutation, UpdateAnnouncementAsAdminMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!, $password: String!) {
  signInAsAdmin(email: $email, password: $password) {
    id
    email
    name
    password
    adminRoleId
    status
    createdAt
    updatedAt
    adminRole {
      name
      id
    }
  }
}
    `;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  signOutAsAdmin
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const GetBannerCountsAsAdminDocument = gql`
    query GetBannerCountsAsAdmin {
  getBannersCountAsAdmin {
    activeCount
    inactiveCount
    reservedCount
    totalCount
  }
}
    `;

/**
 * __useGetBannerCountsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetBannerCountsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerCountsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerCountsAsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBannerCountsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetBannerCountsAsAdminQuery, GetBannerCountsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerCountsAsAdminQuery, GetBannerCountsAsAdminQueryVariables>(GetBannerCountsAsAdminDocument, options);
      }
export function useGetBannerCountsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerCountsAsAdminQuery, GetBannerCountsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerCountsAsAdminQuery, GetBannerCountsAsAdminQueryVariables>(GetBannerCountsAsAdminDocument, options);
        }
export type GetBannerCountsAsAdminQueryHookResult = ReturnType<typeof useGetBannerCountsAsAdminQuery>;
export type GetBannerCountsAsAdminLazyQueryHookResult = ReturnType<typeof useGetBannerCountsAsAdminLazyQuery>;
export type GetBannerCountsAsAdminQueryResult = Apollo.QueryResult<GetBannerCountsAsAdminQuery, GetBannerCountsAsAdminQueryVariables>;
export const GetBannersAsAdminDocument = gql`
    query GetBannersAsAdmin($limit: Int, $page: Int, $sortKey: BannerSortKey, $sortDirection: String) {
  getBannersAsAdmin(
    limit: $limit
    page: $page
    sortKey: $sortKey
    sortDirection: $sortDirection
  ) {
    edges {
      id
      title
      description
      status {
        code
        id
        name
      }
      statusId
      linkType {
        name
        id
        code
      }
      linkTypeId
      clickCount
      linkUrl
      startAt
      endAt
      createdAt
      updatedAt
      thumbnailMedia {
        id
        thumbnailUri
        uri
      }
      thumbnailMediaId
    }
    pageInfo {
      totalCount
    }
  }
}
    `;

/**
 * __useGetBannersAsAdminQuery__
 *
 * To run a query within a React component, call `useGetBannersAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannersAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannersAsAdminQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetBannersAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetBannersAsAdminQuery, GetBannersAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannersAsAdminQuery, GetBannersAsAdminQueryVariables>(GetBannersAsAdminDocument, options);
      }
export function useGetBannersAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannersAsAdminQuery, GetBannersAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannersAsAdminQuery, GetBannersAsAdminQueryVariables>(GetBannersAsAdminDocument, options);
        }
export type GetBannersAsAdminQueryHookResult = ReturnType<typeof useGetBannersAsAdminQuery>;
export type GetBannersAsAdminLazyQueryHookResult = ReturnType<typeof useGetBannersAsAdminLazyQuery>;
export type GetBannersAsAdminQueryResult = Apollo.QueryResult<GetBannersAsAdminQuery, GetBannersAsAdminQueryVariables>;
export const GetBannerAsAdminDocument = gql`
    query GetBannerAsAdmin($bannerId: String!) {
  getBannerAsAdmin(bannerId: $bannerId) {
    clickCount
    createdAt
    description
    endAt
    id
    linkType {
      id
      name
      code
    }
    linkTypeId
    linkUrl
    startAt
    status {
      code
      id
      name
    }
    statusId
    updatedAt
    title
    thumbnailMediaId
    thumbnailMedia {
      name
      id
      thumbnailUri
      uri
    }
  }
}
    `;

/**
 * __useGetBannerAsAdminQuery__
 *
 * To run a query within a React component, call `useGetBannerAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerAsAdminQuery({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useGetBannerAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetBannerAsAdminQuery, GetBannerAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerAsAdminQuery, GetBannerAsAdminQueryVariables>(GetBannerAsAdminDocument, options);
      }
export function useGetBannerAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerAsAdminQuery, GetBannerAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerAsAdminQuery, GetBannerAsAdminQueryVariables>(GetBannerAsAdminDocument, options);
        }
export type GetBannerAsAdminQueryHookResult = ReturnType<typeof useGetBannerAsAdminQuery>;
export type GetBannerAsAdminLazyQueryHookResult = ReturnType<typeof useGetBannerAsAdminLazyQuery>;
export type GetBannerAsAdminQueryResult = Apollo.QueryResult<GetBannerAsAdminQuery, GetBannerAsAdminQueryVariables>;
export const CreateBannerAsAdminDocument = gql`
    mutation CreateBannerAsAdmin($createBannerAsAdminDto: CreateBannerAsAdminDto!) {
  createBannerAsAdmin(createBannerAsAdminDto: $createBannerAsAdminDto) {
    updatedAt
  }
}
    `;
export type CreateBannerAsAdminMutationFn = Apollo.MutationFunction<CreateBannerAsAdminMutation, CreateBannerAsAdminMutationVariables>;

/**
 * __useCreateBannerAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateBannerAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBannerAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBannerAsAdminMutation, { data, loading, error }] = useCreateBannerAsAdminMutation({
 *   variables: {
 *      createBannerAsAdminDto: // value for 'createBannerAsAdminDto'
 *   },
 * });
 */
export function useCreateBannerAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateBannerAsAdminMutation, CreateBannerAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBannerAsAdminMutation, CreateBannerAsAdminMutationVariables>(CreateBannerAsAdminDocument, options);
      }
export type CreateBannerAsAdminMutationHookResult = ReturnType<typeof useCreateBannerAsAdminMutation>;
export type CreateBannerAsAdminMutationResult = Apollo.MutationResult<CreateBannerAsAdminMutation>;
export type CreateBannerAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateBannerAsAdminMutation, CreateBannerAsAdminMutationVariables>;
export const UpdateBannerAsAdminDocument = gql`
    mutation UpdateBannerAsAdmin($updateBannerAsAdminDto: UpdateBannerAsAdminDto!) {
  updateBannerAsAdmin(updateBannerAsAdminDto: $updateBannerAsAdminDto) {
    updatedAt
  }
}
    `;
export type UpdateBannerAsAdminMutationFn = Apollo.MutationFunction<UpdateBannerAsAdminMutation, UpdateBannerAsAdminMutationVariables>;

/**
 * __useUpdateBannerAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateBannerAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerAsAdminMutation, { data, loading, error }] = useUpdateBannerAsAdminMutation({
 *   variables: {
 *      updateBannerAsAdminDto: // value for 'updateBannerAsAdminDto'
 *   },
 * });
 */
export function useUpdateBannerAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBannerAsAdminMutation, UpdateBannerAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBannerAsAdminMutation, UpdateBannerAsAdminMutationVariables>(UpdateBannerAsAdminDocument, options);
      }
export type UpdateBannerAsAdminMutationHookResult = ReturnType<typeof useUpdateBannerAsAdminMutation>;
export type UpdateBannerAsAdminMutationResult = Apollo.MutationResult<UpdateBannerAsAdminMutation>;
export type UpdateBannerAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateBannerAsAdminMutation, UpdateBannerAsAdminMutationVariables>;
export const DeleteBannerAsAdminDocument = gql`
    mutation DeleteBannerAsAdmin($bannerId: String!) {
  deleteBannerAsAdmin(bannerId: $bannerId) {
    id
  }
}
    `;
export type DeleteBannerAsAdminMutationFn = Apollo.MutationFunction<DeleteBannerAsAdminMutation, DeleteBannerAsAdminMutationVariables>;

/**
 * __useDeleteBannerAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteBannerAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBannerAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBannerAsAdminMutation, { data, loading, error }] = useDeleteBannerAsAdminMutation({
 *   variables: {
 *      bannerId: // value for 'bannerId'
 *   },
 * });
 */
export function useDeleteBannerAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBannerAsAdminMutation, DeleteBannerAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBannerAsAdminMutation, DeleteBannerAsAdminMutationVariables>(DeleteBannerAsAdminDocument, options);
      }
export type DeleteBannerAsAdminMutationHookResult = ReturnType<typeof useDeleteBannerAsAdminMutation>;
export type DeleteBannerAsAdminMutationResult = Apollo.MutationResult<DeleteBannerAsAdminMutation>;
export type DeleteBannerAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteBannerAsAdminMutation, DeleteBannerAsAdminMutationVariables>;
export const GetCaregiversAsAdminDocument = gql`
    query GetCaregiversAsAdmin($gender: Gender, $first: Int, $after: String) {
  getCaregiversAsAdmin(gender: $gender, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      phone
      gender
      point
      name
      username
      dateOfBirth
      certificateMedia {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      certificateNumber
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetCaregiversAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCaregiversAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiversAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiversAsAdminQuery({
 *   variables: {
 *      gender: // value for 'gender'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCaregiversAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetCaregiversAsAdminQuery, GetCaregiversAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiversAsAdminQuery, GetCaregiversAsAdminQueryVariables>(GetCaregiversAsAdminDocument, options);
      }
export function useGetCaregiversAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiversAsAdminQuery, GetCaregiversAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiversAsAdminQuery, GetCaregiversAsAdminQueryVariables>(GetCaregiversAsAdminDocument, options);
        }
export type GetCaregiversAsAdminQueryHookResult = ReturnType<typeof useGetCaregiversAsAdminQuery>;
export type GetCaregiversAsAdminLazyQueryHookResult = ReturnType<typeof useGetCaregiversAsAdminLazyQuery>;
export type GetCaregiversAsAdminQueryResult = Apollo.QueryResult<GetCaregiversAsAdminQuery, GetCaregiversAsAdminQueryVariables>;
export const GetCaregiverProfileDocument = gql`
    query GetCaregiverProfile($caregiverId: ID!) {
  getCaregiverProfile(caregiverId: $caregiverId) {
    id
    role {
      id
      name
    }
    phone
    email
    gender
    name
    avatar {
      id
      name
      uri
      size
      type
      createdAt
      thumbnailUri
    }
    username
    dateOfBirth
    point
    certificateMedia {
      id
      name
      uri
      size
      type
      createdAt
      thumbnailUri
    }
    certificateNumber
    receivers {
      id
      name
      phone
      registrationNumber
      dateOfBirth
      gender
      address
      addressDetail
      guardians {
        guardian {
          id
          phone
          name
          gender
          avatar {
            id
            name
            uri
            size
            type
            createdAt
            thumbnailUri
          }
          username
          dateOfBirth
          point
        }
      }
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useGetCaregiverProfileQuery__
 *
 * To run a query within a React component, call `useGetCaregiverProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverProfileQuery({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *   },
 * });
 */
export function useGetCaregiverProfileQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverProfileQuery, GetCaregiverProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverProfileQuery, GetCaregiverProfileQueryVariables>(GetCaregiverProfileDocument, options);
      }
export function useGetCaregiverProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverProfileQuery, GetCaregiverProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverProfileQuery, GetCaregiverProfileQueryVariables>(GetCaregiverProfileDocument, options);
        }
export type GetCaregiverProfileQueryHookResult = ReturnType<typeof useGetCaregiverProfileQuery>;
export type GetCaregiverProfileLazyQueryHookResult = ReturnType<typeof useGetCaregiverProfileLazyQuery>;
export type GetCaregiverProfileQueryResult = Apollo.QueryResult<GetCaregiverProfileQuery, GetCaregiverProfileQueryVariables>;
export const CreateCaregiverAsAdminDocument = gql`
    mutation CreateCaregiverAsAdmin($phone: String!, $profileInput: ProfileInput!, $cityCodes: [ID!]!, $caregiverInput: CaregiverInput!) {
  createCaregiverAsAdmin(
    phone: $phone
    profileInput: $profileInput
    cityCodes: $cityCodes
    caregiverInput: $caregiverInput
  ) {
    id
    name
  }
}
    `;
export type CreateCaregiverAsAdminMutationFn = Apollo.MutationFunction<CreateCaregiverAsAdminMutation, CreateCaregiverAsAdminMutationVariables>;

/**
 * __useCreateCaregiverAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateCaregiverAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaregiverAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaregiverAsAdminMutation, { data, loading, error }] = useCreateCaregiverAsAdminMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *      profileInput: // value for 'profileInput'
 *      cityCodes: // value for 'cityCodes'
 *      caregiverInput: // value for 'caregiverInput'
 *   },
 * });
 */
export function useCreateCaregiverAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaregiverAsAdminMutation, CreateCaregiverAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaregiverAsAdminMutation, CreateCaregiverAsAdminMutationVariables>(CreateCaregiverAsAdminDocument, options);
      }
export type CreateCaregiverAsAdminMutationHookResult = ReturnType<typeof useCreateCaregiverAsAdminMutation>;
export type CreateCaregiverAsAdminMutationResult = Apollo.MutationResult<CreateCaregiverAsAdminMutation>;
export type CreateCaregiverAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateCaregiverAsAdminMutation, CreateCaregiverAsAdminMutationVariables>;
export const ResignCaregiverAsAdminDocument = gql`
    mutation ResignCaregiverAsAdmin($caregiverId: ID!) {
  resignCaregiverAsAdmin(caregiverId: $caregiverId)
}
    `;
export type ResignCaregiverAsAdminMutationFn = Apollo.MutationFunction<ResignCaregiverAsAdminMutation, ResignCaregiverAsAdminMutationVariables>;

/**
 * __useResignCaregiverAsAdminMutation__
 *
 * To run a mutation, you first call `useResignCaregiverAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResignCaregiverAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resignCaregiverAsAdminMutation, { data, loading, error }] = useResignCaregiverAsAdminMutation({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *   },
 * });
 */
export function useResignCaregiverAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<ResignCaregiverAsAdminMutation, ResignCaregiverAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResignCaregiverAsAdminMutation, ResignCaregiverAsAdminMutationVariables>(ResignCaregiverAsAdminDocument, options);
      }
export type ResignCaregiverAsAdminMutationHookResult = ReturnType<typeof useResignCaregiverAsAdminMutation>;
export type ResignCaregiverAsAdminMutationResult = Apollo.MutationResult<ResignCaregiverAsAdminMutation>;
export type ResignCaregiverAsAdminMutationOptions = Apollo.BaseMutationOptions<ResignCaregiverAsAdminMutation, ResignCaregiverAsAdminMutationVariables>;
export const GetWorkHoursAsAdminDocument = gql`
    query GetWorkHoursAsAdmin($receiverId: ID, $caregiverId: ID, $range: RangeInput, $first: Int, $after: String) {
  getWorkHoursAsAdmin(
    receiverId: $receiverId
    caregiverId: $caregiverId
    range: $range
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      caregiver {
        id
        phone
        gender
        name
        point
        createdAt
        updatedAt
      }
      receiver {
        id
        name
        dateOfBirth
        gender
        createdAt
        updatedAt
        deletedAt
        registrationNumber
        phone
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetWorkHoursAsAdminQuery__
 *
 * To run a query within a React component, call `useGetWorkHoursAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkHoursAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkHoursAsAdminQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      caregiverId: // value for 'caregiverId'
 *      range: // value for 'range'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetWorkHoursAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkHoursAsAdminQuery, GetWorkHoursAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkHoursAsAdminQuery, GetWorkHoursAsAdminQueryVariables>(GetWorkHoursAsAdminDocument, options);
      }
export function useGetWorkHoursAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkHoursAsAdminQuery, GetWorkHoursAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkHoursAsAdminQuery, GetWorkHoursAsAdminQueryVariables>(GetWorkHoursAsAdminDocument, options);
        }
export type GetWorkHoursAsAdminQueryHookResult = ReturnType<typeof useGetWorkHoursAsAdminQuery>;
export type GetWorkHoursAsAdminLazyQueryHookResult = ReturnType<typeof useGetWorkHoursAsAdminLazyQuery>;
export type GetWorkHoursAsAdminQueryResult = Apollo.QueryResult<GetWorkHoursAsAdminQuery, GetWorkHoursAsAdminQueryVariables>;
export const SearchCaregiversAsAdminDocument = gql`
    query SearchCaregiversAsAdmin($query: String, $gender: Gender, $first: Int, $after: String) {
  searchCaregiversAsAdmin(
    query: $query
    gender: $gender
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      phone
      gender
      point
      name
      username
      dateOfBirth
      certificateMedia {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      certificateNumber
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useSearchCaregiversAsAdminQuery__
 *
 * To run a query within a React component, call `useSearchCaregiversAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCaregiversAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCaregiversAsAdminQuery({
 *   variables: {
 *      query: // value for 'query'
 *      gender: // value for 'gender'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchCaregiversAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<SearchCaregiversAsAdminQuery, SearchCaregiversAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCaregiversAsAdminQuery, SearchCaregiversAsAdminQueryVariables>(SearchCaregiversAsAdminDocument, options);
      }
export function useSearchCaregiversAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCaregiversAsAdminQuery, SearchCaregiversAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCaregiversAsAdminQuery, SearchCaregiversAsAdminQueryVariables>(SearchCaregiversAsAdminDocument, options);
        }
export type SearchCaregiversAsAdminQueryHookResult = ReturnType<typeof useSearchCaregiversAsAdminQuery>;
export type SearchCaregiversAsAdminLazyQueryHookResult = ReturnType<typeof useSearchCaregiversAsAdminLazyQuery>;
export type SearchCaregiversAsAdminQueryResult = Apollo.QueryResult<SearchCaregiversAsAdminQuery, SearchCaregiversAsAdminQueryVariables>;
export const UpdateCaregiverAsAdminDocument = gql`
    mutation UpdateCaregiverAsAdmin($caregiverId: String!, $phoneNumber: String!, $profileInput: ProfileInput!, $caregiverInput: CaregiverInput!) {
  updateCaregiverAsAdmin(
    caregiverId: $caregiverId
    phoneNumber: $phoneNumber
    profileInput: $profileInput
    caregiverInput: $caregiverInput
  ) {
    id
    phone
    email
    name
    updatedAt
  }
}
    `;
export type UpdateCaregiverAsAdminMutationFn = Apollo.MutationFunction<UpdateCaregiverAsAdminMutation, UpdateCaregiverAsAdminMutationVariables>;

/**
 * __useUpdateCaregiverAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateCaregiverAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaregiverAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaregiverAsAdminMutation, { data, loading, error }] = useUpdateCaregiverAsAdminMutation({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *      phoneNumber: // value for 'phoneNumber'
 *      profileInput: // value for 'profileInput'
 *      caregiverInput: // value for 'caregiverInput'
 *   },
 * });
 */
export function useUpdateCaregiverAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaregiverAsAdminMutation, UpdateCaregiverAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaregiverAsAdminMutation, UpdateCaregiverAsAdminMutationVariables>(UpdateCaregiverAsAdminDocument, options);
      }
export type UpdateCaregiverAsAdminMutationHookResult = ReturnType<typeof useUpdateCaregiverAsAdminMutation>;
export type UpdateCaregiverAsAdminMutationResult = Apollo.MutationResult<UpdateCaregiverAsAdminMutation>;
export type UpdateCaregiverAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateCaregiverAsAdminMutation, UpdateCaregiverAsAdminMutationVariables>;
export const GetChatsOrderByMessagesCountAsAdminDocument = gql`
    query GetChatsOrderByMessagesCountAsAdmin($first: Int, $after: String) {
  getChatsOrderByMessagesCountAsAdmin(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      chatId
      createdAt
      updatedAt
      messageCount
      hasUnreadMessage
      receiver {
        id
        name
        dateOfBirth
        gender
        createdAt
        updatedAt
      }
      users {
        id
        lastSeenAt
        joinAt
        caregiver {
          id
          phone
          gender
          name
          point
          createdAt
          updatedAt
          deletedAt
        }
        guardian {
          id
          phone
          gender
          name
          point
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetChatsOrderByMessagesCountAsAdminQuery__
 *
 * To run a query within a React component, call `useGetChatsOrderByMessagesCountAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsOrderByMessagesCountAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsOrderByMessagesCountAsAdminQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetChatsOrderByMessagesCountAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetChatsOrderByMessagesCountAsAdminQuery, GetChatsOrderByMessagesCountAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsOrderByMessagesCountAsAdminQuery, GetChatsOrderByMessagesCountAsAdminQueryVariables>(GetChatsOrderByMessagesCountAsAdminDocument, options);
      }
export function useGetChatsOrderByMessagesCountAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsOrderByMessagesCountAsAdminQuery, GetChatsOrderByMessagesCountAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsOrderByMessagesCountAsAdminQuery, GetChatsOrderByMessagesCountAsAdminQueryVariables>(GetChatsOrderByMessagesCountAsAdminDocument, options);
        }
export type GetChatsOrderByMessagesCountAsAdminQueryHookResult = ReturnType<typeof useGetChatsOrderByMessagesCountAsAdminQuery>;
export type GetChatsOrderByMessagesCountAsAdminLazyQueryHookResult = ReturnType<typeof useGetChatsOrderByMessagesCountAsAdminLazyQuery>;
export type GetChatsOrderByMessagesCountAsAdminQueryResult = Apollo.QueryResult<GetChatsOrderByMessagesCountAsAdminQuery, GetChatsOrderByMessagesCountAsAdminQueryVariables>;
export const GetCommonCodeGroupsAsAdminDocument = gql`
    query GetCommonCodeGroupsAsAdmin($sortDirection: String, $sortKey: CommonCodeGroupSortKey, $after: String, $first: Int, $query: String, $commonGroupCodeSearchType: CommonCodeGroupSearchType) {
  getCommonCodeGroupsAsAdmin(
    sortDirection: $sortDirection
    sortKey: $sortKey
    after: $after
    first: $first
    query: $query
    commonGroupCodeSearchType: $commonGroupCodeSearchType
  ) {
    pageInfo {
      endCursor
      hasNextPage
      startCursor
    }
    edges {
      id
      groupCode
      name
      status
      createdAt
      updatedAt
      commonCodes {
        id
        code
        name
        status
        commonCodeGroupId
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetCommonCodeGroupsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommonCodeGroupsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCodeGroupsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCodeGroupsAsAdminQuery({
 *   variables: {
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      commonGroupCodeSearchType: // value for 'commonGroupCodeSearchType'
 *   },
 * });
 */
export function useGetCommonCodeGroupsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetCommonCodeGroupsAsAdminQuery, GetCommonCodeGroupsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonCodeGroupsAsAdminQuery, GetCommonCodeGroupsAsAdminQueryVariables>(GetCommonCodeGroupsAsAdminDocument, options);
      }
export function useGetCommonCodeGroupsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCodeGroupsAsAdminQuery, GetCommonCodeGroupsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonCodeGroupsAsAdminQuery, GetCommonCodeGroupsAsAdminQueryVariables>(GetCommonCodeGroupsAsAdminDocument, options);
        }
export type GetCommonCodeGroupsAsAdminQueryHookResult = ReturnType<typeof useGetCommonCodeGroupsAsAdminQuery>;
export type GetCommonCodeGroupsAsAdminLazyQueryHookResult = ReturnType<typeof useGetCommonCodeGroupsAsAdminLazyQuery>;
export type GetCommonCodeGroupsAsAdminQueryResult = Apollo.QueryResult<GetCommonCodeGroupsAsAdminQuery, GetCommonCodeGroupsAsAdminQueryVariables>;
export const GetCommonCodesAsAdminDocument = gql`
    query GetCommonCodesAsAdmin($commonCodeGroupId: String!, $commonCodeSearchType: CommonCodeSearchType, $query: String, $first: Int, $after: String, $sortKey: CommonCodeSortKey, $sortDirection: String) {
  getCommonCodesAsAdmin(
    commonCodeGroupId: $commonCodeGroupId
    commonCodeSearchType: $commonCodeSearchType
    query: $query
    first: $first
    after: $after
    sortKey: $sortKey
    sortDirection: $sortDirection
  ) {
    edges {
      code
      commonCodeGroupId
      createdAt
      id
      name
      status
      updatedAt
    }
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetCommonCodesAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommonCodesAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCodesAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCodesAsAdminQuery({
 *   variables: {
 *      commonCodeGroupId: // value for 'commonCodeGroupId'
 *      commonCodeSearchType: // value for 'commonCodeSearchType'
 *      query: // value for 'query'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetCommonCodesAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCommonCodesAsAdminQuery, GetCommonCodesAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonCodesAsAdminQuery, GetCommonCodesAsAdminQueryVariables>(GetCommonCodesAsAdminDocument, options);
      }
export function useGetCommonCodesAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCodesAsAdminQuery, GetCommonCodesAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonCodesAsAdminQuery, GetCommonCodesAsAdminQueryVariables>(GetCommonCodesAsAdminDocument, options);
        }
export type GetCommonCodesAsAdminQueryHookResult = ReturnType<typeof useGetCommonCodesAsAdminQuery>;
export type GetCommonCodesAsAdminLazyQueryHookResult = ReturnType<typeof useGetCommonCodesAsAdminLazyQuery>;
export type GetCommonCodesAsAdminQueryResult = Apollo.QueryResult<GetCommonCodesAsAdminQuery, GetCommonCodesAsAdminQueryVariables>;
export const CreateCommonCodeGroupAsAdminDocument = gql`
    mutation CreateCommonCodeGroupAsAdmin($createCommonCodeGroupInput: CreateCommonCodeGroupDto!) {
  createCommonCodeGroupAsAdmin(
    createCommonCodeGroupInput: $createCommonCodeGroupInput
  ) {
    id
    name
    status
  }
}
    `;
export type CreateCommonCodeGroupAsAdminMutationFn = Apollo.MutationFunction<CreateCommonCodeGroupAsAdminMutation, CreateCommonCodeGroupAsAdminMutationVariables>;

/**
 * __useCreateCommonCodeGroupAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateCommonCodeGroupAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommonCodeGroupAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommonCodeGroupAsAdminMutation, { data, loading, error }] = useCreateCommonCodeGroupAsAdminMutation({
 *   variables: {
 *      createCommonCodeGroupInput: // value for 'createCommonCodeGroupInput'
 *   },
 * });
 */
export function useCreateCommonCodeGroupAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommonCodeGroupAsAdminMutation, CreateCommonCodeGroupAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommonCodeGroupAsAdminMutation, CreateCommonCodeGroupAsAdminMutationVariables>(CreateCommonCodeGroupAsAdminDocument, options);
      }
export type CreateCommonCodeGroupAsAdminMutationHookResult = ReturnType<typeof useCreateCommonCodeGroupAsAdminMutation>;
export type CreateCommonCodeGroupAsAdminMutationResult = Apollo.MutationResult<CreateCommonCodeGroupAsAdminMutation>;
export type CreateCommonCodeGroupAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateCommonCodeGroupAsAdminMutation, CreateCommonCodeGroupAsAdminMutationVariables>;
export const UpdateCommonCodeGroupAsAdminDocument = gql`
    mutation UpdateCommonCodeGroupAsAdmin($updateCommonCodeGroupInput: UpdateCommonCodeGroupDto!) {
  updateCommonCodeGroupAsAdmin(
    updateCommonCodeGroupInput: $updateCommonCodeGroupInput
  ) {
    id
    name
    status
    groupCode
  }
}
    `;
export type UpdateCommonCodeGroupAsAdminMutationFn = Apollo.MutationFunction<UpdateCommonCodeGroupAsAdminMutation, UpdateCommonCodeGroupAsAdminMutationVariables>;

/**
 * __useUpdateCommonCodeGroupAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateCommonCodeGroupAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommonCodeGroupAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommonCodeGroupAsAdminMutation, { data, loading, error }] = useUpdateCommonCodeGroupAsAdminMutation({
 *   variables: {
 *      updateCommonCodeGroupInput: // value for 'updateCommonCodeGroupInput'
 *   },
 * });
 */
export function useUpdateCommonCodeGroupAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommonCodeGroupAsAdminMutation, UpdateCommonCodeGroupAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommonCodeGroupAsAdminMutation, UpdateCommonCodeGroupAsAdminMutationVariables>(UpdateCommonCodeGroupAsAdminDocument, options);
      }
export type UpdateCommonCodeGroupAsAdminMutationHookResult = ReturnType<typeof useUpdateCommonCodeGroupAsAdminMutation>;
export type UpdateCommonCodeGroupAsAdminMutationResult = Apollo.MutationResult<UpdateCommonCodeGroupAsAdminMutation>;
export type UpdateCommonCodeGroupAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateCommonCodeGroupAsAdminMutation, UpdateCommonCodeGroupAsAdminMutationVariables>;
export const DeleteCommonCodeGroupAsAdminDocument = gql`
    mutation DeleteCommonCodeGroupAsAdmin($commonCodeGroupId: String!) {
  deleteCommonCodeGroupAsAdmin(commonCodeGroupId: $commonCodeGroupId) {
    id
    name
    status
    updatedAt
    groupCode
  }
}
    `;
export type DeleteCommonCodeGroupAsAdminMutationFn = Apollo.MutationFunction<DeleteCommonCodeGroupAsAdminMutation, DeleteCommonCodeGroupAsAdminMutationVariables>;

/**
 * __useDeleteCommonCodeGroupAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteCommonCodeGroupAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommonCodeGroupAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommonCodeGroupAsAdminMutation, { data, loading, error }] = useDeleteCommonCodeGroupAsAdminMutation({
 *   variables: {
 *      commonCodeGroupId: // value for 'commonCodeGroupId'
 *   },
 * });
 */
export function useDeleteCommonCodeGroupAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommonCodeGroupAsAdminMutation, DeleteCommonCodeGroupAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommonCodeGroupAsAdminMutation, DeleteCommonCodeGroupAsAdminMutationVariables>(DeleteCommonCodeGroupAsAdminDocument, options);
      }
export type DeleteCommonCodeGroupAsAdminMutationHookResult = ReturnType<typeof useDeleteCommonCodeGroupAsAdminMutation>;
export type DeleteCommonCodeGroupAsAdminMutationResult = Apollo.MutationResult<DeleteCommonCodeGroupAsAdminMutation>;
export type DeleteCommonCodeGroupAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteCommonCodeGroupAsAdminMutation, DeleteCommonCodeGroupAsAdminMutationVariables>;
export const DeleteCommonCodeAsAdminDocument = gql`
    mutation DeleteCommonCodeAsAdmin($commonCodeId: String!) {
  deleteCommonCodeAsAdmin(commonCodeId: $commonCodeId) {
    commonCodeGroupId
    createdAt
    id
    name
    status
    updatedAt
  }
}
    `;
export type DeleteCommonCodeAsAdminMutationFn = Apollo.MutationFunction<DeleteCommonCodeAsAdminMutation, DeleteCommonCodeAsAdminMutationVariables>;

/**
 * __useDeleteCommonCodeAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteCommonCodeAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommonCodeAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommonCodeAsAdminMutation, { data, loading, error }] = useDeleteCommonCodeAsAdminMutation({
 *   variables: {
 *      commonCodeId: // value for 'commonCodeId'
 *   },
 * });
 */
export function useDeleteCommonCodeAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommonCodeAsAdminMutation, DeleteCommonCodeAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommonCodeAsAdminMutation, DeleteCommonCodeAsAdminMutationVariables>(DeleteCommonCodeAsAdminDocument, options);
      }
export type DeleteCommonCodeAsAdminMutationHookResult = ReturnType<typeof useDeleteCommonCodeAsAdminMutation>;
export type DeleteCommonCodeAsAdminMutationResult = Apollo.MutationResult<DeleteCommonCodeAsAdminMutation>;
export type DeleteCommonCodeAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteCommonCodeAsAdminMutation, DeleteCommonCodeAsAdminMutationVariables>;
export const UpdateCommonCodeAsAdminDocument = gql`
    mutation UpdateCommonCodeAsAdmin($updateCommonCodeInput: UpdateCommonCodeDto!) {
  updateCommonCodeAsAdmin(updateCommonCodeInput: $updateCommonCodeInput) {
    code
    id
    name
    status
    updatedAt
    createdAt
    commonCodeGroupId
  }
}
    `;
export type UpdateCommonCodeAsAdminMutationFn = Apollo.MutationFunction<UpdateCommonCodeAsAdminMutation, UpdateCommonCodeAsAdminMutationVariables>;

/**
 * __useUpdateCommonCodeAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateCommonCodeAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommonCodeAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommonCodeAsAdminMutation, { data, loading, error }] = useUpdateCommonCodeAsAdminMutation({
 *   variables: {
 *      updateCommonCodeInput: // value for 'updateCommonCodeInput'
 *   },
 * });
 */
export function useUpdateCommonCodeAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommonCodeAsAdminMutation, UpdateCommonCodeAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommonCodeAsAdminMutation, UpdateCommonCodeAsAdminMutationVariables>(UpdateCommonCodeAsAdminDocument, options);
      }
export type UpdateCommonCodeAsAdminMutationHookResult = ReturnType<typeof useUpdateCommonCodeAsAdminMutation>;
export type UpdateCommonCodeAsAdminMutationResult = Apollo.MutationResult<UpdateCommonCodeAsAdminMutation>;
export type UpdateCommonCodeAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateCommonCodeAsAdminMutation, UpdateCommonCodeAsAdminMutationVariables>;
export const CreateCommonCodeAsAdminDocument = gql`
    mutation CreateCommonCodeAsAdmin($createCommonCodeInput: CreateCommonCodeDto!) {
  createCommonCodeAsAdmin(createCommonCodeInput: $createCommonCodeInput) {
    code
    commonCodeGroupId
    createdAt
    id
    name
    status
    updatedAt
  }
}
    `;
export type CreateCommonCodeAsAdminMutationFn = Apollo.MutationFunction<CreateCommonCodeAsAdminMutation, CreateCommonCodeAsAdminMutationVariables>;

/**
 * __useCreateCommonCodeAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateCommonCodeAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommonCodeAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommonCodeAsAdminMutation, { data, loading, error }] = useCreateCommonCodeAsAdminMutation({
 *   variables: {
 *      createCommonCodeInput: // value for 'createCommonCodeInput'
 *   },
 * });
 */
export function useCreateCommonCodeAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommonCodeAsAdminMutation, CreateCommonCodeAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommonCodeAsAdminMutation, CreateCommonCodeAsAdminMutationVariables>(CreateCommonCodeAsAdminDocument, options);
      }
export type CreateCommonCodeAsAdminMutationHookResult = ReturnType<typeof useCreateCommonCodeAsAdminMutation>;
export type CreateCommonCodeAsAdminMutationResult = Apollo.MutationResult<CreateCommonCodeAsAdminMutation>;
export type CreateCommonCodeAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateCommonCodeAsAdminMutation, CreateCommonCodeAsAdminMutationVariables>;
export const GetCommonCodeGroupAsAdminDocument = gql`
    query GetCommonCodeGroupAsAdmin($groupId: String!) {
  getCommonCodeGroupAsAdmin(groupId: $groupId) {
    id
    name
    status
    updatedAt
    groupCode
    createdAt
  }
}
    `;

/**
 * __useGetCommonCodeGroupAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommonCodeGroupAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCodeGroupAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCodeGroupAsAdminQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCommonCodeGroupAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCommonCodeGroupAsAdminQuery, GetCommonCodeGroupAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonCodeGroupAsAdminQuery, GetCommonCodeGroupAsAdminQueryVariables>(GetCommonCodeGroupAsAdminDocument, options);
      }
export function useGetCommonCodeGroupAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCodeGroupAsAdminQuery, GetCommonCodeGroupAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonCodeGroupAsAdminQuery, GetCommonCodeGroupAsAdminQueryVariables>(GetCommonCodeGroupAsAdminDocument, options);
        }
export type GetCommonCodeGroupAsAdminQueryHookResult = ReturnType<typeof useGetCommonCodeGroupAsAdminQuery>;
export type GetCommonCodeGroupAsAdminLazyQueryHookResult = ReturnType<typeof useGetCommonCodeGroupAsAdminLazyQuery>;
export type GetCommonCodeGroupAsAdminQueryResult = Apollo.QueryResult<GetCommonCodeGroupAsAdminQuery, GetCommonCodeGroupAsAdminQueryVariables>;
export const GetCommonCodeAsAdminDocument = gql`
    query GetCommonCodeAsAdmin($commonCodeId: String!) {
  getCommonCodeAsAdmin(commonCodeId: $commonCodeId) {
    code
    commonCodeGroupId
    createdAt
    id
    name
    status
    updatedAt
  }
}
    `;

/**
 * __useGetCommonCodeAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommonCodeAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCodeAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCodeAsAdminQuery({
 *   variables: {
 *      commonCodeId: // value for 'commonCodeId'
 *   },
 * });
 */
export function useGetCommonCodeAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCommonCodeAsAdminQuery, GetCommonCodeAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonCodeAsAdminQuery, GetCommonCodeAsAdminQueryVariables>(GetCommonCodeAsAdminDocument, options);
      }
export function useGetCommonCodeAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCodeAsAdminQuery, GetCommonCodeAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonCodeAsAdminQuery, GetCommonCodeAsAdminQueryVariables>(GetCommonCodeAsAdminDocument, options);
        }
export type GetCommonCodeAsAdminQueryHookResult = ReturnType<typeof useGetCommonCodeAsAdminQuery>;
export type GetCommonCodeAsAdminLazyQueryHookResult = ReturnType<typeof useGetCommonCodeAsAdminLazyQuery>;
export type GetCommonCodeAsAdminQueryResult = Apollo.QueryResult<GetCommonCodeAsAdminQuery, GetCommonCodeAsAdminQueryVariables>;
export const GetCommonCodeGroupsForSelectionAsAdminDocument = gql`
    query GetCommonCodeGroupsForSelectionAsAdmin($sortDirection: String, $sortKey: CommonCodeGroupSortKey, $after: String, $first: Int, $query: String, $commonGroupCodeSearchType: CommonCodeGroupSearchType) {
  getCommonCodeGroupsAsAdmin(
    sortDirection: $sortDirection
    sortKey: $sortKey
    after: $after
    first: $first
    query: $query
    commonGroupCodeSearchType: $commonGroupCodeSearchType
  ) {
    pageInfo {
      endCursor
      hasNextPage
      startCursor
    }
    edges {
      id
      groupCode
      name
    }
  }
}
    `;

/**
 * __useGetCommonCodeGroupsForSelectionAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommonCodeGroupsForSelectionAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCodeGroupsForSelectionAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCodeGroupsForSelectionAsAdminQuery({
 *   variables: {
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      query: // value for 'query'
 *      commonGroupCodeSearchType: // value for 'commonGroupCodeSearchType'
 *   },
 * });
 */
export function useGetCommonCodeGroupsForSelectionAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetCommonCodeGroupsForSelectionAsAdminQuery, GetCommonCodeGroupsForSelectionAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonCodeGroupsForSelectionAsAdminQuery, GetCommonCodeGroupsForSelectionAsAdminQueryVariables>(GetCommonCodeGroupsForSelectionAsAdminDocument, options);
      }
export function useGetCommonCodeGroupsForSelectionAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCodeGroupsForSelectionAsAdminQuery, GetCommonCodeGroupsForSelectionAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonCodeGroupsForSelectionAsAdminQuery, GetCommonCodeGroupsForSelectionAsAdminQueryVariables>(GetCommonCodeGroupsForSelectionAsAdminDocument, options);
        }
export type GetCommonCodeGroupsForSelectionAsAdminQueryHookResult = ReturnType<typeof useGetCommonCodeGroupsForSelectionAsAdminQuery>;
export type GetCommonCodeGroupsForSelectionAsAdminLazyQueryHookResult = ReturnType<typeof useGetCommonCodeGroupsForSelectionAsAdminLazyQuery>;
export type GetCommonCodeGroupsForSelectionAsAdminQueryResult = Apollo.QueryResult<GetCommonCodeGroupsForSelectionAsAdminQuery, GetCommonCodeGroupsForSelectionAsAdminQueryVariables>;
export const GetCommonCodeGroupsByTypeAsAdminDocument = gql`
    query GetCommonCodeGroupsByTypeAsAdmin($types: [CommonCodeGroupType!]!) {
  getCommonCodeGroupsByTypeAsAdmin(types: $types) {
    activeCommonCodes {
      code
      id
      name
    }
    groupCode
    id
    name
  }
}
    `;

/**
 * __useGetCommonCodeGroupsByTypeAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommonCodeGroupsByTypeAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommonCodeGroupsByTypeAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommonCodeGroupsByTypeAsAdminQuery({
 *   variables: {
 *      types: // value for 'types'
 *   },
 * });
 */
export function useGetCommonCodeGroupsByTypeAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCommonCodeGroupsByTypeAsAdminQuery, GetCommonCodeGroupsByTypeAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommonCodeGroupsByTypeAsAdminQuery, GetCommonCodeGroupsByTypeAsAdminQueryVariables>(GetCommonCodeGroupsByTypeAsAdminDocument, options);
      }
export function useGetCommonCodeGroupsByTypeAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommonCodeGroupsByTypeAsAdminQuery, GetCommonCodeGroupsByTypeAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommonCodeGroupsByTypeAsAdminQuery, GetCommonCodeGroupsByTypeAsAdminQueryVariables>(GetCommonCodeGroupsByTypeAsAdminDocument, options);
        }
export type GetCommonCodeGroupsByTypeAsAdminQueryHookResult = ReturnType<typeof useGetCommonCodeGroupsByTypeAsAdminQuery>;
export type GetCommonCodeGroupsByTypeAsAdminLazyQueryHookResult = ReturnType<typeof useGetCommonCodeGroupsByTypeAsAdminLazyQuery>;
export type GetCommonCodeGroupsByTypeAsAdminQueryResult = Apollo.QueryResult<GetCommonCodeGroupsByTypeAsAdminQuery, GetCommonCodeGroupsByTypeAsAdminQueryVariables>;
export const GetCaregiverCommunitiesByTypeAsAdminDocument = gql`
    query GetCaregiverCommunitiesByTypeAsAdmin($type: CaregiverCommunityType, $range: RangeInput, $first: Int!, $after: String) {
  getCaregiverCommunitiesByTypeAsAdmin(
    type: $type
    range: $range
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      author {
        name
        gender
        email
        phone
        id
        point
        updatedAt
        createdAt
        deletedAt
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
      }
      body
      type
      media {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      replyCount
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetCaregiverCommunitiesByTypeAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCaregiverCommunitiesByTypeAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverCommunitiesByTypeAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverCommunitiesByTypeAsAdminQuery({
 *   variables: {
 *      type: // value for 'type'
 *      range: // value for 'range'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCaregiverCommunitiesByTypeAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverCommunitiesByTypeAsAdminQuery, GetCaregiverCommunitiesByTypeAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverCommunitiesByTypeAsAdminQuery, GetCaregiverCommunitiesByTypeAsAdminQueryVariables>(GetCaregiverCommunitiesByTypeAsAdminDocument, options);
      }
export function useGetCaregiverCommunitiesByTypeAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverCommunitiesByTypeAsAdminQuery, GetCaregiverCommunitiesByTypeAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverCommunitiesByTypeAsAdminQuery, GetCaregiverCommunitiesByTypeAsAdminQueryVariables>(GetCaregiverCommunitiesByTypeAsAdminDocument, options);
        }
export type GetCaregiverCommunitiesByTypeAsAdminQueryHookResult = ReturnType<typeof useGetCaregiverCommunitiesByTypeAsAdminQuery>;
export type GetCaregiverCommunitiesByTypeAsAdminLazyQueryHookResult = ReturnType<typeof useGetCaregiverCommunitiesByTypeAsAdminLazyQuery>;
export type GetCaregiverCommunitiesByTypeAsAdminQueryResult = Apollo.QueryResult<GetCaregiverCommunitiesByTypeAsAdminQuery, GetCaregiverCommunitiesByTypeAsAdminQueryVariables>;
export const GetCaregiverCommunitiesByAuthorAsAdminDocument = gql`
    query GetCaregiverCommunitiesByAuthorAsAdmin($caregiverId: ID!, $first: Int!, $after: String) {
  getCaregiverCommunitiesByAuthorAsAdmin(
    caregiverId: $caregiverId
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      author {
        id
        phone
        gender
        name
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
        username
        dateOfBirth
        point
        certificateNumber
        createdAt
        updatedAt
        deletedAt
      }
      body
      type
      media {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      replyCount
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetCaregiverCommunitiesByAuthorAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCaregiverCommunitiesByAuthorAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverCommunitiesByAuthorAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverCommunitiesByAuthorAsAdminQuery({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCaregiverCommunitiesByAuthorAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverCommunitiesByAuthorAsAdminQuery, GetCaregiverCommunitiesByAuthorAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverCommunitiesByAuthorAsAdminQuery, GetCaregiverCommunitiesByAuthorAsAdminQueryVariables>(GetCaregiverCommunitiesByAuthorAsAdminDocument, options);
      }
export function useGetCaregiverCommunitiesByAuthorAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverCommunitiesByAuthorAsAdminQuery, GetCaregiverCommunitiesByAuthorAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverCommunitiesByAuthorAsAdminQuery, GetCaregiverCommunitiesByAuthorAsAdminQueryVariables>(GetCaregiverCommunitiesByAuthorAsAdminDocument, options);
        }
export type GetCaregiverCommunitiesByAuthorAsAdminQueryHookResult = ReturnType<typeof useGetCaregiverCommunitiesByAuthorAsAdminQuery>;
export type GetCaregiverCommunitiesByAuthorAsAdminLazyQueryHookResult = ReturnType<typeof useGetCaregiverCommunitiesByAuthorAsAdminLazyQuery>;
export type GetCaregiverCommunitiesByAuthorAsAdminQueryResult = Apollo.QueryResult<GetCaregiverCommunitiesByAuthorAsAdminQuery, GetCaregiverCommunitiesByAuthorAsAdminQueryVariables>;
export const GetCaregiverCommunityRepliesByCommunityAsAdminDocument = gql`
    query GetCaregiverCommunityRepliesByCommunityAsAdmin($communityId: ID!, $first: Int!, $after: String) {
  getCaregiverCommunityRepliesByCommunityAsAdmin(
    communityId: $communityId
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      author {
        id
        phone
        gender
        name
        point
        createdAt
        updatedAt
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
      }
      updatedAt
      deletedAt
      createdAt
      body
    }
  }
}
    `;

/**
 * __useGetCaregiverCommunityRepliesByCommunityAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCaregiverCommunityRepliesByCommunityAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverCommunityRepliesByCommunityAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverCommunityRepliesByCommunityAsAdminQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCaregiverCommunityRepliesByCommunityAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverCommunityRepliesByCommunityAsAdminQuery, GetCaregiverCommunityRepliesByCommunityAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverCommunityRepliesByCommunityAsAdminQuery, GetCaregiverCommunityRepliesByCommunityAsAdminQueryVariables>(GetCaregiverCommunityRepliesByCommunityAsAdminDocument, options);
      }
export function useGetCaregiverCommunityRepliesByCommunityAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverCommunityRepliesByCommunityAsAdminQuery, GetCaregiverCommunityRepliesByCommunityAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverCommunityRepliesByCommunityAsAdminQuery, GetCaregiverCommunityRepliesByCommunityAsAdminQueryVariables>(GetCaregiverCommunityRepliesByCommunityAsAdminDocument, options);
        }
export type GetCaregiverCommunityRepliesByCommunityAsAdminQueryHookResult = ReturnType<typeof useGetCaregiverCommunityRepliesByCommunityAsAdminQuery>;
export type GetCaregiverCommunityRepliesByCommunityAsAdminLazyQueryHookResult = ReturnType<typeof useGetCaregiverCommunityRepliesByCommunityAsAdminLazyQuery>;
export type GetCaregiverCommunityRepliesByCommunityAsAdminQueryResult = Apollo.QueryResult<GetCaregiverCommunityRepliesByCommunityAsAdminQuery, GetCaregiverCommunityRepliesByCommunityAsAdminQueryVariables>;
export const DeleteCaregiverCommunityDocument = gql`
    mutation DeleteCaregiverCommunity($communityId: ID!) {
  deleteCaregiverCommunity(communityId: $communityId) {
    id
    author {
      id
      phone
      gender
      name
      username
      dateOfBirth
      point
      certificateNumber
      createdAt
      updatedAt
      deletedAt
    }
    body
    type
    replyCount
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type DeleteCaregiverCommunityMutationFn = Apollo.MutationFunction<DeleteCaregiverCommunityMutation, DeleteCaregiverCommunityMutationVariables>;

/**
 * __useDeleteCaregiverCommunityMutation__
 *
 * To run a mutation, you first call `useDeleteCaregiverCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaregiverCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaregiverCommunityMutation, { data, loading, error }] = useDeleteCaregiverCommunityMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useDeleteCaregiverCommunityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaregiverCommunityMutation, DeleteCaregiverCommunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaregiverCommunityMutation, DeleteCaregiverCommunityMutationVariables>(DeleteCaregiverCommunityDocument, options);
      }
export type DeleteCaregiverCommunityMutationHookResult = ReturnType<typeof useDeleteCaregiverCommunityMutation>;
export type DeleteCaregiverCommunityMutationResult = Apollo.MutationResult<DeleteCaregiverCommunityMutation>;
export type DeleteCaregiverCommunityMutationOptions = Apollo.BaseMutationOptions<DeleteCaregiverCommunityMutation, DeleteCaregiverCommunityMutationVariables>;
export const GetYearlyCommunityTrendAsAdminDocument = gql`
    query GetYearlyCommunityTrendAsAdmin {
  getYearlyCommunityTrendAsAdmin {
    general
    secret
  }
}
    `;

/**
 * __useGetYearlyCommunityTrendAsAdminQuery__
 *
 * To run a query within a React component, call `useGetYearlyCommunityTrendAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearlyCommunityTrendAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearlyCommunityTrendAsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYearlyCommunityTrendAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetYearlyCommunityTrendAsAdminQuery, GetYearlyCommunityTrendAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYearlyCommunityTrendAsAdminQuery, GetYearlyCommunityTrendAsAdminQueryVariables>(GetYearlyCommunityTrendAsAdminDocument, options);
      }
export function useGetYearlyCommunityTrendAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYearlyCommunityTrendAsAdminQuery, GetYearlyCommunityTrendAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYearlyCommunityTrendAsAdminQuery, GetYearlyCommunityTrendAsAdminQueryVariables>(GetYearlyCommunityTrendAsAdminDocument, options);
        }
export type GetYearlyCommunityTrendAsAdminQueryHookResult = ReturnType<typeof useGetYearlyCommunityTrendAsAdminQuery>;
export type GetYearlyCommunityTrendAsAdminLazyQueryHookResult = ReturnType<typeof useGetYearlyCommunityTrendAsAdminLazyQuery>;
export type GetYearlyCommunityTrendAsAdminQueryResult = Apollo.QueryResult<GetYearlyCommunityTrendAsAdminQuery, GetYearlyCommunityTrendAsAdminQueryVariables>;
export const GetGuardianProfileDocument = gql`
    query GetGuardianProfile($guardianId: String!) {
  getGuardianProfile(guardianId: $guardianId) {
    id
    phone
    role {
      id
      name
    }
    gender
    name
    avatar {
      id
      name
      uri
      size
      type
      createdAt
      thumbnailUri
    }
    username
    dateOfBirth
    point
    createdAt
    updatedAt
    deletedAt
    receivers {
      id
      name
      phone
      gender
      address
      dateOfBirth
      caregivers {
        caregiver {
          id
          phone
          email
          gender
          avatar {
            id
            name
            uri
            size
            type
            createdAt
            thumbnailUri
          }
          name
          username
          dateOfBirth
          point
        }
      }
    }
  }
}
    `;

/**
 * __useGetGuardianProfileQuery__
 *
 * To run a query within a React component, call `useGetGuardianProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuardianProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuardianProfileQuery({
 *   variables: {
 *      guardianId: // value for 'guardianId'
 *   },
 * });
 */
export function useGetGuardianProfileQuery(baseOptions: Apollo.QueryHookOptions<GetGuardianProfileQuery, GetGuardianProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuardianProfileQuery, GetGuardianProfileQueryVariables>(GetGuardianProfileDocument, options);
      }
export function useGetGuardianProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuardianProfileQuery, GetGuardianProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuardianProfileQuery, GetGuardianProfileQueryVariables>(GetGuardianProfileDocument, options);
        }
export type GetGuardianProfileQueryHookResult = ReturnType<typeof useGetGuardianProfileQuery>;
export type GetGuardianProfileLazyQueryHookResult = ReturnType<typeof useGetGuardianProfileLazyQuery>;
export type GetGuardianProfileQueryResult = Apollo.QueryResult<GetGuardianProfileQuery, GetGuardianProfileQueryVariables>;
export const SearchGuardiansAsAdminDocument = gql`
    query SearchGuardiansAsAdmin($query: String!, $gender: Gender, $first: Int!, $after: String) {
  searchGuardiansAsAdmin(
    query: $query
    gender: $gender
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      phone
      gender
      name
      avatar {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      username
      dateOfBirth
      point
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useSearchGuardiansAsAdminQuery__
 *
 * To run a query within a React component, call `useSearchGuardiansAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchGuardiansAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchGuardiansAsAdminQuery({
 *   variables: {
 *      query: // value for 'query'
 *      gender: // value for 'gender'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchGuardiansAsAdminQuery(baseOptions: Apollo.QueryHookOptions<SearchGuardiansAsAdminQuery, SearchGuardiansAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchGuardiansAsAdminQuery, SearchGuardiansAsAdminQueryVariables>(SearchGuardiansAsAdminDocument, options);
      }
export function useSearchGuardiansAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchGuardiansAsAdminQuery, SearchGuardiansAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchGuardiansAsAdminQuery, SearchGuardiansAsAdminQueryVariables>(SearchGuardiansAsAdminDocument, options);
        }
export type SearchGuardiansAsAdminQueryHookResult = ReturnType<typeof useSearchGuardiansAsAdminQuery>;
export type SearchGuardiansAsAdminLazyQueryHookResult = ReturnType<typeof useSearchGuardiansAsAdminLazyQuery>;
export type SearchGuardiansAsAdminQueryResult = Apollo.QueryResult<SearchGuardiansAsAdminQuery, SearchGuardiansAsAdminQueryVariables>;
export const GetGuardiansAsAdminDocument = gql`
    query GetGuardiansAsAdmin($gender: Gender, $first: Int!, $after: String) {
  getGuardiansAsAdmin(gender: $gender, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      phone
      gender
      name
      avatar {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      username
      dateOfBirth
      point
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetGuardiansAsAdminQuery__
 *
 * To run a query within a React component, call `useGetGuardiansAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGuardiansAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGuardiansAsAdminQuery({
 *   variables: {
 *      gender: // value for 'gender'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetGuardiansAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetGuardiansAsAdminQuery, GetGuardiansAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGuardiansAsAdminQuery, GetGuardiansAsAdminQueryVariables>(GetGuardiansAsAdminDocument, options);
      }
export function useGetGuardiansAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGuardiansAsAdminQuery, GetGuardiansAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGuardiansAsAdminQuery, GetGuardiansAsAdminQueryVariables>(GetGuardiansAsAdminDocument, options);
        }
export type GetGuardiansAsAdminQueryHookResult = ReturnType<typeof useGetGuardiansAsAdminQuery>;
export type GetGuardiansAsAdminLazyQueryHookResult = ReturnType<typeof useGetGuardiansAsAdminLazyQuery>;
export type GetGuardiansAsAdminQueryResult = Apollo.QueryResult<GetGuardiansAsAdminQuery, GetGuardiansAsAdminQueryVariables>;
export const ResignGuardianAsAdminDocument = gql`
    mutation ResignGuardianAsAdmin($guardianId: String!) {
  resignGuardianAsAdmin(guardianId: $guardianId)
}
    `;
export type ResignGuardianAsAdminMutationFn = Apollo.MutationFunction<ResignGuardianAsAdminMutation, ResignGuardianAsAdminMutationVariables>;

/**
 * __useResignGuardianAsAdminMutation__
 *
 * To run a mutation, you first call `useResignGuardianAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResignGuardianAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resignGuardianAsAdminMutation, { data, loading, error }] = useResignGuardianAsAdminMutation({
 *   variables: {
 *      guardianId: // value for 'guardianId'
 *   },
 * });
 */
export function useResignGuardianAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<ResignGuardianAsAdminMutation, ResignGuardianAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResignGuardianAsAdminMutation, ResignGuardianAsAdminMutationVariables>(ResignGuardianAsAdminDocument, options);
      }
export type ResignGuardianAsAdminMutationHookResult = ReturnType<typeof useResignGuardianAsAdminMutation>;
export type ResignGuardianAsAdminMutationResult = Apollo.MutationResult<ResignGuardianAsAdminMutation>;
export type ResignGuardianAsAdminMutationOptions = Apollo.BaseMutationOptions<ResignGuardianAsAdminMutation, ResignGuardianAsAdminMutationVariables>;
export const CreateGuardianAsAdminDocument = gql`
    mutation CreateGuardianAsAdmin($phoneNumber: String!, $profileInput: ProfileInput!) {
  createGuardianAsAdmin(phoneNumber: $phoneNumber, profileInput: $profileInput) {
    id
    phone
    gender
    name
    point
    createdAt
    updatedAt
  }
}
    `;
export type CreateGuardianAsAdminMutationFn = Apollo.MutationFunction<CreateGuardianAsAdminMutation, CreateGuardianAsAdminMutationVariables>;

/**
 * __useCreateGuardianAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateGuardianAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuardianAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuardianAsAdminMutation, { data, loading, error }] = useCreateGuardianAsAdminMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useCreateGuardianAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuardianAsAdminMutation, CreateGuardianAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuardianAsAdminMutation, CreateGuardianAsAdminMutationVariables>(CreateGuardianAsAdminDocument, options);
      }
export type CreateGuardianAsAdminMutationHookResult = ReturnType<typeof useCreateGuardianAsAdminMutation>;
export type CreateGuardianAsAdminMutationResult = Apollo.MutationResult<CreateGuardianAsAdminMutation>;
export type CreateGuardianAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateGuardianAsAdminMutation, CreateGuardianAsAdminMutationVariables>;
export const UpdateGuardianAsAdminDocument = gql`
    mutation UpdateGuardianAsAdmin($phoneNumber: String!, $guardianId: String!, $profileInput: ProfileInput!) {
  updateGuardianAsAdmin(
    phoneNumber: $phoneNumber
    guardianId: $guardianId
    profileInput: $profileInput
  ) {
    id
    phone
    name
    updatedAt
  }
}
    `;
export type UpdateGuardianAsAdminMutationFn = Apollo.MutationFunction<UpdateGuardianAsAdminMutation, UpdateGuardianAsAdminMutationVariables>;

/**
 * __useUpdateGuardianAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateGuardianAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGuardianAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGuardianAsAdminMutation, { data, loading, error }] = useUpdateGuardianAsAdminMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *      guardianId: // value for 'guardianId'
 *      profileInput: // value for 'profileInput'
 *   },
 * });
 */
export function useUpdateGuardianAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGuardianAsAdminMutation, UpdateGuardianAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGuardianAsAdminMutation, UpdateGuardianAsAdminMutationVariables>(UpdateGuardianAsAdminDocument, options);
      }
export type UpdateGuardianAsAdminMutationHookResult = ReturnType<typeof useUpdateGuardianAsAdminMutation>;
export type UpdateGuardianAsAdminMutationResult = Apollo.MutationResult<UpdateGuardianAsAdminMutation>;
export type UpdateGuardianAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateGuardianAsAdminMutation, UpdateGuardianAsAdminMutationVariables>;
export const UpdateCaregiverInfoAsAdminDocument = gql`
    mutation UpdateCaregiverInfoAsAdmin($caregiverInfoInput: CaregiverInfoInput!) {
  updateCaregiverInfoAsAdmin(caregiverInfoInput: $caregiverInfoInput) {
    id
    body
    title
    summary
    media {
      id
      uri
    }
    createdAt
    cities {
      cityCode
      name
      state {
        stateCode
        name
      }
    }
  }
}
    `;
export type UpdateCaregiverInfoAsAdminMutationFn = Apollo.MutationFunction<UpdateCaregiverInfoAsAdminMutation, UpdateCaregiverInfoAsAdminMutationVariables>;

/**
 * __useUpdateCaregiverInfoAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateCaregiverInfoAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaregiverInfoAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaregiverInfoAsAdminMutation, { data, loading, error }] = useUpdateCaregiverInfoAsAdminMutation({
 *   variables: {
 *      caregiverInfoInput: // value for 'caregiverInfoInput'
 *   },
 * });
 */
export function useUpdateCaregiverInfoAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaregiverInfoAsAdminMutation, UpdateCaregiverInfoAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaregiverInfoAsAdminMutation, UpdateCaregiverInfoAsAdminMutationVariables>(UpdateCaregiverInfoAsAdminDocument, options);
      }
export type UpdateCaregiverInfoAsAdminMutationHookResult = ReturnType<typeof useUpdateCaregiverInfoAsAdminMutation>;
export type UpdateCaregiverInfoAsAdminMutationResult = Apollo.MutationResult<UpdateCaregiverInfoAsAdminMutation>;
export type UpdateCaregiverInfoAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateCaregiverInfoAsAdminMutation, UpdateCaregiverInfoAsAdminMutationVariables>;
export const GetCaregiverInfosDocument = gql`
    query GetCaregiverInfos($first: Int, $after: String, $cityCodes: [ID!]) {
  getCaregiverInfos(first: $first, after: $after, cityCodes: $cityCodes) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      body
      title
      summary
      media {
        id
        uri
      }
      replyCount
      cities {
        cityCode
        name
        state {
          stateCode
          name
        }
      }
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetCaregiverInfosQuery__
 *
 * To run a query within a React component, call `useGetCaregiverInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverInfosQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      cityCodes: // value for 'cityCodes'
 *   },
 * });
 */
export function useGetCaregiverInfosQuery(baseOptions?: Apollo.QueryHookOptions<GetCaregiverInfosQuery, GetCaregiverInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverInfosQuery, GetCaregiverInfosQueryVariables>(GetCaregiverInfosDocument, options);
      }
export function useGetCaregiverInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverInfosQuery, GetCaregiverInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverInfosQuery, GetCaregiverInfosQueryVariables>(GetCaregiverInfosDocument, options);
        }
export type GetCaregiverInfosQueryHookResult = ReturnType<typeof useGetCaregiverInfosQuery>;
export type GetCaregiverInfosLazyQueryHookResult = ReturnType<typeof useGetCaregiverInfosLazyQuery>;
export type GetCaregiverInfosQueryResult = Apollo.QueryResult<GetCaregiverInfosQuery, GetCaregiverInfosQueryVariables>;
export const GetCaregiverInfoDocument = gql`
    query GetCaregiverInfo($infoId: ID!) {
  getCaregiverInfo(infoId: $infoId) {
    id
    body
    title
    summary
    media {
      id
      uri
    }
    replyCount
    cities {
      cityCode
      state {
        stateCode
        name
      }
      name
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useGetCaregiverInfoQuery__
 *
 * To run a query within a React component, call `useGetCaregiverInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverInfoQuery({
 *   variables: {
 *      infoId: // value for 'infoId'
 *   },
 * });
 */
export function useGetCaregiverInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverInfoQuery, GetCaregiverInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverInfoQuery, GetCaregiverInfoQueryVariables>(GetCaregiverInfoDocument, options);
      }
export function useGetCaregiverInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverInfoQuery, GetCaregiverInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverInfoQuery, GetCaregiverInfoQueryVariables>(GetCaregiverInfoDocument, options);
        }
export type GetCaregiverInfoQueryHookResult = ReturnType<typeof useGetCaregiverInfoQuery>;
export type GetCaregiverInfoLazyQueryHookResult = ReturnType<typeof useGetCaregiverInfoLazyQuery>;
export type GetCaregiverInfoQueryResult = Apollo.QueryResult<GetCaregiverInfoQuery, GetCaregiverInfoQueryVariables>;
export const DeleteCaregiverInfoAsAdminDocument = gql`
    mutation DeleteCaregiverInfoAsAdmin($infoId: ID!) {
  deleteCaregiverInfoAsAdmin(infoId: $infoId) {
    id
    replyCount
    createdAt
    updatedAt
  }
}
    `;
export type DeleteCaregiverInfoAsAdminMutationFn = Apollo.MutationFunction<DeleteCaregiverInfoAsAdminMutation, DeleteCaregiverInfoAsAdminMutationVariables>;

/**
 * __useDeleteCaregiverInfoAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteCaregiverInfoAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaregiverInfoAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaregiverInfoAsAdminMutation, { data, loading, error }] = useDeleteCaregiverInfoAsAdminMutation({
 *   variables: {
 *      infoId: // value for 'infoId'
 *   },
 * });
 */
export function useDeleteCaregiverInfoAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaregiverInfoAsAdminMutation, DeleteCaregiverInfoAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaregiverInfoAsAdminMutation, DeleteCaregiverInfoAsAdminMutationVariables>(DeleteCaregiverInfoAsAdminDocument, options);
      }
export type DeleteCaregiverInfoAsAdminMutationHookResult = ReturnType<typeof useDeleteCaregiverInfoAsAdminMutation>;
export type DeleteCaregiverInfoAsAdminMutationResult = Apollo.MutationResult<DeleteCaregiverInfoAsAdminMutation>;
export type DeleteCaregiverInfoAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteCaregiverInfoAsAdminMutation, DeleteCaregiverInfoAsAdminMutationVariables>;
export const DeleteCaregiverInfoMediaDocument = gql`
    mutation DeleteCaregiverInfoMedia($infoId: ID!, $mediaId: ID!) {
  deleteCaregiverInfoMedia(infoId: $infoId, mediaId: $mediaId) {
    id
    media {
      id
      uri
    }
  }
}
    `;
export type DeleteCaregiverInfoMediaMutationFn = Apollo.MutationFunction<DeleteCaregiverInfoMediaMutation, DeleteCaregiverInfoMediaMutationVariables>;

/**
 * __useDeleteCaregiverInfoMediaMutation__
 *
 * To run a mutation, you first call `useDeleteCaregiverInfoMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaregiverInfoMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaregiverInfoMediaMutation, { data, loading, error }] = useDeleteCaregiverInfoMediaMutation({
 *   variables: {
 *      infoId: // value for 'infoId'
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useDeleteCaregiverInfoMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaregiverInfoMediaMutation, DeleteCaregiverInfoMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaregiverInfoMediaMutation, DeleteCaregiverInfoMediaMutationVariables>(DeleteCaregiverInfoMediaDocument, options);
      }
export type DeleteCaregiverInfoMediaMutationHookResult = ReturnType<typeof useDeleteCaregiverInfoMediaMutation>;
export type DeleteCaregiverInfoMediaMutationResult = Apollo.MutationResult<DeleteCaregiverInfoMediaMutation>;
export type DeleteCaregiverInfoMediaMutationOptions = Apollo.BaseMutationOptions<DeleteCaregiverInfoMediaMutation, DeleteCaregiverInfoMediaMutationVariables>;
export const GetLatestPolicyDocument = gql`
    query GetLatestPolicy($type: PolicyType!) {
  getLatestPolicy(type: $type) {
    id
    type
    body
    createdAt
  }
}
    `;

/**
 * __useGetLatestPolicyQuery__
 *
 * To run a query within a React component, call `useGetLatestPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestPolicyQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLatestPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetLatestPolicyQuery, GetLatestPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestPolicyQuery, GetLatestPolicyQueryVariables>(GetLatestPolicyDocument, options);
      }
export function useGetLatestPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestPolicyQuery, GetLatestPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestPolicyQuery, GetLatestPolicyQueryVariables>(GetLatestPolicyDocument, options);
        }
export type GetLatestPolicyQueryHookResult = ReturnType<typeof useGetLatestPolicyQuery>;
export type GetLatestPolicyLazyQueryHookResult = ReturnType<typeof useGetLatestPolicyLazyQuery>;
export type GetLatestPolicyQueryResult = Apollo.QueryResult<GetLatestPolicyQuery, GetLatestPolicyQueryVariables>;
export const UpdatePolicyAsAdminDocument = gql`
    mutation UpdatePolicyAsAdmin($policyInput: UpdatePolicyDto!) {
  updatePolicyAsAdmin(policyInput: $policyInput) {
    id
    type
    body
    createdAt
  }
}
    `;
export type UpdatePolicyAsAdminMutationFn = Apollo.MutationFunction<UpdatePolicyAsAdminMutation, UpdatePolicyAsAdminMutationVariables>;

/**
 * __useUpdatePolicyAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyAsAdminMutation, { data, loading, error }] = useUpdatePolicyAsAdminMutation({
 *   variables: {
 *      policyInput: // value for 'policyInput'
 *   },
 * });
 */
export function useUpdatePolicyAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePolicyAsAdminMutation, UpdatePolicyAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePolicyAsAdminMutation, UpdatePolicyAsAdminMutationVariables>(UpdatePolicyAsAdminDocument, options);
      }
export type UpdatePolicyAsAdminMutationHookResult = ReturnType<typeof useUpdatePolicyAsAdminMutation>;
export type UpdatePolicyAsAdminMutationResult = Apollo.MutationResult<UpdatePolicyAsAdminMutation>;
export type UpdatePolicyAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdatePolicyAsAdminMutation, UpdatePolicyAsAdminMutationVariables>;
export const GetManagementDocument = gql`
    query GetManagement {
  getManagement {
    id
    companyName
    address
    copyright
    email
    ceoName
    registrationNumber
    escroRegistration
    paymentWarning
    paymentInformation
    phone
    kakaoAddress
    minimumTip
    invitationPoint
    shopAddress
  }
}
    `;

/**
 * __useGetManagementQuery__
 *
 * To run a query within a React component, call `useGetManagementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManagementQuery(baseOptions?: Apollo.QueryHookOptions<GetManagementQuery, GetManagementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManagementQuery, GetManagementQueryVariables>(GetManagementDocument, options);
      }
export function useGetManagementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagementQuery, GetManagementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManagementQuery, GetManagementQueryVariables>(GetManagementDocument, options);
        }
export type GetManagementQueryHookResult = ReturnType<typeof useGetManagementQuery>;
export type GetManagementLazyQueryHookResult = ReturnType<typeof useGetManagementLazyQuery>;
export type GetManagementQueryResult = Apollo.QueryResult<GetManagementQuery, GetManagementQueryVariables>;
export const UpdateManagementAsAdminDocument = gql`
    mutation UpdateManagementAsAdmin($managementInput: UpdateManagementAsAdminDto!) {
  updateManagementAsAdmin(managementInput: $managementInput) {
    id
    companyName
    address
    copyright
    email
    ceoName
    registrationNumber
    escroRegistration
    phone
    kakaoAddress
    minimumTip
    invitationPoint
    shopAddress
  }
}
    `;
export type UpdateManagementAsAdminMutationFn = Apollo.MutationFunction<UpdateManagementAsAdminMutation, UpdateManagementAsAdminMutationVariables>;

/**
 * __useUpdateManagementAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateManagementAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagementAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagementAsAdminMutation, { data, loading, error }] = useUpdateManagementAsAdminMutation({
 *   variables: {
 *      managementInput: // value for 'managementInput'
 *   },
 * });
 */
export function useUpdateManagementAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagementAsAdminMutation, UpdateManagementAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManagementAsAdminMutation, UpdateManagementAsAdminMutationVariables>(UpdateManagementAsAdminDocument, options);
      }
export type UpdateManagementAsAdminMutationHookResult = ReturnType<typeof useUpdateManagementAsAdminMutation>;
export type UpdateManagementAsAdminMutationResult = Apollo.MutationResult<UpdateManagementAsAdminMutation>;
export type UpdateManagementAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateManagementAsAdminMutation, UpdateManagementAsAdminMutationVariables>;
export const GetPoliciesDocument = gql`
    query GetPolicies($type: PolicyType!) {
  getPolicies(type: $type) {
    id
    type
    body
    createdAt
  }
}
    `;

/**
 * __useGetPoliciesQuery__
 *
 * To run a query within a React component, call `useGetPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoliciesQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetPoliciesQuery(baseOptions: Apollo.QueryHookOptions<GetPoliciesQuery, GetPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoliciesQuery, GetPoliciesQueryVariables>(GetPoliciesDocument, options);
      }
export function useGetPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPoliciesQuery, GetPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoliciesQuery, GetPoliciesQueryVariables>(GetPoliciesDocument, options);
        }
export type GetPoliciesQueryHookResult = ReturnType<typeof useGetPoliciesQuery>;
export type GetPoliciesLazyQueryHookResult = ReturnType<typeof useGetPoliciesLazyQuery>;
export type GetPoliciesQueryResult = Apollo.QueryResult<GetPoliciesQuery, GetPoliciesQueryVariables>;
export const GetCafe24TokenExpiryTimesAsAdminDocument = gql`
    query GetCafe24TokenExpiryTimesAsAdmin {
  getCafe24TokenExpiryTimesAsAdmin {
    refresh
    access
  }
}
    `;

/**
 * __useGetCafe24TokenExpiryTimesAsAdminQuery__
 *
 * To run a query within a React component, call `useGetCafe24TokenExpiryTimesAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCafe24TokenExpiryTimesAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCafe24TokenExpiryTimesAsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCafe24TokenExpiryTimesAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetCafe24TokenExpiryTimesAsAdminQuery, GetCafe24TokenExpiryTimesAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCafe24TokenExpiryTimesAsAdminQuery, GetCafe24TokenExpiryTimesAsAdminQueryVariables>(GetCafe24TokenExpiryTimesAsAdminDocument, options);
      }
export function useGetCafe24TokenExpiryTimesAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCafe24TokenExpiryTimesAsAdminQuery, GetCafe24TokenExpiryTimesAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCafe24TokenExpiryTimesAsAdminQuery, GetCafe24TokenExpiryTimesAsAdminQueryVariables>(GetCafe24TokenExpiryTimesAsAdminDocument, options);
        }
export type GetCafe24TokenExpiryTimesAsAdminQueryHookResult = ReturnType<typeof useGetCafe24TokenExpiryTimesAsAdminQuery>;
export type GetCafe24TokenExpiryTimesAsAdminLazyQueryHookResult = ReturnType<typeof useGetCafe24TokenExpiryTimesAsAdminLazyQuery>;
export type GetCafe24TokenExpiryTimesAsAdminQueryResult = Apollo.QueryResult<GetCafe24TokenExpiryTimesAsAdminQuery, GetCafe24TokenExpiryTimesAsAdminQueryVariables>;
export const GetReferralNetworkUsersAsAdminDocument = gql`
    query GetReferralNetworkUsersAsAdmin($networkUserSearchType: NetworkUserSearchType, $query: String, $page: Int, $limit: Int, $sortKey: NetworkUserSortKey, $sortDirection: String) {
  getReferralNetworkUsersAsAdmin(
    networkUserSearchType: $networkUserSearchType
    query: $query
    page: $page
    limit: $limit
    sortKey: $sortKey
    sortDirection: $sortDirection
  ) {
    pageInfo {
      totalCount
    }
    edges {
      id
      totalNetworkRewardPoint
      totalNetworkUserCount
      caregiver {
        avatar {
          id
          uri
          thumbnailUri
        }
        id
        invitedUserCount
        lastSignInAt
        name
        phone
        updatedAt
        username
      }
      guardian {
        avatar {
          id
          uri
          thumbnailUri
        }
        id
        invitedUserCount
        lastSignInAt
        name
        phone
        updatedAt
        username
      }
      createdAt
      deletedAt
      id
    }
  }
}
    `;

/**
 * __useGetReferralNetworkUsersAsAdminQuery__
 *
 * To run a query within a React component, call `useGetReferralNetworkUsersAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralNetworkUsersAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralNetworkUsersAsAdminQuery({
 *   variables: {
 *      networkUserSearchType: // value for 'networkUserSearchType'
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetReferralNetworkUsersAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetReferralNetworkUsersAsAdminQuery, GetReferralNetworkUsersAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralNetworkUsersAsAdminQuery, GetReferralNetworkUsersAsAdminQueryVariables>(GetReferralNetworkUsersAsAdminDocument, options);
      }
export function useGetReferralNetworkUsersAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralNetworkUsersAsAdminQuery, GetReferralNetworkUsersAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralNetworkUsersAsAdminQuery, GetReferralNetworkUsersAsAdminQueryVariables>(GetReferralNetworkUsersAsAdminDocument, options);
        }
export type GetReferralNetworkUsersAsAdminQueryHookResult = ReturnType<typeof useGetReferralNetworkUsersAsAdminQuery>;
export type GetReferralNetworkUsersAsAdminLazyQueryHookResult = ReturnType<typeof useGetReferralNetworkUsersAsAdminLazyQuery>;
export type GetReferralNetworkUsersAsAdminQueryResult = Apollo.QueryResult<GetReferralNetworkUsersAsAdminQuery, GetReferralNetworkUsersAsAdminQueryVariables>;
export const GetReferralNetworkUserAsAdminDocument = gql`
    query GetReferralNetworkUserAsAdmin($caregiverId: String, $guardianId: String) {
  getReferralNetworkUserAsAdmin(
    caregiverId: $caregiverId
    guardianId: $guardianId
  ) {
    id
    totalNetworkUserCount
    totalNetworkRewardPoint
    updatedAt
    caregiver {
      id
      totalRewardPoint
      invitedUserCount
      lastSignInAt
      name
      phone
      updatedAt
      username
      avatar {
        id
        uri
        thumbnailUri
      }
      invitedCaregivers {
        id
        invitedUserCount
        lastSignInAt
        name
        phone
        updatedAt
        username
        totalRewardPoint
        invitedUserCount
        avatar {
          id
          uri
          thumbnailUri
        }
        invitedCaregivers {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
        invitedGuardians {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
      }
      invitedGuardians {
        id
        totalRewardPoint
        invitedUserCount
        lastSignInAt
        name
        phone
        updatedAt
        username
        avatar {
          id
          uri
          thumbnailUri
        }
        invitedCaregivers {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
        invitedGuardians {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
      }
    }
    guardian {
      id
      invitedUserCount
      totalRewardPoint
      lastSignInAt
      name
      phone
      updatedAt
      username
      avatar {
        id
        uri
        thumbnailUri
      }
      invitedCaregivers {
        id
        totalRewardPoint
        invitedUserCount
        lastSignInAt
        name
        phone
        updatedAt
        username
        avatar {
          id
          uri
          thumbnailUri
        }
        invitedCaregivers {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
        invitedGuardians {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
      }
      invitedGuardians {
        id
        totalRewardPoint
        invitedUserCount
        lastSignInAt
        name
        phone
        updatedAt
        username
        avatar {
          id
          uri
          thumbnailUri
        }
        invitedCaregivers {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
        invitedGuardians {
          id
          totalRewardPoint
          invitedUserCount
          lastSignInAt
          name
          phone
          updatedAt
          username
          avatar {
            id
            uri
            thumbnailUri
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReferralNetworkUserAsAdminQuery__
 *
 * To run a query within a React component, call `useGetReferralNetworkUserAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralNetworkUserAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralNetworkUserAsAdminQuery({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *      guardianId: // value for 'guardianId'
 *   },
 * });
 */
export function useGetReferralNetworkUserAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetReferralNetworkUserAsAdminQuery, GetReferralNetworkUserAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralNetworkUserAsAdminQuery, GetReferralNetworkUserAsAdminQueryVariables>(GetReferralNetworkUserAsAdminDocument, options);
      }
export function useGetReferralNetworkUserAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralNetworkUserAsAdminQuery, GetReferralNetworkUserAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralNetworkUserAsAdminQuery, GetReferralNetworkUserAsAdminQueryVariables>(GetReferralNetworkUserAsAdminDocument, options);
        }
export type GetReferralNetworkUserAsAdminQueryHookResult = ReturnType<typeof useGetReferralNetworkUserAsAdminQuery>;
export type GetReferralNetworkUserAsAdminLazyQueryHookResult = ReturnType<typeof useGetReferralNetworkUserAsAdminLazyQuery>;
export type GetReferralNetworkUserAsAdminQueryResult = Apollo.QueryResult<GetReferralNetworkUserAsAdminQuery, GetReferralNetworkUserAsAdminQueryVariables>;
export const GetNetworkDashboardAsAdminDocument = gql`
    query GetNetworkDashboardAsAdmin($year: Int!, $month: Int!) {
  getNetworkDashboardAsAdmin(year: $year, month: $month) {
    activeUserRate
    averageActivePeriod
    totalUserCount
    totalInviteCount
    totalActiveUserCount
    previousMonthUserCountRate
    previousMonthInviteCountRate
    previousMonthAverageReferralDepthRate
    previousMonthAverageReferralCountRate
    previousMonthAverageActivePeriodRate
    previousMonthActiveUserRate
    previousMonthActiveUserCountRate
    averageReferralDepth
    averageReferralCount
  }
}
    `;

/**
 * __useGetNetworkDashboardAsAdminQuery__
 *
 * To run a query within a React component, call `useGetNetworkDashboardAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkDashboardAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkDashboardAsAdminQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetNetworkDashboardAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetNetworkDashboardAsAdminQuery, GetNetworkDashboardAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNetworkDashboardAsAdminQuery, GetNetworkDashboardAsAdminQueryVariables>(GetNetworkDashboardAsAdminDocument, options);
      }
export function useGetNetworkDashboardAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNetworkDashboardAsAdminQuery, GetNetworkDashboardAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNetworkDashboardAsAdminQuery, GetNetworkDashboardAsAdminQueryVariables>(GetNetworkDashboardAsAdminDocument, options);
        }
export type GetNetworkDashboardAsAdminQueryHookResult = ReturnType<typeof useGetNetworkDashboardAsAdminQuery>;
export type GetNetworkDashboardAsAdminLazyQueryHookResult = ReturnType<typeof useGetNetworkDashboardAsAdminLazyQuery>;
export type GetNetworkDashboardAsAdminQueryResult = Apollo.QueryResult<GetNetworkDashboardAsAdminQuery, GetNetworkDashboardAsAdminQueryVariables>;
export const GetNetworkGraphDashboardAsAdminDocument = gql`
    query GetNetworkGraphDashboardAsAdmin($year: Int!, $month: Int!) {
  getNetworkGraphDashboardAsAdmin(year: $year, month: $month) {
    year
    month
    totalInviteUserCount
    totalInvitedUserCount
  }
}
    `;

/**
 * __useGetNetworkGraphDashboardAsAdminQuery__
 *
 * To run a query within a React component, call `useGetNetworkGraphDashboardAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkGraphDashboardAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkGraphDashboardAsAdminQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetNetworkGraphDashboardAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetNetworkGraphDashboardAsAdminQuery, GetNetworkGraphDashboardAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNetworkGraphDashboardAsAdminQuery, GetNetworkGraphDashboardAsAdminQueryVariables>(GetNetworkGraphDashboardAsAdminDocument, options);
      }
export function useGetNetworkGraphDashboardAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNetworkGraphDashboardAsAdminQuery, GetNetworkGraphDashboardAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNetworkGraphDashboardAsAdminQuery, GetNetworkGraphDashboardAsAdminQueryVariables>(GetNetworkGraphDashboardAsAdminDocument, options);
        }
export type GetNetworkGraphDashboardAsAdminQueryHookResult = ReturnType<typeof useGetNetworkGraphDashboardAsAdminQuery>;
export type GetNetworkGraphDashboardAsAdminLazyQueryHookResult = ReturnType<typeof useGetNetworkGraphDashboardAsAdminLazyQuery>;
export type GetNetworkGraphDashboardAsAdminQueryResult = Apollo.QueryResult<GetNetworkGraphDashboardAsAdminQuery, GetNetworkGraphDashboardAsAdminQueryVariables>;
export const GetNetworkRankingAsAdminDocument = gql`
    query GetNetworkRankingAsAdmin($page: Int!, $limit: Int, $sortKey: NetworkUserRankSortKey, $sortDirection: String) {
  getReferralNetworkUsersRankAsAdmin(
    page: $page
    limit: $limit
    sortKey: $sortKey
    sortDirection: $sortDirection
  ) {
    pageInfo {
      totalCount
    }
    edges {
      totalNetworkRewardPoint
      totalNetworkUserCount
      id
      caregiver {
        id
        name
        username
        totalRewardPoint
        invitedUserCount
        lastSignInAt
        createdAt
      }
      guardian {
        id
        name
        username
        totalRewardPoint
        invitedUserCount
        lastSignInAt
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetNetworkRankingAsAdminQuery__
 *
 * To run a query within a React component, call `useGetNetworkRankingAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkRankingAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkRankingAsAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetNetworkRankingAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetNetworkRankingAsAdminQuery, GetNetworkRankingAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNetworkRankingAsAdminQuery, GetNetworkRankingAsAdminQueryVariables>(GetNetworkRankingAsAdminDocument, options);
      }
export function useGetNetworkRankingAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNetworkRankingAsAdminQuery, GetNetworkRankingAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNetworkRankingAsAdminQuery, GetNetworkRankingAsAdminQueryVariables>(GetNetworkRankingAsAdminDocument, options);
        }
export type GetNetworkRankingAsAdminQueryHookResult = ReturnType<typeof useGetNetworkRankingAsAdminQuery>;
export type GetNetworkRankingAsAdminLazyQueryHookResult = ReturnType<typeof useGetNetworkRankingAsAdminLazyQuery>;
export type GetNetworkRankingAsAdminQueryResult = Apollo.QueryResult<GetNetworkRankingAsAdminQuery, GetNetworkRankingAsAdminQueryVariables>;
export const GetIncentiveDashboardAsAdminDocument = gql`
    query GetIncentiveDashboardAsAdmin($year: Int!, $month: Int!) {
  getIncentiveDashboardAsAdmin(year: $year, month: $month) {
    accumulatedAmount
    previousMonthAccumulatedAmountDifference
    thisMonthTotalAmount
    previousMonthThisMonthTotalAmountRate
    thisMonthTotalReceivedUserCount
    previousMonthThisMonthTotalReceivedUserCountRate
    averageReceivedAmount
    previousMonthAverageReceivedAmountRate
    pointUsedCount
    previousMonthPointUsedCountRate
  }
}
    `;

/**
 * __useGetIncentiveDashboardAsAdminQuery__
 *
 * To run a query within a React component, call `useGetIncentiveDashboardAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncentiveDashboardAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncentiveDashboardAsAdminQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetIncentiveDashboardAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetIncentiveDashboardAsAdminQuery, GetIncentiveDashboardAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncentiveDashboardAsAdminQuery, GetIncentiveDashboardAsAdminQueryVariables>(GetIncentiveDashboardAsAdminDocument, options);
      }
export function useGetIncentiveDashboardAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncentiveDashboardAsAdminQuery, GetIncentiveDashboardAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncentiveDashboardAsAdminQuery, GetIncentiveDashboardAsAdminQueryVariables>(GetIncentiveDashboardAsAdminDocument, options);
        }
export type GetIncentiveDashboardAsAdminQueryHookResult = ReturnType<typeof useGetIncentiveDashboardAsAdminQuery>;
export type GetIncentiveDashboardAsAdminLazyQueryHookResult = ReturnType<typeof useGetIncentiveDashboardAsAdminLazyQuery>;
export type GetIncentiveDashboardAsAdminQueryResult = Apollo.QueryResult<GetIncentiveDashboardAsAdminQuery, GetIncentiveDashboardAsAdminQueryVariables>;
export const GetIncentiveLineGraphAsAdminDocument = gql`
    query GetIncentiveLineGraphAsAdmin($year: Int!, $month: Int!, $caregiverId: String, $guardianId: String) {
  getIncentiveLineGraphAsAdmin(
    year: $year
    month: $month
    caregiverId: $caregiverId
    guardianId: $guardianId
  ) {
    amount
    pointTransactionType {
      code
      id
      name
    }
    pointTransactionTypeId
  }
}
    `;

/**
 * __useGetIncentiveLineGraphAsAdminQuery__
 *
 * To run a query within a React component, call `useGetIncentiveLineGraphAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncentiveLineGraphAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncentiveLineGraphAsAdminQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      caregiverId: // value for 'caregiverId'
 *      guardianId: // value for 'guardianId'
 *   },
 * });
 */
export function useGetIncentiveLineGraphAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetIncentiveLineGraphAsAdminQuery, GetIncentiveLineGraphAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncentiveLineGraphAsAdminQuery, GetIncentiveLineGraphAsAdminQueryVariables>(GetIncentiveLineGraphAsAdminDocument, options);
      }
export function useGetIncentiveLineGraphAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncentiveLineGraphAsAdminQuery, GetIncentiveLineGraphAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncentiveLineGraphAsAdminQuery, GetIncentiveLineGraphAsAdminQueryVariables>(GetIncentiveLineGraphAsAdminDocument, options);
        }
export type GetIncentiveLineGraphAsAdminQueryHookResult = ReturnType<typeof useGetIncentiveLineGraphAsAdminQuery>;
export type GetIncentiveLineGraphAsAdminLazyQueryHookResult = ReturnType<typeof useGetIncentiveLineGraphAsAdminLazyQuery>;
export type GetIncentiveLineGraphAsAdminQueryResult = Apollo.QueryResult<GetIncentiveLineGraphAsAdminQuery, GetIncentiveLineGraphAsAdminQueryVariables>;
export const GetUserIncentivesAsAdminDocument = gql`
    query GetUserIncentivesAsAdmin($year: Int!, $month: Int!, $page: Int!, $limit: Int!, $guardianId: ID, $caregiverId: ID) {
  getUserIncentivesAsAdmin(
    year: $year
    month: $month
    page: $page
    limit: $limit
    guardianId: $guardianId
    caregiverId: $caregiverId
  ) {
    pageInfo {
      totalCount
    }
    edges {
      id
      amount
      createdAt
      caregiver {
        id
        name
        phone
        createdAt
        dateOfBirth
        gender
        username
      }
      guardian {
        id
        name
        phone
        createdAt
        dateOfBirth
        gender
        username
      }
      pointTransactionType {
        code
        name
        id
      }
    }
  }
}
    `;

/**
 * __useGetUserIncentivesAsAdminQuery__
 *
 * To run a query within a React component, call `useGetUserIncentivesAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIncentivesAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIncentivesAsAdminQuery({
 *   variables: {
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      guardianId: // value for 'guardianId'
 *      caregiverId: // value for 'caregiverId'
 *   },
 * });
 */
export function useGetUserIncentivesAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetUserIncentivesAsAdminQuery, GetUserIncentivesAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIncentivesAsAdminQuery, GetUserIncentivesAsAdminQueryVariables>(GetUserIncentivesAsAdminDocument, options);
      }
export function useGetUserIncentivesAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIncentivesAsAdminQuery, GetUserIncentivesAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIncentivesAsAdminQuery, GetUserIncentivesAsAdminQueryVariables>(GetUserIncentivesAsAdminDocument, options);
        }
export type GetUserIncentivesAsAdminQueryHookResult = ReturnType<typeof useGetUserIncentivesAsAdminQuery>;
export type GetUserIncentivesAsAdminLazyQueryHookResult = ReturnType<typeof useGetUserIncentivesAsAdminLazyQuery>;
export type GetUserIncentivesAsAdminQueryResult = Apollo.QueryResult<GetUserIncentivesAsAdminQuery, GetUserIncentivesAsAdminQueryVariables>;
export const GetPackagesDocument = gql`
    query GetPackages {
  getPackages {
    id
    point
    initialPrice
    finalPrice
    name
    active
  }
}
    `;

/**
 * __useGetPackagesQuery__
 *
 * To run a query within a React component, call `useGetPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPackagesQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagesQuery, GetPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagesQuery, GetPackagesQueryVariables>(GetPackagesDocument, options);
      }
export function useGetPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagesQuery, GetPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagesQuery, GetPackagesQueryVariables>(GetPackagesDocument, options);
        }
export type GetPackagesQueryHookResult = ReturnType<typeof useGetPackagesQuery>;
export type GetPackagesLazyQueryHookResult = ReturnType<typeof useGetPackagesLazyQuery>;
export type GetPackagesQueryResult = Apollo.QueryResult<GetPackagesQuery, GetPackagesQueryVariables>;
export const UpdatePackageAsAdminDocument = gql`
    mutation UpdatePackageAsAdmin($packageInput: PackageInput!) {
  updatePackageAsAdmin(packageInput: $packageInput) {
    id
    point
    initialPrice
    finalPrice
    name
    active
  }
}
    `;
export type UpdatePackageAsAdminMutationFn = Apollo.MutationFunction<UpdatePackageAsAdminMutation, UpdatePackageAsAdminMutationVariables>;

/**
 * __useUpdatePackageAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdatePackageAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageAsAdminMutation, { data, loading, error }] = useUpdatePackageAsAdminMutation({
 *   variables: {
 *      packageInput: // value for 'packageInput'
 *   },
 * });
 */
export function useUpdatePackageAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageAsAdminMutation, UpdatePackageAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageAsAdminMutation, UpdatePackageAsAdminMutationVariables>(UpdatePackageAsAdminDocument, options);
      }
export type UpdatePackageAsAdminMutationHookResult = ReturnType<typeof useUpdatePackageAsAdminMutation>;
export type UpdatePackageAsAdminMutationResult = Apollo.MutationResult<UpdatePackageAsAdminMutation>;
export type UpdatePackageAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdatePackageAsAdminMutation, UpdatePackageAsAdminMutationVariables>;
export const GetPackageDocument = gql`
    query GetPackage($packageId: ID!) {
  getPackage(packageId: $packageId) {
    id
    point
    initialPrice
    finalPrice
    name
    active
  }
}
    `;

/**
 * __useGetPackageQuery__
 *
 * To run a query within a React component, call `useGetPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageQuery({
 *   variables: {
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function useGetPackageQuery(baseOptions: Apollo.QueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
      }
export function useGetPackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageQuery, GetPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageQuery, GetPackageQueryVariables>(GetPackageDocument, options);
        }
export type GetPackageQueryHookResult = ReturnType<typeof useGetPackageQuery>;
export type GetPackageLazyQueryHookResult = ReturnType<typeof useGetPackageLazyQuery>;
export type GetPackageQueryResult = Apollo.QueryResult<GetPackageQuery, GetPackageQueryVariables>;
export const CreateAdminUserAsAdminDocument = gql`
    mutation CreateAdminUserAsAdmin($createAdminUserAsAdminInput: CreateAdminUserAsAdminInput!) {
  createAdminUserAsAdmin(
    createAdminUserAsAdminInput: $createAdminUserAsAdminInput
  )
}
    `;
export type CreateAdminUserAsAdminMutationFn = Apollo.MutationFunction<CreateAdminUserAsAdminMutation, CreateAdminUserAsAdminMutationVariables>;

/**
 * __useCreateAdminUserAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserAsAdminMutation, { data, loading, error }] = useCreateAdminUserAsAdminMutation({
 *   variables: {
 *      createAdminUserAsAdminInput: // value for 'createAdminUserAsAdminInput'
 *   },
 * });
 */
export function useCreateAdminUserAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserAsAdminMutation, CreateAdminUserAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserAsAdminMutation, CreateAdminUserAsAdminMutationVariables>(CreateAdminUserAsAdminDocument, options);
      }
export type CreateAdminUserAsAdminMutationHookResult = ReturnType<typeof useCreateAdminUserAsAdminMutation>;
export type CreateAdminUserAsAdminMutationResult = Apollo.MutationResult<CreateAdminUserAsAdminMutation>;
export type CreateAdminUserAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserAsAdminMutation, CreateAdminUserAsAdminMutationVariables>;
export const GetMyInvitationCaregiversGuardiansDocument = gql`
    query GetMyInvitationCaregiversGuardians($first: Int, $after: String) {
  getMyInvitationCaregiversGuardians(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
      startCursor
    }
    edges {
      invitedCaregiver {
        id
        phone
        email
        communityCount
        dailyReportCount
        replyCount
        cafe24MemberId
        avatar {
          uri
          id
        }
        name
        gender
        username
      }
    }
  }
}
    `;

/**
 * __useGetMyInvitationCaregiversGuardiansQuery__
 *
 * To run a query within a React component, call `useGetMyInvitationCaregiversGuardiansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInvitationCaregiversGuardiansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInvitationCaregiversGuardiansQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMyInvitationCaregiversGuardiansQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInvitationCaregiversGuardiansQuery, GetMyInvitationCaregiversGuardiansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInvitationCaregiversGuardiansQuery, GetMyInvitationCaregiversGuardiansQueryVariables>(GetMyInvitationCaregiversGuardiansDocument, options);
      }
export function useGetMyInvitationCaregiversGuardiansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInvitationCaregiversGuardiansQuery, GetMyInvitationCaregiversGuardiansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInvitationCaregiversGuardiansQuery, GetMyInvitationCaregiversGuardiansQueryVariables>(GetMyInvitationCaregiversGuardiansDocument, options);
        }
export type GetMyInvitationCaregiversGuardiansQueryHookResult = ReturnType<typeof useGetMyInvitationCaregiversGuardiansQuery>;
export type GetMyInvitationCaregiversGuardiansLazyQueryHookResult = ReturnType<typeof useGetMyInvitationCaregiversGuardiansLazyQuery>;
export type GetMyInvitationCaregiversGuardiansQueryResult = Apollo.QueryResult<GetMyInvitationCaregiversGuardiansQuery, GetMyInvitationCaregiversGuardiansQueryVariables>;
export const GetUserPointTransactionsAsAdminDocument = gql`
    query GetUserPointTransactionsAsAdmin($caregiverId: ID, $guardianId: ID, $range: RangeInput, $first: Int, $after: String) {
  getUserPointTransactionsAsAdmin(
    caregiverId: $caregiverId
    guardianId: $guardianId
    range: $range
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      type
      purchase {
        id
        guardian {
          id
          phone
          gender
          name
          avatar {
            id
            name
            uri
            size
            type
            createdAt
            thumbnailUri
          }
          username
          dateOfBirth
          point
          createdAt
          updatedAt
          deletedAt
        }
        caregiver {
          id
          phone
          gender
          name
          avatar {
            id
            name
            uri
            size
            type
            createdAt
            thumbnailUri
          }
          username
          dateOfBirth
          point
          certificateNumber
          updatedAt
          createdAt
          deletedAt
        }
        pointPackage {
          id
          point
          initialPrice
          finalPrice
          name
          active
        }
        impUid
        merchantUid
        status
        initialPrice
        finalPrice
        point
        method
        paidAt
        cancelledAt
        cancelReason
        pgProvider
        createdAt
        updatedAt
      }
      amount
      serviceRequest {
        id
        service {
          id
          name
          summary
          price
          active
          createdAt
          updatedAt
        }
        guardian {
          id
          phone
          gender
          name
          avatar {
            id
            name
            uri
            size
            type
            createdAt
            thumbnailUri
          }
          username
          dateOfBirth
          point
          createdAt
          updatedAt
          deletedAt
        }
        receiver {
          id
          name
          phone
          registrationNumber
          dateOfBirth
          gender
          createdAt
          updatedAt
          deletedAt
        }
        caregiver {
          id
          phone
          gender
          name
          avatar {
            id
            name
            uri
            size
            type
            createdAt
            thumbnailUri
          }
          username
          dateOfBirth
          point
          certificateNumber
          createdAt
          updatedAt
          deletedAt
        }
        price
        serviceAt
        type
        status
        message
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetUserPointTransactionsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetUserPointTransactionsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPointTransactionsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPointTransactionsAsAdminQuery({
 *   variables: {
 *      caregiverId: // value for 'caregiverId'
 *      guardianId: // value for 'guardianId'
 *      range: // value for 'range'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserPointTransactionsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPointTransactionsAsAdminQuery, GetUserPointTransactionsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPointTransactionsAsAdminQuery, GetUserPointTransactionsAsAdminQueryVariables>(GetUserPointTransactionsAsAdminDocument, options);
      }
export function useGetUserPointTransactionsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPointTransactionsAsAdminQuery, GetUserPointTransactionsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPointTransactionsAsAdminQuery, GetUserPointTransactionsAsAdminQueryVariables>(GetUserPointTransactionsAsAdminDocument, options);
        }
export type GetUserPointTransactionsAsAdminQueryHookResult = ReturnType<typeof useGetUserPointTransactionsAsAdminQuery>;
export type GetUserPointTransactionsAsAdminLazyQueryHookResult = ReturnType<typeof useGetUserPointTransactionsAsAdminLazyQuery>;
export type GetUserPointTransactionsAsAdminQueryResult = Apollo.QueryResult<GetUserPointTransactionsAsAdminQuery, GetUserPointTransactionsAsAdminQueryVariables>;
export const GetExmapleQuestionsAsAdminDocument = gql`
    query GetExmapleQuestionsAsAdmin($first: Float, $after: String) {
  getExmapleQuestionsAsAdmin(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      answers {
        id
        answer
        active
      }
      question
      createdAt
      active
      updatedAt
    }
  }
}
    `;

/**
 * __useGetExmapleQuestionsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetExmapleQuestionsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExmapleQuestionsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExmapleQuestionsAsAdminQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetExmapleQuestionsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetExmapleQuestionsAsAdminQuery, GetExmapleQuestionsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExmapleQuestionsAsAdminQuery, GetExmapleQuestionsAsAdminQueryVariables>(GetExmapleQuestionsAsAdminDocument, options);
      }
export function useGetExmapleQuestionsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExmapleQuestionsAsAdminQuery, GetExmapleQuestionsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExmapleQuestionsAsAdminQuery, GetExmapleQuestionsAsAdminQueryVariables>(GetExmapleQuestionsAsAdminDocument, options);
        }
export type GetExmapleQuestionsAsAdminQueryHookResult = ReturnType<typeof useGetExmapleQuestionsAsAdminQuery>;
export type GetExmapleQuestionsAsAdminLazyQueryHookResult = ReturnType<typeof useGetExmapleQuestionsAsAdminLazyQuery>;
export type GetExmapleQuestionsAsAdminQueryResult = Apollo.QueryResult<GetExmapleQuestionsAsAdminQuery, GetExmapleQuestionsAsAdminQueryVariables>;
export const UpdateExampleQuestionAsAdminDocument = gql`
    mutation UpdateExampleQuestionAsAdmin($exampleQuestionInput: ExampleQuestionInput!) {
  updateExampleQuestionAsAdmin(exampleQuestionInput: $exampleQuestionInput) {
    id
    question
  }
}
    `;
export type UpdateExampleQuestionAsAdminMutationFn = Apollo.MutationFunction<UpdateExampleQuestionAsAdminMutation, UpdateExampleQuestionAsAdminMutationVariables>;

/**
 * __useUpdateExampleQuestionAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateExampleQuestionAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExampleQuestionAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExampleQuestionAsAdminMutation, { data, loading, error }] = useUpdateExampleQuestionAsAdminMutation({
 *   variables: {
 *      exampleQuestionInput: // value for 'exampleQuestionInput'
 *   },
 * });
 */
export function useUpdateExampleQuestionAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExampleQuestionAsAdminMutation, UpdateExampleQuestionAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExampleQuestionAsAdminMutation, UpdateExampleQuestionAsAdminMutationVariables>(UpdateExampleQuestionAsAdminDocument, options);
      }
export type UpdateExampleQuestionAsAdminMutationHookResult = ReturnType<typeof useUpdateExampleQuestionAsAdminMutation>;
export type UpdateExampleQuestionAsAdminMutationResult = Apollo.MutationResult<UpdateExampleQuestionAsAdminMutation>;
export type UpdateExampleQuestionAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateExampleQuestionAsAdminMutation, UpdateExampleQuestionAsAdminMutationVariables>;
export const UpdateExampleQuestionAnswerAsAdminDocument = gql`
    mutation UpdateExampleQuestionAnswerAsAdmin($exampleQuestionAnswerInput: ExampleQuestionAnswerInput!) {
  updateExampleQuestionAnswerAsAdmin(
    exampleQuestionAnswerInput: $exampleQuestionAnswerInput
  ) {
    id
    answer
  }
}
    `;
export type UpdateExampleQuestionAnswerAsAdminMutationFn = Apollo.MutationFunction<UpdateExampleQuestionAnswerAsAdminMutation, UpdateExampleQuestionAnswerAsAdminMutationVariables>;

/**
 * __useUpdateExampleQuestionAnswerAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateExampleQuestionAnswerAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExampleQuestionAnswerAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExampleQuestionAnswerAsAdminMutation, { data, loading, error }] = useUpdateExampleQuestionAnswerAsAdminMutation({
 *   variables: {
 *      exampleQuestionAnswerInput: // value for 'exampleQuestionAnswerInput'
 *   },
 * });
 */
export function useUpdateExampleQuestionAnswerAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExampleQuestionAnswerAsAdminMutation, UpdateExampleQuestionAnswerAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExampleQuestionAnswerAsAdminMutation, UpdateExampleQuestionAnswerAsAdminMutationVariables>(UpdateExampleQuestionAnswerAsAdminDocument, options);
      }
export type UpdateExampleQuestionAnswerAsAdminMutationHookResult = ReturnType<typeof useUpdateExampleQuestionAnswerAsAdminMutation>;
export type UpdateExampleQuestionAnswerAsAdminMutationResult = Apollo.MutationResult<UpdateExampleQuestionAnswerAsAdminMutation>;
export type UpdateExampleQuestionAnswerAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateExampleQuestionAnswerAsAdminMutation, UpdateExampleQuestionAnswerAsAdminMutationVariables>;
export const GetReceiversAsAdminDocument = gql`
    query GetReceiversAsAdmin($stateId: ID, $after: String, $first: Int, $gender: Gender, $cityId: ID) {
  getReceiversAsAdmin(
    stateId: $stateId
    after: $after
    first: $first
    gender: $gender
    cityId: $cityId
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      name
      phone
      registrationMedia {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      registrationNumber
      dateOfBirth
      gender
      address
      addressDetail
      state {
        stateCode
        name
      }
      city {
        cityCode
        name
      }
      lastRecordAt
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetReceiversAsAdminQuery__
 *
 * To run a query within a React component, call `useGetReceiversAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiversAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiversAsAdminQuery({
 *   variables: {
 *      stateId: // value for 'stateId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      gender: // value for 'gender'
 *      cityId: // value for 'cityId'
 *   },
 * });
 */
export function useGetReceiversAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetReceiversAsAdminQuery, GetReceiversAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiversAsAdminQuery, GetReceiversAsAdminQueryVariables>(GetReceiversAsAdminDocument, options);
      }
export function useGetReceiversAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiversAsAdminQuery, GetReceiversAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiversAsAdminQuery, GetReceiversAsAdminQueryVariables>(GetReceiversAsAdminDocument, options);
        }
export type GetReceiversAsAdminQueryHookResult = ReturnType<typeof useGetReceiversAsAdminQuery>;
export type GetReceiversAsAdminLazyQueryHookResult = ReturnType<typeof useGetReceiversAsAdminLazyQuery>;
export type GetReceiversAsAdminQueryResult = Apollo.QueryResult<GetReceiversAsAdminQuery, GetReceiversAsAdminQueryVariables>;
export const SearchReceiversAsAdminDocument = gql`
    query SearchReceiversAsAdmin($query: String!, $gender: Gender, $first: Int, $after: String) {
  searchReceiversAsAdmin(
    query: $query
    gender: $gender
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      id
      name
      phone
      registrationMedia {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      registrationNumber
      dateOfBirth
      gender
      address
      addressDetail
      state {
        stateCode
        name
      }
      city {
        cityCode
        name
      }
      lastRecordAt
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `;

/**
 * __useSearchReceiversAsAdminQuery__
 *
 * To run a query within a React component, call `useSearchReceiversAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchReceiversAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchReceiversAsAdminQuery({
 *   variables: {
 *      query: // value for 'query'
 *      gender: // value for 'gender'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchReceiversAsAdminQuery(baseOptions: Apollo.QueryHookOptions<SearchReceiversAsAdminQuery, SearchReceiversAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchReceiversAsAdminQuery, SearchReceiversAsAdminQueryVariables>(SearchReceiversAsAdminDocument, options);
      }
export function useSearchReceiversAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchReceiversAsAdminQuery, SearchReceiversAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchReceiversAsAdminQuery, SearchReceiversAsAdminQueryVariables>(SearchReceiversAsAdminDocument, options);
        }
export type SearchReceiversAsAdminQueryHookResult = ReturnType<typeof useSearchReceiversAsAdminQuery>;
export type SearchReceiversAsAdminLazyQueryHookResult = ReturnType<typeof useSearchReceiversAsAdminLazyQuery>;
export type SearchReceiversAsAdminQueryResult = Apollo.QueryResult<SearchReceiversAsAdminQuery, SearchReceiversAsAdminQueryVariables>;
export const GetReceiverDocument = gql`
    query GetReceiver($receiverId: ID!) {
  getReceiver(receiverId: $receiverId) {
    id
    name
    phone
    registrationMedia {
      id
      name
      uri
      size
      type
      createdAt
      thumbnailUri
    }
    registrationNumber
    dateOfBirth
    gender
    address
    addressDetail
    guardians {
      guardian {
        id
        phone
        gender
        name
        username
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
        dateOfBirth
        point
        deletedAt
      }
    }
    caregivers {
      caregiver {
        id
        phone
        email
        gender
        name
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
        username
        dateOfBirth
        point
        certificateNumber
        deletedAt
      }
      active
      hasUnreadMessage
      createdAt
      updatedAt
    }
    city {
      cityCode
      name
    }
    createdAt
    updatedAt
    deletedAt
    state {
      stateCode
      name
    }
  }
}
    `;

/**
 * __useGetReceiverQuery__
 *
 * To run a query within a React component, call `useGetReceiverQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *   },
 * });
 */
export function useGetReceiverQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverQuery, GetReceiverQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverQuery, GetReceiverQueryVariables>(GetReceiverDocument, options);
      }
export function useGetReceiverLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverQuery, GetReceiverQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverQuery, GetReceiverQueryVariables>(GetReceiverDocument, options);
        }
export type GetReceiverQueryHookResult = ReturnType<typeof useGetReceiverQuery>;
export type GetReceiverLazyQueryHookResult = ReturnType<typeof useGetReceiverLazyQuery>;
export type GetReceiverQueryResult = Apollo.QueryResult<GetReceiverQuery, GetReceiverQueryVariables>;
export const GetReceiverNameDocument = gql`
    query GetReceiverName($receiverId: ID!) {
  getReceiver(receiverId: $receiverId) {
    name
  }
}
    `;

/**
 * __useGetReceiverNameQuery__
 *
 * To run a query within a React component, call `useGetReceiverNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverNameQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *   },
 * });
 */
export function useGetReceiverNameQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverNameQuery, GetReceiverNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverNameQuery, GetReceiverNameQueryVariables>(GetReceiverNameDocument, options);
      }
export function useGetReceiverNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverNameQuery, GetReceiverNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverNameQuery, GetReceiverNameQueryVariables>(GetReceiverNameDocument, options);
        }
export type GetReceiverNameQueryHookResult = ReturnType<typeof useGetReceiverNameQuery>;
export type GetReceiverNameLazyQueryHookResult = ReturnType<typeof useGetReceiverNameLazyQuery>;
export type GetReceiverNameQueryResult = Apollo.QueryResult<GetReceiverNameQuery, GetReceiverNameQueryVariables>;
export const UpdateReceiverDocument = gql`
    mutation UpdateReceiver($receiverInput: ReceiverInput!) {
  updateReceiver(receiverInput: $receiverInput) {
    id
    name
    registrationNumber
    phone
    dateOfBirth
    gender
    createdAt
  }
}
    `;
export type UpdateReceiverMutationFn = Apollo.MutationFunction<UpdateReceiverMutation, UpdateReceiverMutationVariables>;

/**
 * __useUpdateReceiverMutation__
 *
 * To run a mutation, you first call `useUpdateReceiverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReceiverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReceiverMutation, { data, loading, error }] = useUpdateReceiverMutation({
 *   variables: {
 *      receiverInput: // value for 'receiverInput'
 *   },
 * });
 */
export function useUpdateReceiverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReceiverMutation, UpdateReceiverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReceiverMutation, UpdateReceiverMutationVariables>(UpdateReceiverDocument, options);
      }
export type UpdateReceiverMutationHookResult = ReturnType<typeof useUpdateReceiverMutation>;
export type UpdateReceiverMutationResult = Apollo.MutationResult<UpdateReceiverMutation>;
export type UpdateReceiverMutationOptions = Apollo.BaseMutationOptions<UpdateReceiverMutation, UpdateReceiverMutationVariables>;
export const GetReceiverRecordsAsAdminDocument = gql`
    query GetReceiverRecordsAsAdmin($receiverId: String!, $first: Float, $after: String) {
  getReceiverRecordsAsAdmin(receiverId: $receiverId, first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      author {
        id
        phone
        name
        gender
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
        username
      }
      body
      media {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      createdAt
      deletedAt
      updatedAt
      id
    }
  }
}
    `;

/**
 * __useGetReceiverRecordsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetReceiverRecordsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverRecordsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverRecordsAsAdminQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetReceiverRecordsAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverRecordsAsAdminQuery, GetReceiverRecordsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverRecordsAsAdminQuery, GetReceiverRecordsAsAdminQueryVariables>(GetReceiverRecordsAsAdminDocument, options);
      }
export function useGetReceiverRecordsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverRecordsAsAdminQuery, GetReceiverRecordsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverRecordsAsAdminQuery, GetReceiverRecordsAsAdminQueryVariables>(GetReceiverRecordsAsAdminDocument, options);
        }
export type GetReceiverRecordsAsAdminQueryHookResult = ReturnType<typeof useGetReceiverRecordsAsAdminQuery>;
export type GetReceiverRecordsAsAdminLazyQueryHookResult = ReturnType<typeof useGetReceiverRecordsAsAdminLazyQuery>;
export type GetReceiverRecordsAsAdminQueryResult = Apollo.QueryResult<GetReceiverRecordsAsAdminQuery, GetReceiverRecordsAsAdminQueryVariables>;
export const GetReceiverRecordsDocument = gql`
    query GetReceiverRecords($receiverId: ID!, $range: RangeInput!, $first: Int, $after: String) {
  getReceiverRecords(
    receiverId: $receiverId
    range: $range
    first: $first
    after: $after
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      id
      author {
        id
        phone
        gender
        name
        avatar {
          id
          name
          uri
          size
          type
          createdAt
          thumbnailUri
        }
        username
        dateOfBirth
        point
        certificateNumber
      }
      body
      receiver {
        id
        name
      }
      media {
        id
        name
        uri
        size
        type
        createdAt
        thumbnailUri
      }
      createdAt
      deletedAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetReceiverRecordsQuery__
 *
 * To run a query within a React component, call `useGetReceiverRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverRecordsQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      range: // value for 'range'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetReceiverRecordsQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverRecordsQuery, GetReceiverRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverRecordsQuery, GetReceiverRecordsQueryVariables>(GetReceiverRecordsDocument, options);
      }
export function useGetReceiverRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverRecordsQuery, GetReceiverRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverRecordsQuery, GetReceiverRecordsQueryVariables>(GetReceiverRecordsDocument, options);
        }
export type GetReceiverRecordsQueryHookResult = ReturnType<typeof useGetReceiverRecordsQuery>;
export type GetReceiverRecordsLazyQueryHookResult = ReturnType<typeof useGetReceiverRecordsLazyQuery>;
export type GetReceiverRecordsQueryResult = Apollo.QueryResult<GetReceiverRecordsQuery, GetReceiverRecordsQueryVariables>;
export const UpdateReceiverAsAdminDocument = gql`
    mutation UpdateReceiverAsAdmin($receiverInput: ReceiverInput!) {
  updateReceiverAsAdmin(receiverInput: $receiverInput) {
    id
    name
    phone
    registrationMedia {
      id
      name
      uri
      size
      type
      createdAt
      thumbnailUri
    }
    registrationNumber
    dateOfBirth
    gender
    address
    addressDetail
    hasCohabitingFamily
    issue
    state {
      stateCode
      name
    }
    city {
      cityCode
    }
    lastRecordAt
  }
}
    `;
export type UpdateReceiverAsAdminMutationFn = Apollo.MutationFunction<UpdateReceiverAsAdminMutation, UpdateReceiverAsAdminMutationVariables>;

/**
 * __useUpdateReceiverAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateReceiverAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReceiverAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReceiverAsAdminMutation, { data, loading, error }] = useUpdateReceiverAsAdminMutation({
 *   variables: {
 *      receiverInput: // value for 'receiverInput'
 *   },
 * });
 */
export function useUpdateReceiverAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReceiverAsAdminMutation, UpdateReceiverAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReceiverAsAdminMutation, UpdateReceiverAsAdminMutationVariables>(UpdateReceiverAsAdminDocument, options);
      }
export type UpdateReceiverAsAdminMutationHookResult = ReturnType<typeof useUpdateReceiverAsAdminMutation>;
export type UpdateReceiverAsAdminMutationResult = Apollo.MutationResult<UpdateReceiverAsAdminMutation>;
export type UpdateReceiverAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateReceiverAsAdminMutation, UpdateReceiverAsAdminMutationVariables>;
export const GetDailyReportsAsAdminDocument = gql`
    query GetDailyReportsAsAdmin($dailyReportSearchQuery: DailyReportSearchQuery, $first: Int!, $after: String) {
  getDailyReportsAsAdmin(
    dailyReportSearchQuery: $dailyReportSearchQuery
    first: $first
    after: $after
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    edges {
      id
      dailyReport
      caregiver {
        id
        name
      }
      receiver {
        id
        name
      }
      recordHistories {
        id
        measure
        answerComment
        answer
        recordQuestion {
          id
          question
          measureType
          isMeasureQuestion
          isInformationQuestion
        }
      }
      createdAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetDailyReportsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetDailyReportsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportsAsAdminQuery({
 *   variables: {
 *      dailyReportSearchQuery: // value for 'dailyReportSearchQuery'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetDailyReportsAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReportsAsAdminQuery, GetDailyReportsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReportsAsAdminQuery, GetDailyReportsAsAdminQueryVariables>(GetDailyReportsAsAdminDocument, options);
      }
export function useGetDailyReportsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReportsAsAdminQuery, GetDailyReportsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReportsAsAdminQuery, GetDailyReportsAsAdminQueryVariables>(GetDailyReportsAsAdminDocument, options);
        }
export type GetDailyReportsAsAdminQueryHookResult = ReturnType<typeof useGetDailyReportsAsAdminQuery>;
export type GetDailyReportsAsAdminLazyQueryHookResult = ReturnType<typeof useGetDailyReportsAsAdminLazyQuery>;
export type GetDailyReportsAsAdminQueryResult = Apollo.QueryResult<GetDailyReportsAsAdminQuery, GetDailyReportsAsAdminQueryVariables>;
export const GetDailyReportAsAdminDocument = gql`
    query GetDailyReportAsAdmin($dailyReportId: String!) {
  getDailyReportAsAdmin(dailyReportId: $dailyReportId) {
    id
    dailyReport
    caregiver {
      id
      phone
      email
      gender
      name
      avatar {
        id
        name
        uri
      }
      username
    }
    receiver {
      id
      name
      phone
      dateOfBirth
      gender
      address
      addressDetail
    }
    recordHistories {
      id
      answer
      measure
      answerComment
      recordQuestion {
        id
        question
        isMeasureQuestion
        measureType
        isInformationQuestion
      }
    }
    createdAt
    deletedAt
  }
}
    `;

/**
 * __useGetDailyReportAsAdminQuery__
 *
 * To run a query within a React component, call `useGetDailyReportAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportAsAdminQuery({
 *   variables: {
 *      dailyReportId: // value for 'dailyReportId'
 *   },
 * });
 */
export function useGetDailyReportAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReportAsAdminQuery, GetDailyReportAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReportAsAdminQuery, GetDailyReportAsAdminQueryVariables>(GetDailyReportAsAdminDocument, options);
      }
export function useGetDailyReportAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReportAsAdminQuery, GetDailyReportAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReportAsAdminQuery, GetDailyReportAsAdminQueryVariables>(GetDailyReportAsAdminDocument, options);
        }
export type GetDailyReportAsAdminQueryHookResult = ReturnType<typeof useGetDailyReportAsAdminQuery>;
export type GetDailyReportAsAdminLazyQueryHookResult = ReturnType<typeof useGetDailyReportAsAdminLazyQuery>;
export type GetDailyReportAsAdminQueryResult = Apollo.QueryResult<GetDailyReportAsAdminQuery, GetDailyReportAsAdminQueryVariables>;
export const DeleteDailyReportAsAdminDocument = gql`
    mutation DeleteDailyReportAsAdmin($dailyReportId: String!) {
  deleteDailyReportAsAdmin(dailyReportId: $dailyReportId)
}
    `;
export type DeleteDailyReportAsAdminMutationFn = Apollo.MutationFunction<DeleteDailyReportAsAdminMutation, DeleteDailyReportAsAdminMutationVariables>;

/**
 * __useDeleteDailyReportAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteDailyReportAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDailyReportAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDailyReportAsAdminMutation, { data, loading, error }] = useDeleteDailyReportAsAdminMutation({
 *   variables: {
 *      dailyReportId: // value for 'dailyReportId'
 *   },
 * });
 */
export function useDeleteDailyReportAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDailyReportAsAdminMutation, DeleteDailyReportAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDailyReportAsAdminMutation, DeleteDailyReportAsAdminMutationVariables>(DeleteDailyReportAsAdminDocument, options);
      }
export type DeleteDailyReportAsAdminMutationHookResult = ReturnType<typeof useDeleteDailyReportAsAdminMutation>;
export type DeleteDailyReportAsAdminMutationResult = Apollo.MutationResult<DeleteDailyReportAsAdminMutation>;
export type DeleteDailyReportAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteDailyReportAsAdminMutation, DeleteDailyReportAsAdminMutationVariables>;
export const GetDailyReportsByMonthWeekAdminDocument = gql`
    query GetDailyReportsByMonthWeekAdmin($receiverId: String!, $year: Int!, $month: Int!) {
  getDailyReportsByMonthWeekAdmin(
    receiverId: $receiverId
    year: $year
    month: $month
  ) {
    week
    isHasWeeklyReport
    dailyReports {
      id
      dailyReport
      caregiver {
        id
        name
      }
      receiver {
        id
        name
      }
      recordHistories {
        id
      }
      createdAt
      deletedAt
    }
  }
}
    `;

/**
 * __useGetDailyReportsByMonthWeekAdminQuery__
 *
 * To run a query within a React component, call `useGetDailyReportsByMonthWeekAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyReportsByMonthWeekAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyReportsByMonthWeekAdminQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetDailyReportsByMonthWeekAdminQuery(baseOptions: Apollo.QueryHookOptions<GetDailyReportsByMonthWeekAdminQuery, GetDailyReportsByMonthWeekAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyReportsByMonthWeekAdminQuery, GetDailyReportsByMonthWeekAdminQueryVariables>(GetDailyReportsByMonthWeekAdminDocument, options);
      }
export function useGetDailyReportsByMonthWeekAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyReportsByMonthWeekAdminQuery, GetDailyReportsByMonthWeekAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyReportsByMonthWeekAdminQuery, GetDailyReportsByMonthWeekAdminQueryVariables>(GetDailyReportsByMonthWeekAdminDocument, options);
        }
export type GetDailyReportsByMonthWeekAdminQueryHookResult = ReturnType<typeof useGetDailyReportsByMonthWeekAdminQuery>;
export type GetDailyReportsByMonthWeekAdminLazyQueryHookResult = ReturnType<typeof useGetDailyReportsByMonthWeekAdminLazyQuery>;
export type GetDailyReportsByMonthWeekAdminQueryResult = Apollo.QueryResult<GetDailyReportsByMonthWeekAdminQuery, GetDailyReportsByMonthWeekAdminQueryVariables>;
export const GetWeeklyReceiverMeasuresDocument = gql`
    query GetWeeklyReceiverMeasures($month: Int!, $week: Int!, $receiverId: String!, $year: Int!) {
  getWeeklyReceiverMeasures(
    month: $month
    week: $week
    receiverId: $receiverId
    year: $year
  ) {
    category_id
    large_category
    measure
    medium_category
    small_category
  }
}
    `;

/**
 * __useGetWeeklyReceiverMeasuresQuery__
 *
 * To run a query within a React component, call `useGetWeeklyReceiverMeasuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyReceiverMeasuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyReceiverMeasuresQuery({
 *   variables: {
 *      month: // value for 'month'
 *      week: // value for 'week'
 *      receiverId: // value for 'receiverId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetWeeklyReceiverMeasuresQuery(baseOptions: Apollo.QueryHookOptions<GetWeeklyReceiverMeasuresQuery, GetWeeklyReceiverMeasuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWeeklyReceiverMeasuresQuery, GetWeeklyReceiverMeasuresQueryVariables>(GetWeeklyReceiverMeasuresDocument, options);
      }
export function useGetWeeklyReceiverMeasuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWeeklyReceiverMeasuresQuery, GetWeeklyReceiverMeasuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWeeklyReceiverMeasuresQuery, GetWeeklyReceiverMeasuresQueryVariables>(GetWeeklyReceiverMeasuresDocument, options);
        }
export type GetWeeklyReceiverMeasuresQueryHookResult = ReturnType<typeof useGetWeeklyReceiverMeasuresQuery>;
export type GetWeeklyReceiverMeasuresLazyQueryHookResult = ReturnType<typeof useGetWeeklyReceiverMeasuresLazyQuery>;
export type GetWeeklyReceiverMeasuresQueryResult = Apollo.QueryResult<GetWeeklyReceiverMeasuresQuery, GetWeeklyReceiverMeasuresQueryVariables>;
export const GetReceiverWeeklyReportDocument = gql`
    query GetReceiverWeeklyReport($categoryId: String!, $receiverId: String!, $measure: Int!, $year: Int!, $month: Int!, $week: Int!) {
  getReceiverWeeklyReport(
    categoryId: $categoryId
    receiverId: $receiverId
    measure: $measure
    year: $year
    month: $month
    week: $week
  ) {
    comment
  }
}
    `;

/**
 * __useGetReceiverWeeklyReportQuery__
 *
 * To run a query within a React component, call `useGetReceiverWeeklyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverWeeklyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverWeeklyReportQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      receiverId: // value for 'receiverId'
 *      measure: // value for 'measure'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      week: // value for 'week'
 *   },
 * });
 */
export function useGetReceiverWeeklyReportQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverWeeklyReportQuery, GetReceiverWeeklyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverWeeklyReportQuery, GetReceiverWeeklyReportQueryVariables>(GetReceiverWeeklyReportDocument, options);
      }
export function useGetReceiverWeeklyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverWeeklyReportQuery, GetReceiverWeeklyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverWeeklyReportQuery, GetReceiverWeeklyReportQueryVariables>(GetReceiverWeeklyReportDocument, options);
        }
export type GetReceiverWeeklyReportQueryHookResult = ReturnType<typeof useGetReceiverWeeklyReportQuery>;
export type GetReceiverWeeklyReportLazyQueryHookResult = ReturnType<typeof useGetReceiverWeeklyReportLazyQuery>;
export type GetReceiverWeeklyReportQueryResult = Apollo.QueryResult<GetReceiverWeeklyReportQuery, GetReceiverWeeklyReportQueryVariables>;
export const GetReceiverWeeklyReportWithTotalCommentDocument = gql`
    query GetReceiverWeeklyReportWithTotalComment($receiverId: String!, $categoryMeasures: [CategoryMeasure!]!, $year: Int!, $month: Int!, $week: Int!) {
  getReceiverWeeklyReportWithTotalComment(
    receiverId: $receiverId
    categoryMeasures: $categoryMeasures
    year: $year
    month: $month
    week: $week
  ) {
    categoryComments {
      categoryId
      comment
    }
    totalComment
  }
}
    `;

/**
 * __useGetReceiverWeeklyReportWithTotalCommentQuery__
 *
 * To run a query within a React component, call `useGetReceiverWeeklyReportWithTotalCommentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverWeeklyReportWithTotalCommentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverWeeklyReportWithTotalCommentQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      categoryMeasures: // value for 'categoryMeasures'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      week: // value for 'week'
 *   },
 * });
 */
export function useGetReceiverWeeklyReportWithTotalCommentQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverWeeklyReportWithTotalCommentQuery, GetReceiverWeeklyReportWithTotalCommentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverWeeklyReportWithTotalCommentQuery, GetReceiverWeeklyReportWithTotalCommentQueryVariables>(GetReceiverWeeklyReportWithTotalCommentDocument, options);
      }
export function useGetReceiverWeeklyReportWithTotalCommentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverWeeklyReportWithTotalCommentQuery, GetReceiverWeeklyReportWithTotalCommentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverWeeklyReportWithTotalCommentQuery, GetReceiverWeeklyReportWithTotalCommentQueryVariables>(GetReceiverWeeklyReportWithTotalCommentDocument, options);
        }
export type GetReceiverWeeklyReportWithTotalCommentQueryHookResult = ReturnType<typeof useGetReceiverWeeklyReportWithTotalCommentQuery>;
export type GetReceiverWeeklyReportWithTotalCommentLazyQueryHookResult = ReturnType<typeof useGetReceiverWeeklyReportWithTotalCommentLazyQuery>;
export type GetReceiverWeeklyReportWithTotalCommentQueryResult = Apollo.QueryResult<GetReceiverWeeklyReportWithTotalCommentQuery, GetReceiverWeeklyReportWithTotalCommentQueryVariables>;
export const GetMonthlyReceiverMeasureDocument = gql`
    query GetMonthlyReceiverMeasure($receiverId: String!, $year: Int!, $month: Int!) {
  getMonthlyReceiverMeasure(receiverId: $receiverId, year: $year, month: $month) {
    category_id
    large_category
    medium_category
    small_category
    weekly_measure
  }
}
    `;

/**
 * __useGetMonthlyReceiverMeasureQuery__
 *
 * To run a query within a React component, call `useGetMonthlyReceiverMeasureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyReceiverMeasureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyReceiverMeasureQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetMonthlyReceiverMeasureQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyReceiverMeasureQuery, GetMonthlyReceiverMeasureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyReceiverMeasureQuery, GetMonthlyReceiverMeasureQueryVariables>(GetMonthlyReceiverMeasureDocument, options);
      }
export function useGetMonthlyReceiverMeasureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyReceiverMeasureQuery, GetMonthlyReceiverMeasureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyReceiverMeasureQuery, GetMonthlyReceiverMeasureQueryVariables>(GetMonthlyReceiverMeasureDocument, options);
        }
export type GetMonthlyReceiverMeasureQueryHookResult = ReturnType<typeof useGetMonthlyReceiverMeasureQuery>;
export type GetMonthlyReceiverMeasureLazyQueryHookResult = ReturnType<typeof useGetMonthlyReceiverMeasureLazyQuery>;
export type GetMonthlyReceiverMeasureQueryResult = Apollo.QueryResult<GetMonthlyReceiverMeasureQuery, GetMonthlyReceiverMeasureQueryVariables>;
export const GetReceiverKeywordsDocument = gql`
    query GetReceiverKeywords($receiverId: String!, $year: Int!, $month: Int!) {
  getReceiverKeywords(receiverId: $receiverId, year: $year, month: $month) {
    keyword
    category
    count
  }
}
    `;

/**
 * __useGetReceiverKeywordsQuery__
 *
 * To run a query within a React component, call `useGetReceiverKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReceiverKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReceiverKeywordsQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetReceiverKeywordsQuery(baseOptions: Apollo.QueryHookOptions<GetReceiverKeywordsQuery, GetReceiverKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReceiverKeywordsQuery, GetReceiverKeywordsQueryVariables>(GetReceiverKeywordsDocument, options);
      }
export function useGetReceiverKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReceiverKeywordsQuery, GetReceiverKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReceiverKeywordsQuery, GetReceiverKeywordsQueryVariables>(GetReceiverKeywordsDocument, options);
        }
export type GetReceiverKeywordsQueryHookResult = ReturnType<typeof useGetReceiverKeywordsQuery>;
export type GetReceiverKeywordsLazyQueryHookResult = ReturnType<typeof useGetReceiverKeywordsLazyQuery>;
export type GetReceiverKeywordsQueryResult = Apollo.QueryResult<GetReceiverKeywordsQuery, GetReceiverKeywordsQueryVariables>;
export const GetCaregiverManualDocument = gql`
    query GetCaregiverManual($receiverId: String!, $year: Int!, $month: Int!) {
  getCaregiverManual(receiverId: $receiverId, year: $year, month: $month) {
    catNm
    actNm
    actDetail
  }
}
    `;

/**
 * __useGetCaregiverManualQuery__
 *
 * To run a query within a React component, call `useGetCaregiverManualQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaregiverManualQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaregiverManualQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetCaregiverManualQuery(baseOptions: Apollo.QueryHookOptions<GetCaregiverManualQuery, GetCaregiverManualQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaregiverManualQuery, GetCaregiverManualQueryVariables>(GetCaregiverManualDocument, options);
      }
export function useGetCaregiverManualLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaregiverManualQuery, GetCaregiverManualQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaregiverManualQuery, GetCaregiverManualQueryVariables>(GetCaregiverManualDocument, options);
        }
export type GetCaregiverManualQueryHookResult = ReturnType<typeof useGetCaregiverManualQuery>;
export type GetCaregiverManualLazyQueryHookResult = ReturnType<typeof useGetCaregiverManualLazyQuery>;
export type GetCaregiverManualQueryResult = Apollo.QueryResult<GetCaregiverManualQuery, GetCaregiverManualQueryVariables>;
export const GetMonthlyReceiverStatusDocument = gql`
    query GetMonthlyReceiverStatus($receiverId: String!, $month: Int!, $year: Int!) {
  getMonthlyReceiverStatus(receiverId: $receiverId, month: $month, year: $year) {
    comment
  }
}
    `;

/**
 * __useGetMonthlyReceiverStatusQuery__
 *
 * To run a query within a React component, call `useGetMonthlyReceiverStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMonthlyReceiverStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMonthlyReceiverStatusQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      month: // value for 'month'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useGetMonthlyReceiverStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMonthlyReceiverStatusQuery, GetMonthlyReceiverStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMonthlyReceiverStatusQuery, GetMonthlyReceiverStatusQueryVariables>(GetMonthlyReceiverStatusDocument, options);
      }
export function useGetMonthlyReceiverStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMonthlyReceiverStatusQuery, GetMonthlyReceiverStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMonthlyReceiverStatusQuery, GetMonthlyReceiverStatusQueryVariables>(GetMonthlyReceiverStatusDocument, options);
        }
export type GetMonthlyReceiverStatusQueryHookResult = ReturnType<typeof useGetMonthlyReceiverStatusQuery>;
export type GetMonthlyReceiverStatusLazyQueryHookResult = ReturnType<typeof useGetMonthlyReceiverStatusLazyQuery>;
export type GetMonthlyReceiverStatusQueryResult = Apollo.QueryResult<GetMonthlyReceiverStatusQuery, GetMonthlyReceiverStatusQueryVariables>;
export const GetCareServiceDocument = gql`
    query GetCareService($receiverId: String!, $year: Int!, $month: Int!) {
  getCareService(receiverId: $receiverId, year: $year, month: $month) {
    serviceCateNm
    problemNm
    problemSolutionNm
  }
}
    `;

/**
 * __useGetCareServiceQuery__
 *
 * To run a query within a React component, call `useGetCareServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareServiceQuery({
 *   variables: {
 *      receiverId: // value for 'receiverId'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *   },
 * });
 */
export function useGetCareServiceQuery(baseOptions: Apollo.QueryHookOptions<GetCareServiceQuery, GetCareServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareServiceQuery, GetCareServiceQueryVariables>(GetCareServiceDocument, options);
      }
export function useGetCareServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareServiceQuery, GetCareServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareServiceQuery, GetCareServiceQueryVariables>(GetCareServiceDocument, options);
        }
export type GetCareServiceQueryHookResult = ReturnType<typeof useGetCareServiceQuery>;
export type GetCareServiceLazyQueryHookResult = ReturnType<typeof useGetCareServiceLazyQuery>;
export type GetCareServiceQueryResult = Apollo.QueryResult<GetCareServiceQuery, GetCareServiceQueryVariables>;
export const UpdateReportReasonAsAdminDocument = gql`
    mutation UpdateReportReasonAsAdmin($reportReasonInput: UpdateReportReasonAsAdminDto!) {
  updateReportReasonAsAdmin(reportReasonInput: $reportReasonInput) {
    active
    id
    reason
    type
  }
}
    `;
export type UpdateReportReasonAsAdminMutationFn = Apollo.MutationFunction<UpdateReportReasonAsAdminMutation, UpdateReportReasonAsAdminMutationVariables>;

/**
 * __useUpdateReportReasonAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateReportReasonAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportReasonAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportReasonAsAdminMutation, { data, loading, error }] = useUpdateReportReasonAsAdminMutation({
 *   variables: {
 *      reportReasonInput: // value for 'reportReasonInput'
 *   },
 * });
 */
export function useUpdateReportReasonAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportReasonAsAdminMutation, UpdateReportReasonAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportReasonAsAdminMutation, UpdateReportReasonAsAdminMutationVariables>(UpdateReportReasonAsAdminDocument, options);
      }
export type UpdateReportReasonAsAdminMutationHookResult = ReturnType<typeof useUpdateReportReasonAsAdminMutation>;
export type UpdateReportReasonAsAdminMutationResult = Apollo.MutationResult<UpdateReportReasonAsAdminMutation>;
export type UpdateReportReasonAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateReportReasonAsAdminMutation, UpdateReportReasonAsAdminMutationVariables>;
export const CreateReportReasonAsAdminDocument = gql`
    mutation CreateReportReasonAsAdmin($reportReasonInput: CreateReportReasonAsAdminDto!) {
  createReportReasonAsAdmin(reportReasonInput: $reportReasonInput) {
    active
    id
    reason
    type
  }
}
    `;
export type CreateReportReasonAsAdminMutationFn = Apollo.MutationFunction<CreateReportReasonAsAdminMutation, CreateReportReasonAsAdminMutationVariables>;

/**
 * __useCreateReportReasonAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateReportReasonAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportReasonAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportReasonAsAdminMutation, { data, loading, error }] = useCreateReportReasonAsAdminMutation({
 *   variables: {
 *      reportReasonInput: // value for 'reportReasonInput'
 *   },
 * });
 */
export function useCreateReportReasonAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportReasonAsAdminMutation, CreateReportReasonAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportReasonAsAdminMutation, CreateReportReasonAsAdminMutationVariables>(CreateReportReasonAsAdminDocument, options);
      }
export type CreateReportReasonAsAdminMutationHookResult = ReturnType<typeof useCreateReportReasonAsAdminMutation>;
export type CreateReportReasonAsAdminMutationResult = Apollo.MutationResult<CreateReportReasonAsAdminMutation>;
export type CreateReportReasonAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateReportReasonAsAdminMutation, CreateReportReasonAsAdminMutationVariables>;
export const GetReportReasonsDocument = gql`
    query GetReportReasons($active: Boolean) {
  getReportReasons(active: $active) {
    id
    type
    reason
    active
  }
}
    `;

/**
 * __useGetReportReasonsQuery__
 *
 * To run a query within a React component, call `useGetReportReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportReasonsQuery({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useGetReportReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetReportReasonsQuery, GetReportReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportReasonsQuery, GetReportReasonsQueryVariables>(GetReportReasonsDocument, options);
      }
export function useGetReportReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportReasonsQuery, GetReportReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportReasonsQuery, GetReportReasonsQueryVariables>(GetReportReasonsDocument, options);
        }
export type GetReportReasonsQueryHookResult = ReturnType<typeof useGetReportReasonsQuery>;
export type GetReportReasonsLazyQueryHookResult = ReturnType<typeof useGetReportReasonsLazyQuery>;
export type GetReportReasonsQueryResult = Apollo.QueryResult<GetReportReasonsQuery, GetReportReasonsQueryVariables>;
export const GetReportsAsAdminDocument = gql`
    query GetReportsAsAdmin($first: Int, $after: String) {
  getReportsAsAdmin(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      id
      reason {
        id
        code
        name
      }
      createdAt
      updatedAt
      customReason
      caregiver {
        id
        phone
        gender
        name
        username
        point
        dateOfBirth
        createdAt
        updatedAt
        deletedAt
      }
      guardian {
        id
        phone
        gender
        name
        username
        dateOfBirth
        point
        createdAt
        updatedAt
        deletedAt
      }
    }
  }
}
    `;

/**
 * __useGetReportsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetReportsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsAsAdminQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetReportsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsAsAdminQuery, GetReportsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsAsAdminQuery, GetReportsAsAdminQueryVariables>(GetReportsAsAdminDocument, options);
      }
export function useGetReportsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsAsAdminQuery, GetReportsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsAsAdminQuery, GetReportsAsAdminQueryVariables>(GetReportsAsAdminDocument, options);
        }
export type GetReportsAsAdminQueryHookResult = ReturnType<typeof useGetReportsAsAdminQuery>;
export type GetReportsAsAdminLazyQueryHookResult = ReturnType<typeof useGetReportsAsAdminLazyQuery>;
export type GetReportsAsAdminQueryResult = Apollo.QueryResult<GetReportsAsAdminQuery, GetReportsAsAdminQueryVariables>;
export const GetServicesDocument = gql`
    query GetServices {
  getServices {
    id
    name
    summary
    price
    active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetServicesQuery__
 *
 * To run a query within a React component, call `useGetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
      }
export function useGetServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
        }
export type GetServicesQueryHookResult = ReturnType<typeof useGetServicesQuery>;
export type GetServicesLazyQueryHookResult = ReturnType<typeof useGetServicesLazyQuery>;
export type GetServicesQueryResult = Apollo.QueryResult<GetServicesQuery, GetServicesQueryVariables>;
export const GetServiceDocument = gql`
    query GetService($serviceId: String!) {
  getService(serviceId: $serviceId) {
    id
    name
    summary
    price
    active
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useGetServiceQuery(baseOptions: Apollo.QueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
      }
export function useGetServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<typeof useGetServiceLazyQuery>;
export type GetServiceQueryResult = Apollo.QueryResult<GetServiceQuery, GetServiceQueryVariables>;
export const UpdateServiceAsAdminDocument = gql`
    mutation UpdateServiceAsAdmin($serviceInput: UpdateServiceAsAdminDto!) {
  updateServiceAsAdmin(serviceInput: $serviceInput) {
    id
    name
    summary
    price
    active
    createdAt
    updatedAt
  }
}
    `;
export type UpdateServiceAsAdminMutationFn = Apollo.MutationFunction<UpdateServiceAsAdminMutation, UpdateServiceAsAdminMutationVariables>;

/**
 * __useUpdateServiceAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateServiceAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceAsAdminMutation, { data, loading, error }] = useUpdateServiceAsAdminMutation({
 *   variables: {
 *      serviceInput: // value for 'serviceInput'
 *   },
 * });
 */
export function useUpdateServiceAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceAsAdminMutation, UpdateServiceAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceAsAdminMutation, UpdateServiceAsAdminMutationVariables>(UpdateServiceAsAdminDocument, options);
      }
export type UpdateServiceAsAdminMutationHookResult = ReturnType<typeof useUpdateServiceAsAdminMutation>;
export type UpdateServiceAsAdminMutationResult = Apollo.MutationResult<UpdateServiceAsAdminMutation>;
export type UpdateServiceAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateServiceAsAdminMutation, UpdateServiceAsAdminMutationVariables>;
export const GetUserCountsAsAdminDocument = gql`
    query GetUserCountsAsAdmin($range: RangeInput) {
  getUserCountsAsAdmin(range: $range) {
    caregiverCount
    guardianCount
    receiverCount
    resignedUsersCount
  }
}
    `;

/**
 * __useGetUserCountsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetUserCountsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCountsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCountsAsAdminQuery({
 *   variables: {
 *      range: // value for 'range'
 *   },
 * });
 */
export function useGetUserCountsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetUserCountsAsAdminQuery, GetUserCountsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCountsAsAdminQuery, GetUserCountsAsAdminQueryVariables>(GetUserCountsAsAdminDocument, options);
      }
export function useGetUserCountsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCountsAsAdminQuery, GetUserCountsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCountsAsAdminQuery, GetUserCountsAsAdminQueryVariables>(GetUserCountsAsAdminDocument, options);
        }
export type GetUserCountsAsAdminQueryHookResult = ReturnType<typeof useGetUserCountsAsAdminQuery>;
export type GetUserCountsAsAdminLazyQueryHookResult = ReturnType<typeof useGetUserCountsAsAdminLazyQuery>;
export type GetUserCountsAsAdminQueryResult = Apollo.QueryResult<GetUserCountsAsAdminQuery, GetUserCountsAsAdminQueryVariables>;
export const GetYearlyUserTrendAsAdminDocument = gql`
    query GetYearlyUserTrendAsAdmin {
  getYearlyUserTrendAsAdmin {
    caregiverCount
    guardianCount
    receiverCount
    resignedUsersCount
  }
}
    `;

/**
 * __useGetYearlyUserTrendAsAdminQuery__
 *
 * To run a query within a React component, call `useGetYearlyUserTrendAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearlyUserTrendAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearlyUserTrendAsAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYearlyUserTrendAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetYearlyUserTrendAsAdminQuery, GetYearlyUserTrendAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYearlyUserTrendAsAdminQuery, GetYearlyUserTrendAsAdminQueryVariables>(GetYearlyUserTrendAsAdminDocument, options);
      }
export function useGetYearlyUserTrendAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYearlyUserTrendAsAdminQuery, GetYearlyUserTrendAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYearlyUserTrendAsAdminQuery, GetYearlyUserTrendAsAdminQueryVariables>(GetYearlyUserTrendAsAdminDocument, options);
        }
export type GetYearlyUserTrendAsAdminQueryHookResult = ReturnType<typeof useGetYearlyUserTrendAsAdminQuery>;
export type GetYearlyUserTrendAsAdminLazyQueryHookResult = ReturnType<typeof useGetYearlyUserTrendAsAdminLazyQuery>;
export type GetYearlyUserTrendAsAdminQueryResult = Apollo.QueryResult<GetYearlyUserTrendAsAdminQuery, GetYearlyUserTrendAsAdminQueryVariables>;
export const GetYoutubeVideosAsAdminDocument = gql`
    query GetYoutubeVideosAsAdmin($limit: Int!, $endCursor: String) {
  getYoutubeVideosAsAdmin(limit: $limit, endCursor: $endCursor) {
    pageInfo {
      startCursor
      hasNextPage
      endCursor
    }
    edges {
      commentCount
      description
      likeCount
      playTime
      thumbnail
      title
      viewCount
      youtubeUrl
      isInserted
    }
  }
}
    `;

/**
 * __useGetYoutubeVideosAsAdminQuery__
 *
 * To run a query within a React component, call `useGetYoutubeVideosAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYoutubeVideosAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYoutubeVideosAsAdminQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      endCursor: // value for 'endCursor'
 *   },
 * });
 */
export function useGetYoutubeVideosAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetYoutubeVideosAsAdminQuery, GetYoutubeVideosAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYoutubeVideosAsAdminQuery, GetYoutubeVideosAsAdminQueryVariables>(GetYoutubeVideosAsAdminDocument, options);
      }
export function useGetYoutubeVideosAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYoutubeVideosAsAdminQuery, GetYoutubeVideosAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYoutubeVideosAsAdminQuery, GetYoutubeVideosAsAdminQueryVariables>(GetYoutubeVideosAsAdminDocument, options);
        }
export type GetYoutubeVideosAsAdminQueryHookResult = ReturnType<typeof useGetYoutubeVideosAsAdminQuery>;
export type GetYoutubeVideosAsAdminLazyQueryHookResult = ReturnType<typeof useGetYoutubeVideosAsAdminLazyQuery>;
export type GetYoutubeVideosAsAdminQueryResult = Apollo.QueryResult<GetYoutubeVideosAsAdminQuery, GetYoutubeVideosAsAdminQueryVariables>;
export const CreateVideoContentAsAdminDocument = gql`
    mutation CreateVideoContentAsAdmin($title: String!, $mediaInput: MediaInput!, $playTime: String!, $youtubeUrl: String!, $statusId: String!, $videoContentCategoryId: String!, $description: String) {
  createVideoContentAsAdmin(
    title: $title
    mediaInput: $mediaInput
    playTime: $playTime
    youtubeUrl: $youtubeUrl
    statusId: $statusId
    videoContentCategoryId: $videoContentCategoryId
    description: $description
  ) {
    id
  }
}
    `;
export type CreateVideoContentAsAdminMutationFn = Apollo.MutationFunction<CreateVideoContentAsAdminMutation, CreateVideoContentAsAdminMutationVariables>;

/**
 * __useCreateVideoContentAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateVideoContentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoContentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoContentAsAdminMutation, { data, loading, error }] = useCreateVideoContentAsAdminMutation({
 *   variables: {
 *      title: // value for 'title'
 *      mediaInput: // value for 'mediaInput'
 *      playTime: // value for 'playTime'
 *      youtubeUrl: // value for 'youtubeUrl'
 *      statusId: // value for 'statusId'
 *      videoContentCategoryId: // value for 'videoContentCategoryId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateVideoContentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateVideoContentAsAdminMutation, CreateVideoContentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVideoContentAsAdminMutation, CreateVideoContentAsAdminMutationVariables>(CreateVideoContentAsAdminDocument, options);
      }
export type CreateVideoContentAsAdminMutationHookResult = ReturnType<typeof useCreateVideoContentAsAdminMutation>;
export type CreateVideoContentAsAdminMutationResult = Apollo.MutationResult<CreateVideoContentAsAdminMutation>;
export type CreateVideoContentAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateVideoContentAsAdminMutation, CreateVideoContentAsAdminMutationVariables>;
export const DeleteVideoContentAsAdminDocument = gql`
    mutation DeleteVideoContentAsAdmin($videoContentId: String!) {
  deleteVideoContentAsAdmin(videoContentId: $videoContentId) {
    id
  }
}
    `;
export type DeleteVideoContentAsAdminMutationFn = Apollo.MutationFunction<DeleteVideoContentAsAdminMutation, DeleteVideoContentAsAdminMutationVariables>;

/**
 * __useDeleteVideoContentAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteVideoContentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoContentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoContentAsAdminMutation, { data, loading, error }] = useDeleteVideoContentAsAdminMutation({
 *   variables: {
 *      videoContentId: // value for 'videoContentId'
 *   },
 * });
 */
export function useDeleteVideoContentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVideoContentAsAdminMutation, DeleteVideoContentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVideoContentAsAdminMutation, DeleteVideoContentAsAdminMutationVariables>(DeleteVideoContentAsAdminDocument, options);
      }
export type DeleteVideoContentAsAdminMutationHookResult = ReturnType<typeof useDeleteVideoContentAsAdminMutation>;
export type DeleteVideoContentAsAdminMutationResult = Apollo.MutationResult<DeleteVideoContentAsAdminMutation>;
export type DeleteVideoContentAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteVideoContentAsAdminMutation, DeleteVideoContentAsAdminMutationVariables>;
export const UpdateVideoContentAsAdminDocument = gql`
    mutation UpdateVideoContentAsAdmin($videoContentId: String!, $title: String!, $mediaInput: MediaInput, $playTime: String!, $youtubeUrl: String!, $statusId: String!, $videoContentCategoryId: String!, $description: String) {
  updateVideoContentAsAdmin(
    videoContentId: $videoContentId
    title: $title
    mediaInput: $mediaInput
    playTime: $playTime
    youtubeUrl: $youtubeUrl
    statusId: $statusId
    videoContentCategoryId: $videoContentCategoryId
    description: $description
  ) {
    id
  }
}
    `;
export type UpdateVideoContentAsAdminMutationFn = Apollo.MutationFunction<UpdateVideoContentAsAdminMutation, UpdateVideoContentAsAdminMutationVariables>;

/**
 * __useUpdateVideoContentAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateVideoContentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoContentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoContentAsAdminMutation, { data, loading, error }] = useUpdateVideoContentAsAdminMutation({
 *   variables: {
 *      videoContentId: // value for 'videoContentId'
 *      title: // value for 'title'
 *      mediaInput: // value for 'mediaInput'
 *      playTime: // value for 'playTime'
 *      youtubeUrl: // value for 'youtubeUrl'
 *      statusId: // value for 'statusId'
 *      videoContentCategoryId: // value for 'videoContentCategoryId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateVideoContentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVideoContentAsAdminMutation, UpdateVideoContentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVideoContentAsAdminMutation, UpdateVideoContentAsAdminMutationVariables>(UpdateVideoContentAsAdminDocument, options);
      }
export type UpdateVideoContentAsAdminMutationHookResult = ReturnType<typeof useUpdateVideoContentAsAdminMutation>;
export type UpdateVideoContentAsAdminMutationResult = Apollo.MutationResult<UpdateVideoContentAsAdminMutation>;
export type UpdateVideoContentAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateVideoContentAsAdminMutation, UpdateVideoContentAsAdminMutationVariables>;
export const GetVideoContentsAsAdminDocument = gql`
    query GetVideoContentsAsAdmin($page: Int, $limit: Int!, $query: String, $videoContentSearchType: VideoContentSearchType, $sortKey: VideoContentSortKey, $sortDirection: String) {
  getVideoContentsAsAdmin(
    page: $page
    limit: $limit
    query: $query
    videoContentSearchType: $videoContentSearchType
    sortKey: $sortKey
    sortDirection: $sortDirection
  ) {
    pageInfo {
      totalCount
    }
    edges {
      createdAt
      description
      id
      media {
        uri
        id
      }
      playTime
      status {
        code
        id
        commonCodeGroupId
        status
        name
      }
      title
      updatedAt
      videoContentCategory {
        id
        name
        status
        code
      }
      viewCount
      youtubeUrl
    }
  }
}
    `;

/**
 * __useGetVideoContentsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetVideoContentsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoContentsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoContentsAsAdminQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      videoContentSearchType: // value for 'videoContentSearchType'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetVideoContentsAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetVideoContentsAsAdminQuery, GetVideoContentsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVideoContentsAsAdminQuery, GetVideoContentsAsAdminQueryVariables>(GetVideoContentsAsAdminDocument, options);
      }
export function useGetVideoContentsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVideoContentsAsAdminQuery, GetVideoContentsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVideoContentsAsAdminQuery, GetVideoContentsAsAdminQueryVariables>(GetVideoContentsAsAdminDocument, options);
        }
export type GetVideoContentsAsAdminQueryHookResult = ReturnType<typeof useGetVideoContentsAsAdminQuery>;
export type GetVideoContentsAsAdminLazyQueryHookResult = ReturnType<typeof useGetVideoContentsAsAdminLazyQuery>;
export type GetVideoContentsAsAdminQueryResult = Apollo.QueryResult<GetVideoContentsAsAdminQuery, GetVideoContentsAsAdminQueryVariables>;
export const GetBokjiroWelfareContentsAsAdminDocument = gql`
    query GetBokjiroWelfareContentsAsAdmin($limit: Int!, $page: Int!, $welfareCategoryIds: [String!], $welfareLifeCycleIds: [String!], $welfareFamilyTypeIds: [String!], $welfareTypeId: String) {
  getBokjiroWelfareContentsAsAdmin(
    limit: $limit
    page: $page
    welfareCategoryIds: $welfareCategoryIds
    welfareLifeCycleIds: $welfareLifeCycleIds
    welfareFamilyTypeIds: $welfareFamilyTypeIds
    welfareTypeId: $welfareTypeId
  ) {
    pageInfo {
      totalCount
    }
    edges {
      welfareServiceId
      isInserted
      title
      description
      contactInformation
      supportType
      inquiryPhone
      detailPageUrl
      welfareTypeId
      welfareType {
        id
        name
        code
      }
      supportCycle
      applicationMethod
      welfareCategoryIds
      welfareCategories {
        id
        name
        code
      }
      welfareLifeCycleIds
      welfareLifeCycles {
        id
        name
        code
      }
      welfareFamilyTypes {
        id
        name
        code
      }
      welfareFamilyTypeIds
    }
  }
}
    `;

/**
 * __useGetBokjiroWelfareContentsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetBokjiroWelfareContentsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBokjiroWelfareContentsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBokjiroWelfareContentsAsAdminQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      welfareCategoryIds: // value for 'welfareCategoryIds'
 *      welfareLifeCycleIds: // value for 'welfareLifeCycleIds'
 *      welfareFamilyTypeIds: // value for 'welfareFamilyTypeIds'
 *      welfareTypeId: // value for 'welfareTypeId'
 *   },
 * });
 */
export function useGetBokjiroWelfareContentsAsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetBokjiroWelfareContentsAsAdminQuery, GetBokjiroWelfareContentsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBokjiroWelfareContentsAsAdminQuery, GetBokjiroWelfareContentsAsAdminQueryVariables>(GetBokjiroWelfareContentsAsAdminDocument, options);
      }
export function useGetBokjiroWelfareContentsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBokjiroWelfareContentsAsAdminQuery, GetBokjiroWelfareContentsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBokjiroWelfareContentsAsAdminQuery, GetBokjiroWelfareContentsAsAdminQueryVariables>(GetBokjiroWelfareContentsAsAdminDocument, options);
        }
export type GetBokjiroWelfareContentsAsAdminQueryHookResult = ReturnType<typeof useGetBokjiroWelfareContentsAsAdminQuery>;
export type GetBokjiroWelfareContentsAsAdminLazyQueryHookResult = ReturnType<typeof useGetBokjiroWelfareContentsAsAdminLazyQuery>;
export type GetBokjiroWelfareContentsAsAdminQueryResult = Apollo.QueryResult<GetBokjiroWelfareContentsAsAdminQuery, GetBokjiroWelfareContentsAsAdminQueryVariables>;
export const CreateWelfareContentAsAdminDocument = gql`
    mutation CreateWelfareContentAsAdmin($title: String!, $description: String!, $detailPageUrl: String!, $statusId: String!, $welfareTypeId: String!, $welfareServiceId: String!, $inquiryPhone: String, $contactInformation: String, $welfareCategoryIds: [String!], $welfareLifeCycleIds: [String!], $welfareFamilyTypeIds: [String!]) {
  createWelfareContentAsAdmin(
    title: $title
    welfareServiceId: $welfareServiceId
    description: $description
    detailPageUrl: $detailPageUrl
    statusId: $statusId
    welfareTypeId: $welfareTypeId
    inquiryPhone: $inquiryPhone
    contactInformation: $contactInformation
    welfareCategoryIds: $welfareCategoryIds
    welfareLifeCycleIds: $welfareLifeCycleIds
    welfareFamilyTypeIds: $welfareFamilyTypeIds
  )
}
    `;
export type CreateWelfareContentAsAdminMutationFn = Apollo.MutationFunction<CreateWelfareContentAsAdminMutation, CreateWelfareContentAsAdminMutationVariables>;

/**
 * __useCreateWelfareContentAsAdminMutation__
 *
 * To run a mutation, you first call `useCreateWelfareContentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWelfareContentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWelfareContentAsAdminMutation, { data, loading, error }] = useCreateWelfareContentAsAdminMutation({
 *   variables: {
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      detailPageUrl: // value for 'detailPageUrl'
 *      statusId: // value for 'statusId'
 *      welfareTypeId: // value for 'welfareTypeId'
 *      welfareServiceId: // value for 'welfareServiceId'
 *      inquiryPhone: // value for 'inquiryPhone'
 *      contactInformation: // value for 'contactInformation'
 *      welfareCategoryIds: // value for 'welfareCategoryIds'
 *      welfareLifeCycleIds: // value for 'welfareLifeCycleIds'
 *      welfareFamilyTypeIds: // value for 'welfareFamilyTypeIds'
 *   },
 * });
 */
export function useCreateWelfareContentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateWelfareContentAsAdminMutation, CreateWelfareContentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWelfareContentAsAdminMutation, CreateWelfareContentAsAdminMutationVariables>(CreateWelfareContentAsAdminDocument, options);
      }
export type CreateWelfareContentAsAdminMutationHookResult = ReturnType<typeof useCreateWelfareContentAsAdminMutation>;
export type CreateWelfareContentAsAdminMutationResult = Apollo.MutationResult<CreateWelfareContentAsAdminMutation>;
export type CreateWelfareContentAsAdminMutationOptions = Apollo.BaseMutationOptions<CreateWelfareContentAsAdminMutation, CreateWelfareContentAsAdminMutationVariables>;
export const UpdateWelfareContentAsAdminDocument = gql`
    mutation UpdateWelfareContentAsAdmin($statusId: String!, $welfareContentId: String!) {
  updateWelfareContentAsAdmin(
    statusId: $statusId
    welfareContentId: $welfareContentId
  ) {
    id
  }
}
    `;
export type UpdateWelfareContentAsAdminMutationFn = Apollo.MutationFunction<UpdateWelfareContentAsAdminMutation, UpdateWelfareContentAsAdminMutationVariables>;

/**
 * __useUpdateWelfareContentAsAdminMutation__
 *
 * To run a mutation, you first call `useUpdateWelfareContentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWelfareContentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWelfareContentAsAdminMutation, { data, loading, error }] = useUpdateWelfareContentAsAdminMutation({
 *   variables: {
 *      statusId: // value for 'statusId'
 *      welfareContentId: // value for 'welfareContentId'
 *   },
 * });
 */
export function useUpdateWelfareContentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWelfareContentAsAdminMutation, UpdateWelfareContentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWelfareContentAsAdminMutation, UpdateWelfareContentAsAdminMutationVariables>(UpdateWelfareContentAsAdminDocument, options);
      }
export type UpdateWelfareContentAsAdminMutationHookResult = ReturnType<typeof useUpdateWelfareContentAsAdminMutation>;
export type UpdateWelfareContentAsAdminMutationResult = Apollo.MutationResult<UpdateWelfareContentAsAdminMutation>;
export type UpdateWelfareContentAsAdminMutationOptions = Apollo.BaseMutationOptions<UpdateWelfareContentAsAdminMutation, UpdateWelfareContentAsAdminMutationVariables>;
export const GetWelfareContentStatusDocument = gql`
    query GetWelfareContentStatus($welfareContentId: String!) {
  getWelfareContentAsAdmin(welfareContentId: $welfareContentId) {
    statusId
  }
}
    `;

/**
 * __useGetWelfareContentStatusQuery__
 *
 * To run a query within a React component, call `useGetWelfareContentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelfareContentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelfareContentStatusQuery({
 *   variables: {
 *      welfareContentId: // value for 'welfareContentId'
 *   },
 * });
 */
export function useGetWelfareContentStatusQuery(baseOptions: Apollo.QueryHookOptions<GetWelfareContentStatusQuery, GetWelfareContentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWelfareContentStatusQuery, GetWelfareContentStatusQueryVariables>(GetWelfareContentStatusDocument, options);
      }
export function useGetWelfareContentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWelfareContentStatusQuery, GetWelfareContentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWelfareContentStatusQuery, GetWelfareContentStatusQueryVariables>(GetWelfareContentStatusDocument, options);
        }
export type GetWelfareContentStatusQueryHookResult = ReturnType<typeof useGetWelfareContentStatusQuery>;
export type GetWelfareContentStatusLazyQueryHookResult = ReturnType<typeof useGetWelfareContentStatusLazyQuery>;
export type GetWelfareContentStatusQueryResult = Apollo.QueryResult<GetWelfareContentStatusQuery, GetWelfareContentStatusQueryVariables>;
export const GetWelfareContentsAsAdminDocument = gql`
    query GetWelfareContentsAsAdmin($query: String, $searchType: WelfareContentSearchType, $limit: Int, $page: Int, $sortKey: WelfareContentSortKey, $sortDirection: String, $welfareCategoryIds: [String!]) {
  getWelfareContentsAsAdmin(
    query: $query
    searchType: $searchType
    limit: $limit
    page: $page
    sortKey: $sortKey
    sortDirection: $sortDirection
    welfareCategoryIds: $welfareCategoryIds
  ) {
    pageInfo {
      totalCount
    }
    edges {
      title
      id
      description
      createdAt
      contactInformation
      applicationMethod
      inquiryPhone
      detailPageUrl
      updatedAt
      supportType
      supportCycle
      status {
        name
        status
        id
        code
      }
      welfareCategories {
        id
        name
        code
      }
      welfareFamilyTypes {
        id
        name
        code
      }
      welfareLifeCycles {
        code
        name
        id
      }
      welfareType {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetWelfareContentsAsAdminQuery__
 *
 * To run a query within a React component, call `useGetWelfareContentsAsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelfareContentsAsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelfareContentsAsAdminQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchType: // value for 'searchType'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortKey: // value for 'sortKey'
 *      sortDirection: // value for 'sortDirection'
 *      welfareCategoryIds: // value for 'welfareCategoryIds'
 *   },
 * });
 */
export function useGetWelfareContentsAsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetWelfareContentsAsAdminQuery, GetWelfareContentsAsAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWelfareContentsAsAdminQuery, GetWelfareContentsAsAdminQueryVariables>(GetWelfareContentsAsAdminDocument, options);
      }
export function useGetWelfareContentsAsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWelfareContentsAsAdminQuery, GetWelfareContentsAsAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWelfareContentsAsAdminQuery, GetWelfareContentsAsAdminQueryVariables>(GetWelfareContentsAsAdminDocument, options);
        }
export type GetWelfareContentsAsAdminQueryHookResult = ReturnType<typeof useGetWelfareContentsAsAdminQuery>;
export type GetWelfareContentsAsAdminLazyQueryHookResult = ReturnType<typeof useGetWelfareContentsAsAdminLazyQuery>;
export type GetWelfareContentsAsAdminQueryResult = Apollo.QueryResult<GetWelfareContentsAsAdminQuery, GetWelfareContentsAsAdminQueryVariables>;
export const DeleteWelfareContentAsAdminDocument = gql`
    mutation DeleteWelfareContentAsAdmin($welfareContentId: String!) {
  deleteWelfareContentAsAdmin(welfareContentId: $welfareContentId)
}
    `;
export type DeleteWelfareContentAsAdminMutationFn = Apollo.MutationFunction<DeleteWelfareContentAsAdminMutation, DeleteWelfareContentAsAdminMutationVariables>;

/**
 * __useDeleteWelfareContentAsAdminMutation__
 *
 * To run a mutation, you first call `useDeleteWelfareContentAsAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWelfareContentAsAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWelfareContentAsAdminMutation, { data, loading, error }] = useDeleteWelfareContentAsAdminMutation({
 *   variables: {
 *      welfareContentId: // value for 'welfareContentId'
 *   },
 * });
 */
export function useDeleteWelfareContentAsAdminMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWelfareContentAsAdminMutation, DeleteWelfareContentAsAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWelfareContentAsAdminMutation, DeleteWelfareContentAsAdminMutationVariables>(DeleteWelfareContentAsAdminDocument, options);
      }
export type DeleteWelfareContentAsAdminMutationHookResult = ReturnType<typeof useDeleteWelfareContentAsAdminMutation>;
export type DeleteWelfareContentAsAdminMutationResult = Apollo.MutationResult<DeleteWelfareContentAsAdminMutation>;
export type DeleteWelfareContentAsAdminMutationOptions = Apollo.BaseMutationOptions<DeleteWelfareContentAsAdminMutation, DeleteWelfareContentAsAdminMutationVariables>;